webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends2 = __webpack_require__(366);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(537);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _router = __webpack_require__(347);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _vueResource = __webpack_require__(563);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	var _generated = __webpack_require__(115);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _vueSelect = __webpack_require__(565);
	
	var _vueSelect2 = _interopRequireDefault(_vueSelect);
	
	var _vueMaterial = __webpack_require__(562);
	
	var _vueMaterial2 = _interopRequireDefault(_vueMaterial);
	
	var _config = __webpack_require__(45);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _vueLocalstorage = __webpack_require__(561);
	
	var _vueLocalstorage2 = _interopRequireDefault(_vueLocalstorage);
	
	var _vueSmoothPicker = __webpack_require__(566);
	
	var _vueSmoothPicker2 = _interopRequireDefault(_vueSmoothPicker);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	__webpack_require__(432);
	__webpack_require__(434);
	__webpack_require__(433);
	
	__webpack_require__(435);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.use(_vueMaterial2.default);
	_vue2.default.use(_vueLocalstorage2.default);
	_vue2.default.use(_vueSmoothPicker2.default);
	_vue2.default.component('v-select', _vueSelect2.default);
	
	_generated2.default.ApiClient.instance = new _generated2.default.DefaultApi();
	
	
	_vue2.default.material.registerTheme('default', {
		primary: 'deep-purple',
		accent: 'blue',
		warn: 'red'
	});
	
	firebase.initializeApp(_config2.default.firebaseConfig[_vue2.default.localStorage.get('project', _config2.default.default)]);
	
	_router2.default.beforeEach(function (to, from, next) {
		firebase.auth().onAuthStateChanged(function (user) {
			if (user || to.name === "login" || !to.path.startsWith("/admin")) {
				next();
			} else {
				next('/');
			}
		});
	});
	
	var app = new _vue2.default((0, _extends3.default)({
		router: _router2.default
	}, _App2.default)).$mount('#app');

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer, module) {'use strict';
	
	var _keys = __webpack_require__(363);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['superagent'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(310));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.ApiClient = factory(root.superagent);
	  }
	})(undefined, function (superagent) {
	  'use strict';
	
	  var exports = function exports() {
	    this.basePath = 'http://localhost'.replace(/\/+$/, '');
	
	    this.authentications = {};
	
	    this.defaultHeaders = {};
	
	    this.timeout = 60000;
	
	    this.cache = true;
	  };
	
	  exports.prototype.paramToString = function (param) {
	    if (param == undefined || param == null) {
	      return '';
	    }
	    if (param instanceof Date) {
	      return param.toJSON();
	    }
	    return param.toString();
	  };
	
	  exports.prototype.buildUrl = function (path, pathParams) {
	    if (!path.match(/^\//)) {
	      path = '/' + path;
	    }
	    var url = this.basePath + path;
	    var _this = this;
	    url = url.replace(/\{([\w-]+)\}/g, function (fullMatch, key) {
	      var value;
	      if (pathParams.hasOwnProperty(key)) {
	        value = _this.paramToString(pathParams[key]);
	      } else {
	        value = fullMatch;
	      }
	      return encodeURIComponent(value);
	    });
	    return url;
	  };
	
	  exports.prototype.isJsonMime = function (contentType) {
	    return Boolean(contentType != null && contentType.match(/^application\/json(;.*)?$/i));
	  };
	
	  exports.prototype.jsonPreferredMime = function (contentTypes) {
	    for (var i = 0; i < contentTypes.length; i++) {
	      if (this.isJsonMime(contentTypes[i])) {
	        return contentTypes[i];
	      }
	    }
	    return contentTypes[0];
	  };
	
	  exports.prototype.isFileParam = function (param) {
	    if (typeof window === 'undefined' && "function" === 'function' && __webpack_require__(28) && param instanceof __webpack_require__(28).ReadStream) {
	      return true;
	    }
	
	    if (typeof Buffer === 'function' && param instanceof Buffer) {
	      return true;
	    }
	
	    if (typeof Blob === 'function' && param instanceof Blob) {
	      return true;
	    }
	
	    if (typeof File === 'function' && param instanceof File) {
	      return true;
	    }
	    return false;
	  };
	
	  exports.prototype.normalizeParams = function (params) {
	    var newParams = {};
	    for (var key in params) {
	      if (params.hasOwnProperty(key) && params[key] != undefined && params[key] != null) {
	        var value = params[key];
	        if (this.isFileParam(value) || Array.isArray(value)) {
	          newParams[key] = value;
	        } else {
	          newParams[key] = this.paramToString(value);
	        }
	      }
	    }
	    return newParams;
	  };
	
	  exports.CollectionFormatEnum = {
	    CSV: ',',
	
	    SSV: ' ',
	
	    TSV: '\t',
	
	    PIPES: '|',
	
	    MULTI: 'multi'
	  };
	
	  exports.prototype.buildCollectionParam = function buildCollectionParam(param, collectionFormat) {
	    if (param == null) {
	      return null;
	    }
	    switch (collectionFormat) {
	      case 'csv':
	        return param.map(this.paramToString).join(',');
	      case 'ssv':
	        return param.map(this.paramToString).join(' ');
	      case 'tsv':
	        return param.map(this.paramToString).join('\t');
	      case 'pipes':
	        return param.map(this.paramToString).join('|');
	      case 'multi':
	        return param.map(this.paramToString);
	      default:
	        throw new Error('Unknown collection format: ' + collectionFormat);
	    }
	  };
	
	  exports.prototype.applyAuthToRequest = function (request, authNames) {
	    var _this = this;
	    authNames.forEach(function (authName) {
	      var auth = _this.authentications[authName];
	      switch (auth.type) {
	        case 'basic':
	          if (auth.username || auth.password) {
	            request.auth(auth.username || '', auth.password || '');
	          }
	          break;
	        case 'apiKey':
	          if (auth.apiKey) {
	            var data = {};
	            if (auth.apiKeyPrefix) {
	              data[auth.name] = auth.apiKeyPrefix + ' ' + auth.apiKey;
	            } else {
	              data[auth.name] = auth.apiKey;
	            }
	            if (auth['in'] === 'header') {
	              request.set(data);
	            } else {
	              request.query(data);
	            }
	          }
	          break;
	        case 'oauth2':
	          if (auth.accessToken) {
	            request.set({ 'Authorization': 'Bearer ' + auth.accessToken });
	          }
	          break;
	        default:
	          throw new Error('Unknown authentication type: ' + auth.type);
	      }
	    });
	  };
	
	  exports.prototype.deserialize = function deserialize(response, returnType) {
	    if (response == null || returnType == null) {
	      return null;
	    }
	
	    var data = response.body;
	    if (data == null || !(0, _keys2.default)(data).length) {
	      data = response.text;
	    }
	    return exports.convertToType(data, returnType);
	  };
	
	  exports.prototype.callApi = function callApi(path, httpMethod, pathParams, queryParams, headerParams, formParams, bodyParam, authNames, contentTypes, accepts, returnType, callback) {
	
	    var _this = this;
	    var url = this.buildUrl(path, pathParams);
	    var request = superagent(httpMethod, url);
	
	    this.applyAuthToRequest(request, authNames);
	
	    if (httpMethod.toUpperCase() === 'GET' && this.cache === false) {
	      queryParams['_'] = new Date().getTime();
	    }
	    request.query(this.normalizeParams(queryParams));
	
	    request.set(this.defaultHeaders).set(this.normalizeParams(headerParams));
	
	    request.timeout(this.timeout);
	
	    var contentType = this.jsonPreferredMime(contentTypes);
	    if (contentType) {
	      if (contentType != 'multipart/form-data') {
	        request.type(contentType);
	      }
	    } else if (!request.header['Content-Type']) {
	      request.type('application/json');
	    }
	
	    if (contentType === 'application/x-www-form-urlencoded') {
	      request.send(this.normalizeParams(formParams));
	    } else if (contentType == 'multipart/form-data') {
	      var _formParams = this.normalizeParams(formParams);
	      for (var key in _formParams) {
	        if (_formParams.hasOwnProperty(key)) {
	          if (this.isFileParam(_formParams[key])) {
	            request.attach(key, _formParams[key]);
	          } else {
	            request.field(key, _formParams[key]);
	          }
	        }
	      }
	    } else if (bodyParam) {
	      request.send(bodyParam);
	    }
	
	    var accept = this.jsonPreferredMime(accepts);
	    if (accept) {
	      request.accept(accept);
	    }
	
	    request.end(function (error, response) {
	      if (callback) {
	        var data = null;
	        if (!error) {
	          data = _this.deserialize(response, returnType);
	        }
	        callback(error, data, response);
	      }
	    });
	
	    return request;
	  };
	
	  exports.parseDate = function (str) {
	    return new Date(str.replace(/T/i, ' '));
	  };
	
	  exports.convertToType = function (data, type) {
	    switch (type) {
	      case 'Boolean':
	        return Boolean(data);
	      case 'Integer':
	        return parseInt(data, 10);
	      case 'Number':
	        return parseFloat(data);
	      case 'String':
	        return String(data);
	      case 'Date':
	        return this.parseDate(String(data));
	      default:
	        if (type === Object) {
	          return data;
	        } else if (typeof type === 'function') {
	          return type.constructFromObject(data);
	        } else if (Array.isArray(type)) {
	          var itemType = type[0];
	          return data.map(function (item) {
	            return exports.convertToType(item, itemType);
	          });
	        } else if ((typeof type === 'undefined' ? 'undefined' : (0, _typeof3.default)(type)) === 'object') {
	          var keyType, valueType;
	          for (var k in type) {
	            if (type.hasOwnProperty(k)) {
	              keyType = k;
	              valueType = type[k];
	              break;
	            }
	          }
	          var result = {};
	          for (var k in data) {
	            if (data.hasOwnProperty(k)) {
	              var key = exports.convertToType(k, keyType);
	              var value = exports.convertToType(data[k], valueType);
	              result[key] = value;
	            }
	          }
	          return result;
	        } else {
	          return data;
	        }
	    }
	  };
	
	  exports.constructFromObject = function (data, obj, itemType) {
	    if (Array.isArray(data)) {
	      for (var i = 0; i < data.length; i++) {
	        if (data.hasOwnProperty(i)) obj[i] = exports.convertToType(data[i], itemType);
	      }
	    } else {
	      for (var k in data) {
	        if (data.hasOwnProperty(k)) obj[k] = exports.convertToType(data[k], itemType);
	      }
	    }
	  };
	
	  exports.instance = new exports();
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(2).Buffer, __webpack_require__(5)(module)))

/***/ }),

/***/ 24:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	function commonSave(path, object) {
		console.log("saving");
		console.log((0, _stringify2.default)(object));
	
		for (var key in object) {
			if (object[key] === "") {
				delete object[key];
			}
		}
		var userId = firebase.auth().currentUser.uid;
		if (object.fireId) {
			firebase.database().ref(path + "/" + object.fireId).update(object);
		} else {
			firebase.database().ref(path).push(object);
		}
	}
	
	function commonDelete(path, object) {
		var userId = firebase.auth().currentUser.uid;
		firebase.database().ref(path + "/" + object.fireId).remove();
	}
	
	function commonGet(path, callback) {
		var userId = firebase.auth().currentUser.uid;
		firebase.database().ref(path).once("value").then(function (snapshot) {
			var objects = [];
			for (var key in snapshot.val()) {
				var object = snapshot.val()[key];
				object["fireId"] = key;
				objects.push(object);
			}
			callback(null, objects);
		}).catch(function (e) {
			console.log(e);
		});
	}
	
	function rawGet(path, callback) {
		var userId = firebase.auth().currentUser.uid;
		firebase.database().ref(path).once("value").then(function (snapshot) {
			callback(null, snapshot.val());
		}).catch(function (e) {
			console.log(e);
		});
	}
	
	function commonGetById(path, id, callback) {
		var userId = firebase.auth().currentUser.uid;
		firebase.database().ref(path + "/" + id).once("value").then(function (snapshot) {
			var object = snapshot.val();
			object["fireId"] = id;
			callback(null, object);
		});
	}
	
	exports.default = {
		rawGet: rawGet,
	
		savePresentation: function savePresentation(presentation) {
			commonSave("presentations", presentation);
		},
		deletePresentation: function deletePresentation(presentation) {
			commonDelete("presentations", presentation);
		},
		getPresentations: function getPresentations(callback) {
			commonGet("presentations", callback);
		},
		getPresentationById: function getPresentationById(id, callback) {
			commonGetById("presentations", id, callback);
		},
		saveLecturer: function saveLecturer(lecturer) {
			commonSave("lecturers", lecturer);
		},
		deleteLecturer: function deleteLecturer(lecturer) {
			commonDelete("lecturers", lecturer);
		},
		getLecturers: function getLecturers(callback) {
			commonGet("lecturers", callback);
		},
		getLecturerById: function getLecturerById(id, callback) {
			commonGetById("lecturers", id, callback);
		},
		saveNotification: function saveNotification(notification) {
			commonSave("notifications", notification);
		},
		deleteNotification: function deleteNotification(notification) {
			commonDelete("notifications", notification);
		},
		getNotifications: function getNotifications(callback) {
			commonGet("notifications", callback);
		},
		saveLocation: function saveLocation(location) {
			commonSave("locations", location);
		},
		deleteLocation: function deleteLocation(location) {
			commonDelete("locations", location);
		},
		getLocations: function getLocations(callback) {
			commonGet("locations", callback);
		},
		getRatings: function getRatings(callback) {
			commonGet("ratings", callback);
		},
		getComments: function getComments(callback) {
			commonGet("comments", callback);
		},
		saveInformation: function saveInformation(information) {
			commonSave("information", information);
		},
		getInformation: function getInformation(callback) {
			commonGet("information", callback);
		},
		getConstants: function getConstants(callback) {
			firebase.database().ref("constants").once("value").then(function (snapshot) {
				callback(null, snapshot.val());
			});
		}
	};

/***/ }),

/***/ 45:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var define = false;
	
	exports.default = {
		apiAddress: 'http://conf.pulmoment.com',
	
		firebaseConfig: {
			elektro: {
				appName: "Elektrotechnikai Vándorgyűlés",
				apiKey: "AIzaSyCB5uu-jFH_9bXKHNmpdiUNXWKT8RwsaHk",
				authDomain: "elektrovandor.firebaseapp.com",
				databaseURL: "https://elektrovandor.firebaseio.com",
				projectId: "elektrovandor",
				storageBucket: "elektrovandor.appspot.com",
				messagingSenderId: "546064351670"
			},
			uton: {
				appName: "ÚtOn",
				apiKey: "AIzaSyBDJ9C4VMxalRbUvLvY9MmL_ULQcnaKLA0",
				authDomain: "uton-f87e3.firebaseapp.com",
				databaseURL: "https://uton-f87e3.firebaseio.com",
				projectId: "uton-f87e3",
				storageBucket: "uton-f87e3.appspot.com",
				messagingSenderId: "450105260799"
			},
			safari: {
				appName: "Startup Safary",
				apiKey: "AIzaSyAA0jJvwucEXr0qOjPaVisyMBuRhrs_CpU",
				authDomain: "startupsafary2017.firebaseapp.com",
				databaseURL: "https://startupsafary2017.firebaseio.com",
				storageBucket: "startupsafary2017.appspot.com"
			},
			diakszinhaz: {
				appName: "Diákszínház",
				apiKey: "AIzaSyDToXSFyMMVvw_Bt_H9FHH2f-vJF8Qc58k",
				authDomain: "diakszinhaz-a5a99.firebaseapp.com",
				databaseURL: "https://diakszinhaz-a5a99.firebaseio.com",
				projectId: "diakszinhaz-a5a99",
				storageBucket: "diakszinhaz-a5a99.appspot.com",
				messagingSenderId: "967998939605"
			}
		},
		default: "diakszinhaz",
		ckeditor: {
			toolbar: [{ name: "document", items: ["Undo", "Redo"] }, {
				name: "basicstyles",
				items: ["Bold", "Italic", "Underline", "Strike", "-", "RemoveFormat", "Source"]
			}, { name: "links", items: ["Link", "Unlink"] }, { name: "insert", items: ["Image", "Format", "Color"] }],
			clipboard_defaultContentType: "text",
			height: 300,
			language: "hu",
			removeButtons: "Underline,Subscript,Superscript",
			format_tags: "p;h1;h2;h3;pre",
			removeDialogTabs: "image:advanced;link:advanced"
		}
	};

/***/ }),

/***/ 60:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Attachment = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Attachment', 'model/Presentation'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(60), __webpack_require__(78));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Lecturer = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Attachment, root.ConferenceBackend.Presentation);
	  }
	})(undefined, function (ApiClient, Attachment, Presentation) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('image')) {
	        obj['image'] = ApiClient.convertToType(data['image'], 'String');
	      }
	      if (data.hasOwnProperty('origin')) {
	        obj['origin'] = ApiClient.convertToType(data['origin'], 'String');
	      }
	      if (data.hasOwnProperty('introduction')) {
	        obj['introduction'] = ApiClient.convertToType(data['introduction'], 'String');
	      }
	      if (data.hasOwnProperty('attachments')) {
	        obj['attachments'] = ApiClient.convertToType(data['attachments'], [Attachment]);
	      }
	      if (data.hasOwnProperty('presentations')) {
	        obj['presentations'] = ApiClient.convertToType(data['presentations'], [Presentation]);
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['image'] = undefined;
	
	  exports.prototype['origin'] = undefined;
	
	  exports.prototype['introduction'] = undefined;
	
	  exports.prototype['attachments'] = undefined;
	
	  exports.prototype['presentations'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 78:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Attachment', 'model/Lecturer', 'model/Question'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(60), __webpack_require__(77), __webpack_require__(79));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Presentation = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Attachment, root.ConferenceBackend.Lecturer, root.ConferenceBackend.Question);
	  }
	})(undefined, function (ApiClient, Attachment, Lecturer, Question) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('image')) {
	        obj['image'] = ApiClient.convertToType(data['image'], 'String');
	      }
	      if (data.hasOwnProperty('origin')) {
	        obj['origin'] = ApiClient.convertToType(data['origin'], 'String');
	      }
	      if (data.hasOwnProperty('introduction')) {
	        obj['introduction'] = ApiClient.convertToType(data['introduction'], 'String');
	      }
	      if (data.hasOwnProperty('fromDate')) {
	        obj['fromDate'] = ApiClient.convertToType(data['fromDate'], 'Date');
	      }
	      if (data.hasOwnProperty('toDate')) {
	        obj['toDate'] = ApiClient.convertToType(data['toDate'], 'Date');
	      }
	      if (data.hasOwnProperty('attachments')) {
	        obj['attachments'] = ApiClient.convertToType(data['attachments'], [Attachment]);
	      }
	      if (data.hasOwnProperty('lecturers')) {
	        obj['lecturers'] = ApiClient.convertToType(data['lecturers'], [Lecturer]);
	      }
	      if (data.hasOwnProperty('questions')) {
	        obj['questions'] = ApiClient.convertToType(data['questions'], [Question]);
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['image'] = undefined;
	
	  exports.prototype['origin'] = undefined;
	
	  exports.prototype['introduction'] = undefined;
	
	  exports.prototype['fromDate'] = undefined;
	
	  exports.prototype['toDate'] = undefined;
	
	  exports.prototype['attachments'] = undefined;
	
	  exports.prototype['lecturers'] = undefined;
	
	  exports.prototype['questions'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 79:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/QuestionOptions'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(124));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Question = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.QuestionOptions);
	  }
	})(undefined, function (ApiClient, QuestionOptions) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('body')) {
	        obj['body'] = ApiClient.convertToType(data['body'], 'String');
	      }
	      if (data.hasOwnProperty('type')) {
	        obj['type'] = ApiClient.convertToType(data['type'], 'String');
	      }
	      if (data.hasOwnProperty('published')) {
	        obj['published'] = ApiClient.convertToType(data['published'], 'Boolean');
	      }
	      if (data.hasOwnProperty('targetDate')) {
	        obj['targetDate'] = ApiClient.convertToType(data['targetDate'], 'Date');
	      }
	      if (data.hasOwnProperty('duration')) {
	        obj['duration'] = ApiClient.convertToType(data['duration'], 'Number');
	      }
	      if (data.hasOwnProperty('options')) {
	        obj['options'] = ApiClient.convertToType(data['options'], [QuestionOptions]);
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['body'] = undefined;
	
	  exports.prototype['type'] = undefined;
	
	  exports.prototype['published'] = undefined;
	
	  exports.prototype['targetDate'] = undefined;
	
	  exports.prototype['duration'] = undefined;
	
	  exports.prototype['options'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 115:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Attachment', 'model/Conference', 'model/DataResponse', 'model/ErrorResponse', 'model/Lecturer', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Presentation', 'model/PresentationsurveyquestionOptions', 'model/Question', 'model/QuestionOptions', 'model/Sponsor', 'model/SuccessResponse', 'api/DefaultApi'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(60), __webpack_require__(116), __webpack_require__(117), __webpack_require__(118), __webpack_require__(77), __webpack_require__(119), __webpack_require__(120), __webpack_require__(121), __webpack_require__(122), __webpack_require__(78), __webpack_require__(123), __webpack_require__(79), __webpack_require__(124), __webpack_require__(125), __webpack_require__(126), __webpack_require__(346));
	  }
	})(function (ApiClient, Attachment, Conference, DataResponse, ErrorResponse, Lecturer, Params, Params1, Params2, Params3, Presentation, PresentationsurveyquestionOptions, Question, QuestionOptions, Sponsor, SuccessResponse, DefaultApi) {
	  'use strict';
	
	  var exports = {
	    ApiClient: ApiClient,
	
	    Attachment: Attachment,
	
	    Conference: Conference,
	
	    DataResponse: DataResponse,
	
	    ErrorResponse: ErrorResponse,
	
	    Lecturer: Lecturer,
	
	    Params: Params,
	
	    Params1: Params1,
	
	    Params2: Params2,
	
	    Params3: Params3,
	
	    Presentation: Presentation,
	
	    PresentationsurveyquestionOptions: PresentationsurveyquestionOptions,
	
	    Question: Question,
	
	    QuestionOptions: QuestionOptions,
	
	    Sponsor: Sponsor,
	
	    SuccessResponse: SuccessResponse,
	
	    DefaultApi: DefaultApi
	  };
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 116:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Attachment'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(60));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Conference = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Attachment);
	  }
	})(undefined, function (ApiClient, Attachment) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('location')) {
	        obj['location'] = ApiClient.convertToType(data['location'], 'String');
	      }
	      if (data.hasOwnProperty('description')) {
	        obj['description'] = ApiClient.convertToType(data['description'], 'String');
	      }
	      if (data.hasOwnProperty('fromDate')) {
	        obj['fromDate'] = ApiClient.convertToType(data['fromDate'], 'Date');
	      }
	      if (data.hasOwnProperty('toDate')) {
	        obj['toDate'] = ApiClient.convertToType(data['toDate'], 'Date');
	      }
	      if (data.hasOwnProperty('attachments')) {
	        obj['attachments'] = ApiClient.convertToType(data['attachments'], [Attachment]);
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['location'] = undefined;
	
	  exports.prototype['description'] = undefined;
	
	  exports.prototype['fromDate'] = undefined;
	
	  exports.prototype['toDate'] = undefined;
	
	  exports.prototype['attachments'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 117:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.DataResponse = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('data')) {
	        obj['data'] = ApiClient.convertToType(data['data'], Object);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['data'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 118:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.ErrorResponse = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(message) {
	    var _this = this;
	
	    _this['message'] = message;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('message')) {
	        obj['message'] = ApiClient.convertToType(data['message'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['message'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 119:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Params = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(deviceId, presentationId, rating) {
	    var _this = this;
	
	    _this['deviceId'] = deviceId;
	    _this['presentationId'] = presentationId;
	    _this['rating'] = rating;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('deviceId')) {
	        obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
	      }
	      if (data.hasOwnProperty('presentationId')) {
	        obj['presentationId'] = ApiClient.convertToType(data['presentationId'], 'String');
	      }
	      if (data.hasOwnProperty('rating')) {
	        obj['rating'] = ApiClient.convertToType(data['rating'], 'Number');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['deviceId'] = undefined;
	
	  exports.prototype['presentationId'] = undefined;
	
	  exports.prototype['rating'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 120:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Params1 = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(deviceId, questionId, optionId) {
	    var _this = this;
	
	    _this['deviceId'] = deviceId;
	    _this['questionId'] = questionId;
	    _this['optionId'] = optionId;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('deviceId')) {
	        obj['deviceId'] = ApiClient.convertToType(data['deviceId'], 'String');
	      }
	      if (data.hasOwnProperty('questionId')) {
	        obj['questionId'] = ApiClient.convertToType(data['questionId'], 'String');
	      }
	      if (data.hasOwnProperty('optionId')) {
	        obj['optionId'] = ApiClient.convertToType(data['optionId'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['deviceId'] = undefined;
	
	  exports.prototype['questionId'] = undefined;
	
	  exports.prototype['optionId'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 121:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Params2 = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 122:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/PresentationsurveyquestionOptions'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(123));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Params3 = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.PresentationsurveyquestionOptions);
	  }
	})(undefined, function (ApiClient, PresentationsurveyquestionOptions) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('presentationId')) {
	        obj['presentationId'] = ApiClient.convertToType(data['presentationId'], 'String');
	      }
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('options')) {
	        obj['options'] = ApiClient.convertToType(data['options'], [PresentationsurveyquestionOptions]);
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['presentationId'] = undefined;
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['options'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 123:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.PresentationsurveyquestionOptions = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['title'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 124:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.QuestionOptions = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('title')) {
	        obj['title'] = ApiClient.convertToType(data['title'], 'String');
	      }
	      if (data.hasOwnProperty('value')) {
	        obj['value'] = ApiClient.convertToType(data['value'], 'String');
	      }
	      if (data.hasOwnProperty('answerCount')) {
	        obj['answerCount'] = ApiClient.convertToType(data['answerCount'], 'Number');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['title'] = undefined;
	
	  exports.prototype['value'] = undefined;
	
	  exports.prototype['answerCount'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 125:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.Sponsor = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports() {
	    var _this = this;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('_id')) {
	        obj['_id'] = ApiClient.convertToType(data['_id'], 'String');
	      }
	      if (data.hasOwnProperty('name')) {
	        obj['name'] = ApiClient.convertToType(data['name'], 'String');
	      }
	      if (data.hasOwnProperty('category')) {
	        obj['category'] = ApiClient.convertToType(data['category'], 'String');
	      }
	      if (data.hasOwnProperty('website')) {
	        obj['website'] = ApiClient.convertToType(data['website'], 'String');
	      }
	      if (data.hasOwnProperty('imageUrl')) {
	        obj['imageUrl'] = ApiClient.convertToType(data['imageUrl'], 'String');
	      }
	      if (data.hasOwnProperty('updatedAt')) {
	        obj['updatedAt'] = ApiClient.convertToType(data['updatedAt'], 'Date');
	      }
	      if (data.hasOwnProperty('createdAt')) {
	        obj['createdAt'] = ApiClient.convertToType(data['createdAt'], 'Date');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['_id'] = undefined;
	
	  exports.prototype['name'] = undefined;
	
	  exports.prototype['category'] = undefined;
	
	  exports.prototype['website'] = undefined;
	
	  exports.prototype['imageUrl'] = undefined;
	
	  exports.prototype['updatedAt'] = undefined;
	
	  exports.prototype['createdAt'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 126:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.SuccessResponse = factory(root.ConferenceBackend.ApiClient);
	  }
	})(undefined, function (ApiClient) {
	  'use strict';
	
	  var exports = function exports(message) {
	    var _this = this;
	
	    _this['message'] = message;
	  };
	
	  exports.constructFromObject = function (data, obj) {
	    if (data) {
	      obj = obj || new exports();
	
	      if (data.hasOwnProperty('message')) {
	        obj['message'] = ApiClient.convertToType(data['message'], 'String');
	      }
	    }
	    return obj;
	  };
	
	  exports.prototype['message'] = undefined;
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 304:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(422)
	
	/* script */
	__vue_exports__ = __webpack_require__(350)
	
	/* template */
	var __vue_template__ = __webpack_require__(552)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-2daa25ce"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 305:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(418)
	
	/* script */
	__vue_exports__ = __webpack_require__(353)
	
	/* template */
	var __vue_template__ = __webpack_require__(548)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-16faa600"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 308:
/***/ (function(module, exports, __webpack_require__) {

	
	/**
	 * Expose `Emitter`.
	 */
	
	if (true) {
	  module.exports = Emitter;
	}
	
	/**
	 * Initialize a new `Emitter`.
	 *
	 * @api public
	 */
	
	function Emitter(obj) {
	  if (obj) return mixin(obj);
	};
	
	/**
	 * Mixin the emitter properties.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function mixin(obj) {
	  for (var key in Emitter.prototype) {
	    obj[key] = Emitter.prototype[key];
	  }
	  return obj;
	}
	
	/**
	 * Listen on the given `event` with `fn`.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.on =
	Emitter.prototype.addEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	  (this._callbacks['$' + event] = this._callbacks['$' + event] || [])
	    .push(fn);
	  return this;
	};
	
	/**
	 * Adds an `event` listener that will be invoked a single
	 * time then automatically removed.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.once = function(event, fn){
	  function on() {
	    this.off(event, on);
	    fn.apply(this, arguments);
	  }
	
	  on.fn = fn;
	  this.on(event, on);
	  return this;
	};
	
	/**
	 * Remove the given callback for `event` or all
	 * registered callbacks.
	 *
	 * @param {String} event
	 * @param {Function} fn
	 * @return {Emitter}
	 * @api public
	 */
	
	Emitter.prototype.off =
	Emitter.prototype.removeListener =
	Emitter.prototype.removeAllListeners =
	Emitter.prototype.removeEventListener = function(event, fn){
	  this._callbacks = this._callbacks || {};
	
	  // all
	  if (0 == arguments.length) {
	    this._callbacks = {};
	    return this;
	  }
	
	  // specific event
	  var callbacks = this._callbacks['$' + event];
	  if (!callbacks) return this;
	
	  // remove all handlers
	  if (1 == arguments.length) {
	    delete this._callbacks['$' + event];
	    return this;
	  }
	
	  // remove specific handler
	  var cb;
	  for (var i = 0; i < callbacks.length; i++) {
	    cb = callbacks[i];
	    if (cb === fn || cb.fn === fn) {
	      callbacks.splice(i, 1);
	      break;
	    }
	  }
	  return this;
	};
	
	/**
	 * Emit `event` with the given args.
	 *
	 * @param {String} event
	 * @param {Mixed} ...
	 * @return {Emitter}
	 */
	
	Emitter.prototype.emit = function(event){
	  this._callbacks = this._callbacks || {};
	  var args = [].slice.call(arguments, 1)
	    , callbacks = this._callbacks['$' + event];
	
	  if (callbacks) {
	    callbacks = callbacks.slice(0);
	    for (var i = 0, len = callbacks.length; i < len; ++i) {
	      callbacks[i].apply(this, args);
	    }
	  }
	
	  return this;
	};
	
	/**
	 * Return array of callbacks for `event`.
	 *
	 * @param {String} event
	 * @return {Array}
	 * @api public
	 */
	
	Emitter.prototype.listeners = function(event){
	  this._callbacks = this._callbacks || {};
	  return this._callbacks['$' + event] || [];
	};
	
	/**
	 * Check if this emitter has `event` handlers.
	 *
	 * @param {String} event
	 * @return {Boolean}
	 * @api public
	 */
	
	Emitter.prototype.hasListeners = function(event){
	  return !! this.listeners(event).length;
	};


/***/ }),

/***/ 309:
/***/ (function(module, exports) {

	
	/**
	 * Reduce `arr` with `fn`.
	 *
	 * @param {Array} arr
	 * @param {Function} fn
	 * @param {Mixed} initial
	 *
	 * TODO: combatible error handling?
	 */
	
	module.exports = function(arr, fn, initial){  
	  var idx = 0;
	  var len = arr.length;
	  var curr = arguments.length == 3
	    ? initial
	    : arr[idx++];
	
	  while (idx < len) {
	    curr = fn.call(null, curr, arr[idx], ++idx, arr);
	  }
	  
	  return curr;
	};

/***/ }),

/***/ 310:
/***/ (function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies.
	 */
	
	var Emitter = __webpack_require__(308);
	var reduce = __webpack_require__(309);
	
	/**
	 * Root reference for iframes.
	 */
	
	var root;
	if (typeof window !== 'undefined') { // Browser window
	  root = window;
	} else if (typeof self !== 'undefined') { // Web Worker
	  root = self;
	} else { // Other environments
	  root = this;
	}
	
	/**
	 * Noop.
	 */
	
	function noop(){};
	
	/**
	 * Check if `obj` is a host object,
	 * we don't want to serialize these :)
	 *
	 * TODO: future proof, move to compoent land
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isHost(obj) {
	  var str = {}.toString.call(obj);
	
	  switch (str) {
	    case '[object File]':
	    case '[object Blob]':
	    case '[object FormData]':
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Determine XHR.
	 */
	
	request.getXHR = function () {
	  if (root.XMLHttpRequest
	      && (!root.location || 'file:' != root.location.protocol
	          || !root.ActiveXObject)) {
	    return new XMLHttpRequest;
	  } else {
	    try { return new ActiveXObject('Microsoft.XMLHTTP'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.6.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP.3.0'); } catch(e) {}
	    try { return new ActiveXObject('Msxml2.XMLHTTP'); } catch(e) {}
	  }
	  return false;
	};
	
	/**
	 * Removes leading and trailing whitespace, added to support IE.
	 *
	 * @param {String} s
	 * @return {String}
	 * @api private
	 */
	
	var trim = ''.trim
	  ? function(s) { return s.trim(); }
	  : function(s) { return s.replace(/(^\s*|\s*$)/g, ''); };
	
	/**
	 * Check if `obj` is an object.
	 *
	 * @param {Object} obj
	 * @return {Boolean}
	 * @api private
	 */
	
	function isObject(obj) {
	  return obj === Object(obj);
	}
	
	/**
	 * Serialize the given `obj`.
	 *
	 * @param {Object} obj
	 * @return {String}
	 * @api private
	 */
	
	function serialize(obj) {
	  if (!isObject(obj)) return obj;
	  var pairs = [];
	  for (var key in obj) {
	    if (null != obj[key]) {
	      pushEncodedKeyValuePair(pairs, key, obj[key]);
	        }
	      }
	  return pairs.join('&');
	}
	
	/**
	 * Helps 'serialize' with serializing arrays.
	 * Mutates the pairs array.
	 *
	 * @param {Array} pairs
	 * @param {String} key
	 * @param {Mixed} val
	 */
	
	function pushEncodedKeyValuePair(pairs, key, val) {
	  if (Array.isArray(val)) {
	    return val.forEach(function(v) {
	      pushEncodedKeyValuePair(pairs, key, v);
	    });
	  }
	  pairs.push(encodeURIComponent(key)
	    + '=' + encodeURIComponent(val));
	}
	
	/**
	 * Expose serialization method.
	 */
	
	 request.serializeObject = serialize;
	
	 /**
	  * Parse the given x-www-form-urlencoded `str`.
	  *
	  * @param {String} str
	  * @return {Object}
	  * @api private
	  */
	
	function parseString(str) {
	  var obj = {};
	  var pairs = str.split('&');
	  var parts;
	  var pair;
	
	  for (var i = 0, len = pairs.length; i < len; ++i) {
	    pair = pairs[i];
	    parts = pair.split('=');
	    obj[decodeURIComponent(parts[0])] = decodeURIComponent(parts[1]);
	  }
	
	  return obj;
	}
	
	/**
	 * Expose parser.
	 */
	
	request.parseString = parseString;
	
	/**
	 * Default MIME type map.
	 *
	 *     superagent.types.xml = 'application/xml';
	 *
	 */
	
	request.types = {
	  html: 'text/html',
	  json: 'application/json',
	  xml: 'application/xml',
	  urlencoded: 'application/x-www-form-urlencoded',
	  'form': 'application/x-www-form-urlencoded',
	  'form-data': 'application/x-www-form-urlencoded'
	};
	
	/**
	 * Default serialization map.
	 *
	 *     superagent.serialize['application/xml'] = function(obj){
	 *       return 'generated xml here';
	 *     };
	 *
	 */
	
	 request.serialize = {
	   'application/x-www-form-urlencoded': serialize,
	   'application/json': JSON.stringify
	 };
	
	 /**
	  * Default parsers.
	  *
	  *     superagent.parse['application/xml'] = function(str){
	  *       return { object parsed from str };
	  *     };
	  *
	  */
	
	request.parse = {
	  'application/x-www-form-urlencoded': parseString,
	  'application/json': JSON.parse
	};
	
	/**
	 * Parse the given header `str` into
	 * an object containing the mapped fields.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function parseHeader(str) {
	  var lines = str.split(/\r?\n/);
	  var fields = {};
	  var index;
	  var line;
	  var field;
	  var val;
	
	  lines.pop(); // trailing CRLF
	
	  for (var i = 0, len = lines.length; i < len; ++i) {
	    line = lines[i];
	    index = line.indexOf(':');
	    field = line.slice(0, index).toLowerCase();
	    val = trim(line.slice(index + 1));
	    fields[field] = val;
	  }
	
	  return fields;
	}
	
	/**
	 * Check if `mime` is json or has +json structured syntax suffix.
	 *
	 * @param {String} mime
	 * @return {Boolean}
	 * @api private
	 */
	
	function isJSON(mime) {
	  return /[\/+]json\b/.test(mime);
	}
	
	/**
	 * Return the mime type for the given `str`.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function type(str){
	  return str.split(/ *; */).shift();
	};
	
	/**
	 * Return header field parameters.
	 *
	 * @param {String} str
	 * @return {Object}
	 * @api private
	 */
	
	function params(str){
	  return reduce(str.split(/ *; */), function(obj, str){
	    var parts = str.split(/ *= */)
	      , key = parts.shift()
	      , val = parts.shift();
	
	    if (key && val) obj[key] = val;
	    return obj;
	  }, {});
	};
	
	/**
	 * Initialize a new `Response` with the given `xhr`.
	 *
	 *  - set flags (.ok, .error, etc)
	 *  - parse header
	 *
	 * Examples:
	 *
	 *  Aliasing `superagent` as `request` is nice:
	 *
	 *      request = superagent;
	 *
	 *  We can use the promise-like API, or pass callbacks:
	 *
	 *      request.get('/').end(function(res){});
	 *      request.get('/', function(res){});
	 *
	 *  Sending data can be chained:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' })
	 *        .end(function(res){});
	 *
	 *  Or passed to `.send()`:
	 *
	 *      request
	 *        .post('/user')
	 *        .send({ name: 'tj' }, function(res){});
	 *
	 *  Or passed to `.post()`:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' })
	 *        .end(function(res){});
	 *
	 * Or further reduced to a single call for simple cases:
	 *
	 *      request
	 *        .post('/user', { name: 'tj' }, function(res){});
	 *
	 * @param {XMLHTTPRequest} xhr
	 * @param {Object} options
	 * @api private
	 */
	
	function Response(req, options) {
	  options = options || {};
	  this.req = req;
	  this.xhr = this.req.xhr;
	  // responseText is accessible only if responseType is '' or 'text' and on older browsers
	  this.text = ((this.req.method !='HEAD' && (this.xhr.responseType === '' || this.xhr.responseType === 'text')) || typeof this.xhr.responseType === 'undefined')
	     ? this.xhr.responseText
	     : null;
	  this.statusText = this.req.xhr.statusText;
	  this.setStatusProperties(this.xhr.status);
	  this.header = this.headers = parseHeader(this.xhr.getAllResponseHeaders());
	  // getAllResponseHeaders sometimes falsely returns "" for CORS requests, but
	  // getResponseHeader still works. so we get content-type even if getting
	  // other headers fails.
	  this.header['content-type'] = this.xhr.getResponseHeader('content-type');
	  this.setHeaderProperties(this.header);
	  this.body = this.req.method != 'HEAD'
	    ? this.parseBody(this.text ? this.text : this.xhr.response)
	    : null;
	}
	
	/**
	 * Get case-insensitive `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api public
	 */
	
	Response.prototype.get = function(field){
	  return this.header[field.toLowerCase()];
	};
	
	/**
	 * Set header related properties:
	 *
	 *   - `.type` the content type without params
	 *
	 * A response of "Content-Type: text/plain; charset=utf-8"
	 * will provide you with a `.type` of "text/plain".
	 *
	 * @param {Object} header
	 * @api private
	 */
	
	Response.prototype.setHeaderProperties = function(header){
	  // content-type
	  var ct = this.header['content-type'] || '';
	  this.type = type(ct);
	
	  // params
	  var obj = params(ct);
	  for (var key in obj) this[key] = obj[key];
	};
	
	/**
	 * Parse the given body `str`.
	 *
	 * Used for auto-parsing of bodies. Parsers
	 * are defined on the `superagent.parse` object.
	 *
	 * @param {String} str
	 * @return {Mixed}
	 * @api private
	 */
	
	Response.prototype.parseBody = function(str){
	  var parse = request.parse[this.type];
	  return parse && str && (str.length || str instanceof Object)
	    ? parse(str)
	    : null;
	};
	
	/**
	 * Set flags such as `.ok` based on `status`.
	 *
	 * For example a 2xx response will give you a `.ok` of __true__
	 * whereas 5xx will be __false__ and `.error` will be __true__. The
	 * `.clientError` and `.serverError` are also available to be more
	 * specific, and `.statusType` is the class of error ranging from 1..5
	 * sometimes useful for mapping respond colors etc.
	 *
	 * "sugar" properties are also defined for common cases. Currently providing:
	 *
	 *   - .noContent
	 *   - .badRequest
	 *   - .unauthorized
	 *   - .notAcceptable
	 *   - .notFound
	 *
	 * @param {Number} status
	 * @api private
	 */
	
	Response.prototype.setStatusProperties = function(status){
	  // handle IE9 bug: http://stackoverflow.com/questions/10046972/msie-returns-status-code-of-1223-for-ajax-request
	  if (status === 1223) {
	    status = 204;
	  }
	
	  var type = status / 100 | 0;
	
	  // status / class
	  this.status = this.statusCode = status;
	  this.statusType = type;
	
	  // basics
	  this.info = 1 == type;
	  this.ok = 2 == type;
	  this.clientError = 4 == type;
	  this.serverError = 5 == type;
	  this.error = (4 == type || 5 == type)
	    ? this.toError()
	    : false;
	
	  // sugar
	  this.accepted = 202 == status;
	  this.noContent = 204 == status;
	  this.badRequest = 400 == status;
	  this.unauthorized = 401 == status;
	  this.notAcceptable = 406 == status;
	  this.notFound = 404 == status;
	  this.forbidden = 403 == status;
	};
	
	/**
	 * Return an `Error` representative of this response.
	 *
	 * @return {Error}
	 * @api public
	 */
	
	Response.prototype.toError = function(){
	  var req = this.req;
	  var method = req.method;
	  var url = req.url;
	
	  var msg = 'cannot ' + method + ' ' + url + ' (' + this.status + ')';
	  var err = new Error(msg);
	  err.status = this.status;
	  err.method = method;
	  err.url = url;
	
	  return err;
	};
	
	/**
	 * Expose `Response`.
	 */
	
	request.Response = Response;
	
	/**
	 * Initialize a new `Request` with the given `method` and `url`.
	 *
	 * @param {String} method
	 * @param {String} url
	 * @api public
	 */
	
	function Request(method, url) {
	  var self = this;
	  Emitter.call(this);
	  this._query = this._query || [];
	  this.method = method;
	  this.url = url;
	  this.header = {};
	  this._header = {};
	  this.on('end', function(){
	    var err = null;
	    var res = null;
	
	    try {
	      res = new Response(self);
	    } catch(e) {
	      err = new Error('Parser is unable to parse the response');
	      err.parse = true;
	      err.original = e;
	      // issue #675: return the raw response if the response parsing fails
	      err.rawResponse = self.xhr && self.xhr.responseText ? self.xhr.responseText : null;
	      return self.callback(err);
	    }
	
	    self.emit('response', res);
	
	    if (err) {
	      return self.callback(err, res);
	    }
	
	    if (res.status >= 200 && res.status < 300) {
	      return self.callback(err, res);
	    }
	
	    var new_err = new Error(res.statusText || 'Unsuccessful HTTP response');
	    new_err.original = err;
	    new_err.response = res;
	    new_err.status = res.status;
	
	    self.callback(new_err, res);
	  });
	}
	
	/**
	 * Mixin `Emitter`.
	 */
	
	Emitter(Request.prototype);
	
	/**
	 * Allow for extension
	 */
	
	Request.prototype.use = function(fn) {
	  fn(this);
	  return this;
	}
	
	/**
	 * Set timeout to `ms`.
	 *
	 * @param {Number} ms
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.timeout = function(ms){
	  this._timeout = ms;
	  return this;
	};
	
	/**
	 * Clear previous timeout.
	 *
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.clearTimeout = function(){
	  this._timeout = 0;
	  clearTimeout(this._timer);
	  return this;
	};
	
	/**
	 * Abort the request, and clear potential timeout.
	 *
	 * @return {Request}
	 * @api public
	 */
	
	Request.prototype.abort = function(){
	  if (this.aborted) return;
	  this.aborted = true;
	  this.xhr.abort();
	  this.clearTimeout();
	  this.emit('abort');
	  return this;
	};
	
	/**
	 * Set header `field` to `val`, or multiple fields with one object.
	 *
	 * Examples:
	 *
	 *      req.get('/')
	 *        .set('Accept', 'application/json')
	 *        .set('X-API-Key', 'foobar')
	 *        .end(callback);
	 *
	 *      req.get('/')
	 *        .set({ Accept: 'application/json', 'X-API-Key': 'foobar' })
	 *        .end(callback);
	 *
	 * @param {String|Object} field
	 * @param {String} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.set = function(field, val){
	  if (isObject(field)) {
	    for (var key in field) {
	      this.set(key, field[key]);
	    }
	    return this;
	  }
	  this._header[field.toLowerCase()] = val;
	  this.header[field] = val;
	  return this;
	};
	
	/**
	 * Remove header `field`.
	 *
	 * Example:
	 *
	 *      req.get('/')
	 *        .unset('User-Agent')
	 *        .end(callback);
	 *
	 * @param {String} field
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.unset = function(field){
	  delete this._header[field.toLowerCase()];
	  delete this.header[field];
	  return this;
	};
	
	/**
	 * Get case-insensitive header `field` value.
	 *
	 * @param {String} field
	 * @return {String}
	 * @api private
	 */
	
	Request.prototype.getHeader = function(field){
	  return this._header[field.toLowerCase()];
	};
	
	/**
	 * Set Content-Type to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.xml = 'application/xml';
	 *
	 *      request.post('/')
	 *        .type('xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 *      request.post('/')
	 *        .type('application/xml')
	 *        .send(xmlstring)
	 *        .end(callback);
	 *
	 * @param {String} type
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.type = function(type){
	  this.set('Content-Type', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Force given parser
	 *
	 * Sets the body parser no matter type.
	 *
	 * @param {Function}
	 * @api public
	 */
	
	Request.prototype.parse = function(fn){
	  this._parser = fn;
	  return this;
	};
	
	/**
	 * Set Accept to `type`, mapping values from `request.types`.
	 *
	 * Examples:
	 *
	 *      superagent.types.json = 'application/json';
	 *
	 *      request.get('/agent')
	 *        .accept('json')
	 *        .end(callback);
	 *
	 *      request.get('/agent')
	 *        .accept('application/json')
	 *        .end(callback);
	 *
	 * @param {String} accept
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.accept = function(type){
	  this.set('Accept', request.types[type] || type);
	  return this;
	};
	
	/**
	 * Set Authorization field value with `user` and `pass`.
	 *
	 * @param {String} user
	 * @param {String} pass
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.auth = function(user, pass){
	  var str = btoa(user + ':' + pass);
	  this.set('Authorization', 'Basic ' + str);
	  return this;
	};
	
	/**
	* Add query-string `val`.
	*
	* Examples:
	*
	*   request.get('/shoes')
	*     .query('size=10')
	*     .query({ color: 'blue' })
	*
	* @param {Object|String} val
	* @return {Request} for chaining
	* @api public
	*/
	
	Request.prototype.query = function(val){
	  if ('string' != typeof val) val = serialize(val);
	  if (val) this._query.push(val);
	  return this;
	};
	
	/**
	 * Write the field `name` and `val` for "multipart/form-data"
	 * request bodies.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .field('foo', 'bar')
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} name
	 * @param {String|Blob|File} val
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.field = function(name, val){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(name, val);
	  return this;
	};
	
	/**
	 * Queue the given `file` as an attachment to the specified `field`,
	 * with optional `filename`.
	 *
	 * ``` js
	 * request.post('/upload')
	 *   .attach(new Blob(['<a id="a"><b id="b">hey!</b></a>'], { type: "text/html"}))
	 *   .end(callback);
	 * ```
	 *
	 * @param {String} field
	 * @param {Blob|File} file
	 * @param {String} filename
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.attach = function(field, file, filename){
	  if (!this._formData) this._formData = new root.FormData();
	  this._formData.append(field, file, filename || file.name);
	  return this;
	};
	
	/**
	 * Send `data` as the request body, defaulting the `.type()` to "json" when
	 * an object is given.
	 *
	 * Examples:
	 *
	 *       // manual json
	 *       request.post('/user')
	 *         .type('json')
	 *         .send('{"name":"tj"}')
	 *         .end(callback)
	 *
	 *       // auto json
	 *       request.post('/user')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // manual x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send('name=tj')
	 *         .end(callback)
	 *
	 *       // auto x-www-form-urlencoded
	 *       request.post('/user')
	 *         .type('form')
	 *         .send({ name: 'tj' })
	 *         .end(callback)
	 *
	 *       // defaults to x-www-form-urlencoded
	  *      request.post('/user')
	  *        .send('name=tobi')
	  *        .send('species=ferret')
	  *        .end(callback)
	 *
	 * @param {String|Object} data
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.send = function(data){
	  var obj = isObject(data);
	  var type = this.getHeader('Content-Type');
	
	  // merge
	  if (obj && isObject(this._data)) {
	    for (var key in data) {
	      this._data[key] = data[key];
	    }
	  } else if ('string' == typeof data) {
	    if (!type) this.type('form');
	    type = this.getHeader('Content-Type');
	    if ('application/x-www-form-urlencoded' == type) {
	      this._data = this._data
	        ? this._data + '&' + data
	        : data;
	    } else {
	      this._data = (this._data || '') + data;
	    }
	  } else {
	    this._data = data;
	  }
	
	  if (!obj || isHost(data)) return this;
	  if (!type) this.type('json');
	  return this;
	};
	
	/**
	 * Invoke the callback with `err` and `res`
	 * and handle arity check.
	 *
	 * @param {Error} err
	 * @param {Response} res
	 * @api private
	 */
	
	Request.prototype.callback = function(err, res){
	  var fn = this._callback;
	  this.clearTimeout();
	  fn(err, res);
	};
	
	/**
	 * Invoke callback with x-domain error.
	 *
	 * @api private
	 */
	
	Request.prototype.crossDomainError = function(){
	  var err = new Error('Request has been terminated\nPossible causes: the network is offline, Origin is not allowed by Access-Control-Allow-Origin, the page is being unloaded, etc.');
	  err.crossDomain = true;
	
	  err.status = this.status;
	  err.method = this.method;
	  err.url = this.url;
	
	  this.callback(err);
	};
	
	/**
	 * Invoke callback with timeout error.
	 *
	 * @api private
	 */
	
	Request.prototype.timeoutError = function(){
	  var timeout = this._timeout;
	  var err = new Error('timeout of ' + timeout + 'ms exceeded');
	  err.timeout = timeout;
	  this.callback(err);
	};
	
	/**
	 * Enable transmission of cookies with x-domain requests.
	 *
	 * Note that for this to work the origin must not be
	 * using "Access-Control-Allow-Origin" with a wildcard,
	 * and also must set "Access-Control-Allow-Credentials"
	 * to "true".
	 *
	 * @api public
	 */
	
	Request.prototype.withCredentials = function(){
	  this._withCredentials = true;
	  return this;
	};
	
	/**
	 * Initiate request, invoking callback `fn(res)`
	 * with an instanceof `Response`.
	 *
	 * @param {Function} fn
	 * @return {Request} for chaining
	 * @api public
	 */
	
	Request.prototype.end = function(fn){
	  var self = this;
	  var xhr = this.xhr = request.getXHR();
	  var query = this._query.join('&');
	  var timeout = this._timeout;
	  var data = this._formData || this._data;
	
	  // store callback
	  this._callback = fn || noop;
	
	  // state change
	  xhr.onreadystatechange = function(){
	    if (4 != xhr.readyState) return;
	
	    // In IE9, reads to any property (e.g. status) off of an aborted XHR will
	    // result in the error "Could not complete the operation due to error c00c023f"
	    var status;
	    try { status = xhr.status } catch(e) { status = 0; }
	
	    if (0 == status) {
	      if (self.timedout) return self.timeoutError();
	      if (self.aborted) return;
	      return self.crossDomainError();
	    }
	    self.emit('end');
	  };
	
	  // progress
	  var handleProgress = function(e){
	    if (e.total > 0) {
	      e.percent = e.loaded / e.total * 100;
	    }
	    e.direction = 'download';
	    self.emit('progress', e);
	  };
	  if (this.hasListeners('progress')) {
	    xhr.onprogress = handleProgress;
	  }
	  try {
	    if (xhr.upload && this.hasListeners('progress')) {
	      xhr.upload.onprogress = handleProgress;
	    }
	  } catch(e) {
	    // Accessing xhr.upload fails in IE from a web worker, so just pretend it doesn't exist.
	    // Reported here:
	    // https://connect.microsoft.com/IE/feedback/details/837245/xmlhttprequest-upload-throws-invalid-argument-when-used-from-web-worker-context
	  }
	
	  // timeout
	  if (timeout && !this._timer) {
	    this._timer = setTimeout(function(){
	      self.timedout = true;
	      self.abort();
	    }, timeout);
	  }
	
	  // querystring
	  if (query) {
	    query = request.serializeObject(query);
	    this.url += ~this.url.indexOf('?')
	      ? '&' + query
	      : '?' + query;
	  }
	
	  // initiate request
	  xhr.open(this.method, this.url, true);
	
	  // CORS
	  if (this._withCredentials) xhr.withCredentials = true;
	
	  // body
	  if ('GET' != this.method && 'HEAD' != this.method && 'string' != typeof data && !isHost(data)) {
	    // serialize stuff
	    var contentType = this.getHeader('Content-Type');
	    var serialize = this._parser || request.serialize[contentType ? contentType.split(';')[0] : ''];
	    if (!serialize && isJSON(contentType)) serialize = request.serialize['application/json'];
	    if (serialize) data = serialize(data);
	  }
	
	  // set header fields
	  for (var field in this.header) {
	    if (null == this.header[field]) continue;
	    xhr.setRequestHeader(field, this.header[field]);
	  }
	
	  // send stuff
	  this.emit('request', this);
	
	  // IE11 xhr.send(undefined) sends 'undefined' string as POST payload (instead of nothing)
	  // We need null here if data is undefined
	  xhr.send(typeof data !== 'undefined' ? data : null);
	  return this;
	};
	
	/**
	 * Faux promise support
	 *
	 * @param {Function} fulfill
	 * @param {Function} reject
	 * @return {Request}
	 */
	
	Request.prototype.then = function (fulfill, reject) {
	  return this.end(function(err, res) {
	    err ? reject(err) : fulfill(res);
	  });
	}
	
	/**
	 * Expose `Request`.
	 */
	
	request.Request = Request;
	
	/**
	 * Issue a request:
	 *
	 * Examples:
	 *
	 *    request('GET', '/users').end(callback)
	 *    request('/users').end(callback)
	 *    request('/users', callback)
	 *
	 * @param {String} method
	 * @param {String|Function} url or callback
	 * @return {Request}
	 * @api public
	 */
	
	function request(method, url) {
	  // callback
	  if ('function' == typeof url) {
	    return new Request('GET', method).end(url);
	  }
	
	  // url first
	  if (1 == arguments.length) {
	    return new Request('GET', method);
	  }
	
	  return new Request(method, url);
	}
	
	/**
	 * GET `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.get = function(url, data, fn){
	  var req = request('GET', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.query(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * HEAD `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.head = function(url, data, fn){
	  var req = request('HEAD', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * DELETE `url` with optional callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	function del(url, fn){
	  var req = request('DELETE', url);
	  if (fn) req.end(fn);
	  return req;
	};
	
	request['del'] = del;
	request['delete'] = del;
	
	/**
	 * PATCH `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.patch = function(url, data, fn){
	  var req = request('PATCH', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * POST `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed} data
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.post = function(url, data, fn){
	  var req = request('POST', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * PUT `url` with optional `data` and callback `fn(res)`.
	 *
	 * @param {String} url
	 * @param {Mixed|Function} data or fn
	 * @param {Function} fn
	 * @return {Request}
	 * @api public
	 */
	
	request.put = function(url, data, fn){
	  var req = request('PUT', url);
	  if ('function' == typeof data) fn = data, data = null;
	  if (data) req.send(data);
	  if (fn) req.end(fn);
	  return req;
	};
	
	/**
	 * Expose `request`.
	 */
	
	module.exports = request;


/***/ }),

/***/ 346:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {'use strict';
	
	var _typeof2 = __webpack_require__(7);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	(function (root, factory) {
	  if (typeof define === 'function' && define.amd) {
	    define(['ApiClient', 'model/Conference', 'model/DataResponse', 'model/ErrorResponse', 'model/Lecturer', 'model/Params', 'model/Params1', 'model/Params2', 'model/Params3', 'model/Presentation', 'model/Question', 'model/Sponsor', 'model/SuccessResponse'], factory);
	  } else if (( false ? 'undefined' : (0, _typeof3.default)(module)) === 'object' && module.exports) {
	    module.exports = factory(__webpack_require__(9), __webpack_require__(116), __webpack_require__(117), __webpack_require__(118), __webpack_require__(77), __webpack_require__(119), __webpack_require__(120), __webpack_require__(121), __webpack_require__(122), __webpack_require__(78), __webpack_require__(79), __webpack_require__(125), __webpack_require__(126));
	  } else {
	    if (!root.ConferenceBackend) {
	      root.ConferenceBackend = {};
	    }
	    root.ConferenceBackend.DefaultApi = factory(root.ConferenceBackend.ApiClient, root.ConferenceBackend.Conference, root.ConferenceBackend.DataResponse, root.ConferenceBackend.ErrorResponse, root.ConferenceBackend.Lecturer, root.ConferenceBackend.Params, root.ConferenceBackend.Params1, root.ConferenceBackend.Params2, root.ConferenceBackend.Params3, root.ConferenceBackend.Presentation, root.ConferenceBackend.Question, root.ConferenceBackend.Sponsor, root.ConferenceBackend.SuccessResponse);
	  }
	})(undefined, function (ApiClient, Conference, DataResponse, ErrorResponse, Lecturer, Params, Params1, Params2, Params3, Presentation, Question, Sponsor, SuccessResponse) {
	  'use strict';
	
	  var exports = function exports(apiClient) {
	    this.apiClient = apiClient || ApiClient.instance;
	
	    this.deleteQuestion = function (questionId, callback) {
	      var postBody = null;
	
	      if (questionId == undefined || questionId == null) {
	        throw new Error("Missing the required parameter 'questionId' when calling deleteQuestion");
	      }
	
	      var pathParams = {};
	      var queryParams = {
	        'questionId': questionId
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = SuccessResponse;
	
	      return this.apiClient.callApi('/presentation/survey/question', 'DELETE', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getConferenceInformation = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = Conference;
	
	      return this.apiClient.callApi('/conference', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getCurrentQuestion = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = Question;
	
	      return this.apiClient.callApi('/presentation/survey/current', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getLecturers = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = [Lecturer];
	
	      return this.apiClient.callApi('/lecturers', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getPresentations = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = [Presentation];
	
	      return this.apiClient.callApi('/presentations', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getRatings = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = DataResponse;
	
	      return this.apiClient.callApi('/presentation/rating', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getSponsors = function (callback) {
	      var postBody = null;
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = [Sponsor];
	
	      return this.apiClient.callApi('/sponsors', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.getSurveyResult = function (presentationId, callback) {
	      var postBody = null;
	
	      if (presentationId == undefined || presentationId == null) {
	        throw new Error("Missing the required parameter 'presentationId' when calling getSurveyResult");
	      }
	
	      var pathParams = {};
	      var queryParams = {
	        'presentationId': presentationId
	      };
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = [Question];
	
	      return this.apiClient.callApi('/presentation/survey', 'GET', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postAnswer = function (params, callback) {
	      var postBody = params;
	
	      if (params == undefined || params == null) {
	        throw new Error("Missing the required parameter 'params' when calling postAnswer");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = SuccessResponse;
	
	      return this.apiClient.callApi('/presentation/survey', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postCurrentQuestion = function (params, callback) {
	      var postBody = params;
	
	      if (params == undefined || params == null) {
	        throw new Error("Missing the required parameter 'params' when calling postCurrentQuestion");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = SuccessResponse;
	
	      return this.apiClient.callApi('/presentation/survey/current', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postQuestion = function (params, callback) {
	      var postBody = params;
	
	      if (params == undefined || params == null) {
	        throw new Error("Missing the required parameter 'params' when calling postQuestion");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = SuccessResponse;
	
	      return this.apiClient.callApi('/presentation/survey/question', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	
	    this.postRating = function (params, callback) {
	      var postBody = params;
	
	      if (params == undefined || params == null) {
	        throw new Error("Missing the required parameter 'params' when calling postRating");
	      }
	
	      var pathParams = {};
	      var queryParams = {};
	      var headerParams = {};
	      var formParams = {};
	
	      var authNames = [];
	      var contentTypes = ['application/json'];
	      var accepts = ['application/json'];
	      var returnType = SuccessResponse;
	
	      return this.apiClient.callApi('/presentation/rating', 'POST', pathParams, queryParams, headerParams, formParams, postBody, authNames, contentTypes, accepts, returnType, callback);
	    };
	  };
	
	  return exports;
	});
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(5)(module)))

/***/ }),

/***/ 347:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueRouter = __webpack_require__(564);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	_vue2.default.use(_vueRouter2.default);
	
	exports.default = new _vueRouter2.default({
		mode: 'history',
		routes: [{
			path: '/',
			name: 'login',
			component: __webpack_require__(546)
		}, {
			path: '/app/:appId/floorplan/',
			name: 'floorplan',
			component: __webpack_require__(547)
		}, {
			path: '/admin/',
			name: 'admin',
			component: __webpack_require__(538),
			children: [{
				path: '',
				name: 'admin-notifications',
				component: __webpack_require__(543)
			}, {
				path: 'answers',
				name: 'admin-answers',
				component: __webpack_require__(539)
			}, {
				path: 'presentations',
				name: 'admin-presentations',
				component: __webpack_require__(545)
			}, {
				path: 'lecturers',
				name: 'admin-lecturers',
				component: __webpack_require__(542)
			}, {
				path: 'information',
				name: 'admin-information',
				component: __webpack_require__(541)
			}, {
				path: 'editor',
				name: 'admin-editor',
				component: __webpack_require__(540)
			}]
		}]
	});

/***/ }),

/***/ 348:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _config = __webpack_require__(45);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	var APIKEY = "m5**!Q)kk-x{jw.iGZ:O*S*mW)mdB3#:$i(c<}%f![~c<e$Uk9VGK,DcWyR0/hR";
	
	exports.default = {
		uploadImage: function uploadImage(file, cb) {
			var formdata = new FormData();
			formdata.append('image', file);
			formdata.append('project', _vue2.default.localStorage.get('project', _config2.default.default));
	
			_vue2.default.http.post('https://admin.conflive.com/api/upload', formdata, {
				headers: {
					'Authorization': APIKEY,
					'Content-Type': 'multipart/form-data'
				} }).then(function (response) {
				console.log(response);
				cb(null, response.body);
			});
		}
	};

/***/ }),

/***/ 349:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var define = false;
	
	exports.default = {
		sendGlobalNotification: function sendGlobalNotification(notification, cb) {
			_FirebaseDBService2.default.getConstants(function (err, constants) {
				if (err) {
					cb(err);
					return;
				}
	
				var body = {
					"to": "/topics/global",
					"notification": {
						"title": firebase.apps[0].options.appName,
						"body": notification.title
					},
					"data": {
						"title": firebase.apps[0].options.appName,
						"body": notification.title
					},
					"priority": "high",
					"time_to_live": 60 * 60 * 24
				};
	
				var options = {
					headers: {
						'Content-Type': 'application/json',
						'Authorization': 'key=' + constants.fcm
					}
				};
	
				_vue2.default.http.post('https://fcm.googleapis.com/fcm/send', body, options).then(function (response) {
					console.log("Successfully sent notification");
					console.log(response);
					cb(undefined);
				}, function (errorResponse) {
					console.log("Notification failed");
					console.log(errorResponse);
					cb(errorResponse);
				});
			});
		}
	};

/***/ }),

/***/ 350:
/***/ (function(module, exports, __webpack_require__) {

	
	
	'use strict';
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault2(_stringify);
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault2(_getIterator2);
	
	function _interopRequireDefault2(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : { default: obj };
	}
	
	exports.default = {
	  props: {
	    required: false,
	    date: {
	      type: Object,
	      required: true
	    },
	    option: {
	      type: Object,
	      default: function _default() {
	        return {
	          type: 'day',
	          SundayFirst: false,
	          week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
	          month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
	          format: 'YYYY-MM-DD',
	          color: {
	            checked: '#F50057',
	            header: '#3f51b5',
	            headerText: '#fff'
	          },
	          inputStyle: {
	            'display': 'inline-block',
	            'padding': '6px',
	            'line-height': '22px',
	            'font-size': '16px',
	            'border': '2px solid #fff',
	            'box-shadow': '0 1px 3px 0 rgba(0, 0, 0, 0.2)',
	            'border-radius': '2px',
	            'color': '#5F5F5F'
	          },
	          placeholder: 'when?',
	          buttons: {
	            ok: 'OK',
	            cancel: 'Cancel'
	          },
	          overlayOpacity: 0.5,
	          dismissible: true
	        };
	      }
	    },
	    limit: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    }
	  },
	  data: function data() {
	    function hours() {
	      var list = [];
	      var hour = 24;
	      while (hour > 0) {
	        hour--;
	        list.push({
	          checked: false,
	          value: hour < 10 ? '0' + hour : hour
	        });
	      }
	      return list;
	    }
	    function mins() {
	      var list = [];
	      var min = 60;
	      while (min > 0) {
	        min--;
	        list.push({
	          checked: false,
	          value: min < 10 ? '0' + min : min
	        });
	      }
	      return list;
	    }
	    return {
	      hours: hours(),
	      mins: mins(),
	      showInfo: {
	        hour: false,
	        day: false,
	        month: false,
	        year: false,
	        check: false
	      },
	      displayInfo: {
	        month: ''
	      },
	      library: {
	        week: this.option.week,
	        month: this.option.month,
	        year: []
	      },
	      checked: {
	        oldtime: '',
	        currentMoment: null,
	        year: '',
	        month: '',
	        day: '',
	        hour: '00',
	        min: '00'
	      },
	      dayList: [],
	      selectedDays: []
	    };
	  },
	
	  methods: {
	    pad: function pad(n) {
	      n = Math.floor(n);
	      return n < 10 ? '0' + n : n;
	    },
	    nextMonth: function nextMonth(type) {
	      var next = null;
	      type === 'next' ? next = (0, _moment2.default)(this.checked.currentMoment).add(1, 'M') : next = (0, _moment2.default)(this.checked.currentMoment).add(-1, 'M');
	      this.showDay(next);
	    },
	    showDay: function showDay(time) {
	      if (time === undefined || !Date.parse(time)) {
	        this.checked.currentMoment = (0, _moment2.default)();
	      } else {
	        this.checked.currentMoment = (0, _moment2.default)(time, this.option.format);
	      }
	      this.showOne('day');
	      this.checked.year = (0, _moment2.default)(this.checked.currentMoment).format('YYYY');
	      this.checked.month = (0, _moment2.default)(this.checked.currentMoment).format('MM');
	      this.checked.day = (0, _moment2.default)(this.checked.currentMoment).format('DD');
	      this.displayInfo.month = this.library.month[(0, _moment2.default)(this.checked.currentMoment).month()];
	      var days = [];
	      var currentMoment = this.checked.currentMoment;
	      var firstDay = (0, _moment2.default)(currentMoment).date(1).day();
	
	      var previousMonth = (0, _moment2.default)(currentMoment);
	      var nextMonth = (0, _moment2.default)(currentMoment);
	      nextMonth.add(1, 'months');
	      previousMonth.subtract(1, 'months');
	      var monthDays = (0, _moment2.default)(currentMoment).daysInMonth();
	      var oldtime = this.checked.oldtime;
	      for (var i = 1; i <= monthDays; ++i) {
	        days.push({
	          value: i,
	          inMonth: true,
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(i)
	        });
	        if (i === Math.ceil((0, _moment2.default)(currentMoment).format('D')) && (0, _moment2.default)(oldtime, this.option.format).year() === (0, _moment2.default)(currentMoment).year() && (0, _moment2.default)(oldtime, this.option.format).month() === (0, _moment2.default)(currentMoment).month()) {
	          days[i - 1].checked = true;
	        }
	        this.checkBySelectDays(i, days);
	      }
	      if (firstDay === 0) firstDay = 7;
	      for (var _i = 0; _i < firstDay - (this.option.SundayFirst ? 0 : 1); _i++) {
	        var passiveDay = {
	          value: previousMonth.daysInMonth() - _i,
	          inMonth: false,
	          action: 'previous',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).date(1).subtract(_i + 1, 'days')
	        };
	        days.unshift(passiveDay);
	      }
	      if (this.limit.length > 0) {
	        var _iteratorNormalCompletion = true;
	        var _didIteratorError = false;
	        var _iteratorError = undefined;
	
	        try {
	          for (var _iterator = (0, _getIterator3.default)(this.limit), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	            var li = _step.value;
	
	            switch (li.type) {
	              case 'fromto':
	                days = this.limitFromTo(li, days);
	                break;
	              case 'weekday':
	                days = this.limitWeekDay(li, days);
	                break;
	            }
	          }
	        } catch (err) {
	          _didIteratorError = true;
	          _iteratorError = err;
	        } finally {
	          try {
	            if (!_iteratorNormalCompletion && _iterator.return) {
	              _iterator.return();
	            }
	          } finally {
	            if (_didIteratorError) {
	              throw _iteratorError;
	            }
	          }
	        }
	      }
	      var passiveDaysAtFinal = 42 - days.length;
	      for (var _i2 = 1; _i2 <= passiveDaysAtFinal; _i2++) {
	        var _passiveDay = {
	          value: _i2,
	          inMonth: false,
	          action: 'next',
	          unavailable: false,
	          checked: false,
	          moment: (0, _moment2.default)(currentMoment).add(1, 'months').date(_i2)
	        };
	        days.push(_passiveDay);
	      }
	      this.dayList = days;
	    },
	    checkBySelectDays: function checkBySelectDays(d, days) {
	      var _this = this;
	
	      this.selectedDays.forEach(function (day) {
	        if (_this.checked.year === (0, _moment2.default)(day).format('YYYY') && _this.checked.month === (0, _moment2.default)(day).format('MM') && d === Math.ceil((0, _moment2.default)(day).format('D'))) {
	          days[d - 1].checked = true;
	        }
	      });
	    },
	    limitWeekDay: function limitWeekDay(limit, days) {
	      days.map(function (day) {
	        if (limit.available.indexOf(Math.floor(day.moment.format('d'))) === -1) {
	          day.unavailable = true;
	        }
	      });
	      return days;
	    },
	    limitFromTo: function limitFromTo(limit, days) {
	      var _this2 = this;
	
	      if (limit.from || limit.to) {
	        days.map(function (day) {
	          if (_this2.getLimitCondition(limit, day)) {
	            day.unavailable = true;
	          }
	        });
	      }
	      return days;
	    },
	    getLimitCondition: function getLimitCondition(limit, day) {
	      var tmpMoment = (0, _moment2.default)(this.checked.year + '-' + this.pad(this.checked.month) + '-' + this.pad(day.value));
	      if (limit.from && !limit.to) {
	        return !tmpMoment.isAfter(limit.from);
	      } else if (!limit.from && limit.to) {
	        return !tmpMoment.isBefore(limit.to);
	      } else {
	        return !tmpMoment.isBetween(limit.from, limit.to);
	      }
	    },
	    checkDay: function checkDay(obj) {
	      if (obj.unavailable || obj.value === '') {
	        return false;
	      }
	      if (!obj.inMonth) {
	        this.nextMonth(obj.action);
	      }
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        this.dayList.forEach(function (x) {
	          x.checked = false;
	        });
	        this.checked.day = this.pad(obj.value);
	        obj.checked = true;
	      } else {
	        var day = this.pad(obj.value);
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + day;
	        if (obj.checked === true) {
	          obj.checked = false;
	          this.selectedDays.$remove(ctime);
	        } else {
	          this.selectedDays.push(ctime);
	          obj.checked = true;
	        }
	      }
	      switch (this.option.type) {
	        case 'day':
	          this.picked();
	          break;
	        case 'min':
	          this.showOne('hour');
	
	          this.shiftActTime();
	          break;
	      }
	    },
	    showYear: function showYear() {
	      var _this3 = this;
	
	      var year = (0, _moment2.default)(this.checked.currentMoment).year();
	      this.library.year = [];
	      var yearTmp = [];
	      for (var i = year - 100; i < year + 5; ++i) {
	        yearTmp.push(i);
	      }
	      this.library.year = yearTmp;
	      this.showOne('year');
	      this.$nextTick(function () {
	        var listDom = document.getElementById('yearList');
	        listDom.scrollTop = listDom.scrollHeight - 100;
	        _this3.addYear();
	      });
	    },
	    showOne: function showOne(type) {
	      switch (type) {
	        case 'year':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = true;
	          this.showInfo.month = false;
	          break;
	        case 'month':
	          this.showInfo.hour = false;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = true;
	          break;
	        case 'day':
	          this.showInfo.hour = false;
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        case 'hour':
	          this.showInfo.hour = true;
	          this.showInfo.day = false;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          break;
	        default:
	          this.showInfo.day = true;
	          this.showInfo.year = false;
	          this.showInfo.month = false;
	          this.showInfo.hour = false;
	      }
	    },
	    showMonth: function showMonth() {
	      this.showOne('month');
	    },
	    addYear: function addYear() {
	      var _this4 = this;
	
	      var listDom = document.getElementById('yearList');
	      listDom.addEventListener('scroll', function (e) {
	        if (listDom.scrollTop < listDom.scrollHeight - 100) {
	          var len = _this4.library.year.length;
	          var lastYear = _this4.library.year[len - 1];
	          _this4.library.year.push(lastYear + 1);
	        }
	      }, false);
	    },
	    setYear: function setYear(year) {
	      this.checked.currentMoment = (0, _moment2.default)(year + '-' + this.checked.month + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    setMonth: function setMonth(month) {
	      var mo = this.library.month.indexOf(month) + 1;
	      if (mo < 10) {
	        mo = '0' + '' + mo;
	      }
	      this.checked.currentMoment = (0, _moment2.default)(this.checked.year + '-' + mo + '-' + this.checked.day);
	      this.showDay(this.checked.currentMoment);
	    },
	    showCheck: function showCheck() {
	      if (this.date.time === '') {
	        this.showDay();
	      } else {
	        if (this.option.type === 'day' || this.option.type === 'min') {
	          this.checked.oldtime = this.date.time;
	          this.showDay(this.date.time);
	        } else {
	          this.selectedDays = JSON.parse(this.date.time);
	          if (this.selectedDays.length) {
	            this.checked.oldtime = this.selectedDays[0];
	            this.showDay(this.selectedDays[0]);
	          } else {
	            this.showDay();
	          }
	        }
	      }
	      this.showInfo.check = true;
	    },
	    setTime: function setTime(type, obj, list) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = (0, _getIterator3.default)(list), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var item = _step2.value;
	
	          item.checked = false;
	          if (item.value === obj.value) {
	            item.checked = true;
	            this.checked[type] = item.value;
	          }
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    },
	    picked: function picked() {
	      if (this.option.type === 'day' || this.option.type === 'min') {
	        var ctime = this.checked.year + '-' + this.checked.month + '-' + this.checked.day + ' ' + this.checked.hour + ':' + this.checked.min;
	        this.checked.currentMoment = (0, _moment2.default)(ctime, 'YYYY-MM-DD HH:mm');
	        this.date.time = (0, _moment2.default)(this.checked.currentMoment).format(this.option.format);
	      } else {
	        this.date.time = (0, _stringify2.default)(this.selectedDays);
	      }
	      this.showInfo.check = false;
	      this.$emit('change', this.date.time);
	    },
	    dismiss: function dismiss(evt) {
	      if (evt.target.className === 'datepicker-overlay') {
	        if (this.option.dismissible === undefined || this.option.dismissible) {
	          this.showInfo.check = false;
	          this.$emit('cancel');
	        }
	      }
	    },
	    shiftActTime: function shiftActTime() {
	      this.$nextTick(function () {
	        if (!document.querySelector('.hour-item.active')) {
	          return false;
	        }
	        document.querySelector('.hour-box').scrollTop = (document.querySelector('.hour-item.active').offsetTop || 0) - 250;
	        document.querySelector('.min-box').scrollTop = (document.querySelector('.min-item.active').offsetTop || 0) - 250;
	      });
	    }
	  }
	};

/***/ }),

/***/ 351:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	exports.default = {
		methods: {
			ifRoute: function ifRoute(name) {
				return name === this.$route.name;
			},
			goToRoute: function goToRoute(name) {
				this.$router.replace({ name: name });
			},
			logout: function logout() {
				var _this = this;
	
				firebase.auth().signOut().then(function () {
					_this.$router.push('/');
				}, function (error) {
					console.log(error);
				});
			},
			getAppName: function getAppName() {
				return firebase.apps[0].options.appName;
			}
		},
		created: function created() {}
	};

/***/ }),

/***/ 352:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _vueStrap = __webpack_require__(306);
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			progressbar: _vueStrap.progressbar
		},
		data: function data() {
			return {
				showVoteNumbers: false,
				notifications: []
			};
		},
	
		methods: {
			notificationPercentage: function notificationPercentage(option, notification) {
				return notification.answerSum > 0 ? (option.answerCount / notification.answerSum * 100).toFixed(2) : 0;
			}
		},
		created: function created() {
			var _this = this;
	
			_FirebaseDBService2.default.getNotifications(function (err, notifications) {
				notifications = _lodash2.default.filter(notifications, function (e) {
					return e.options;
				});
				_this.notifications = notifications.reverse();
	
				firebase.database().ref('/answers').on('value', function (snapshot) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = (0, _getIterator3.default)(_this.notifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var notification = _step.value;
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;
	
							try {
								for (var _iterator2 = (0, _getIterator3.default)(notification.options), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var option = _step2.value;
	
									option.answerCount = 0;
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					console.log(snapshot.val());
	
					for (var userId in snapshot.val()) {
						for (var questionId in snapshot.val()[userId]) {
							var question = _lodash2.default.find(_this.notifications, { fireId: questionId });
							if (question) {
								var optionIndex = parseInt(snapshot.val()[userId][questionId]);
								question.options[optionIndex].answerCount = question.options[optionIndex].answerCount + 1;
							}
						}
					}
	
					_this.notifications = _lodash2.default.map(_this.notifications, function (notification) {
						notification.answerSum = _lodash2.default.sumBy(notification.options, 'answerCount');
						return notification;
					});
	
					console.log(_this.notifications);
				});
			});
		}
	};

/***/ }),

/***/ 353:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports.default = {
		props: ['attachments'],
		data: function data() {
			return {
				attachmentTypes: [{
					label: "E-mail",
					value: "email"
				}, {
					label: "Telefon",
					value: "phone"
				}, {
					label: "Fájl",
					value: "file"
				}, {
					label: "Link",
					value: "link"
				}, {
					label: "Egyéb",
					value: "other"
				}]
			};
		},
	
		methods: {
			newAttachment: function newAttachment() {
				this.attachments.push({
					type: this.attachmentTypes[0],
					value: "",
					name: ""
				});
				this.$forceUpdate();
			}
		}
	};

/***/ }),

/***/ 354:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _ConfliveHelperService = __webpack_require__(348);
	
	var _ConfliveHelperService2 = _interopRequireDefault(_ConfliveHelperService);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueDatepicker = __webpack_require__(304);
	
	var _vueDatepicker2 = _interopRequireDefault(_vueDatepicker);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vueCkeditor = __webpack_require__(303);
	
	var _vueCkeditor2 = _interopRequireDefault(_vueCkeditor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var lastSection;
	var lastDate;
	
	function initalForm() {
		return {
			name: "",
			title: "",
			image: "",
			origin: "",
			description: "",
			isSection: false,
			displayHours: true,
			section: " ",
			fromDate: { time: (0, _moment2.default)().format('YYYY-MM-DD HH:mm') },
			toDate: { time: (0, _moment2.default)().format('YYYY-MM-DD HH:mm') },
			duration: 60,
			attachments: [],
			lecturers: [],
			questions: [],
			hidden: false,
			location: {}
		};
	};
	
	exports.default = {
		components: {
			'date-picker': _vueDatepicker2.default,
			'attachment-block': __webpack_require__(305),
			Ckeditor: _vueCkeditor2.default
		},
		data: function data() {
			return {
				type: 'presentation',
				form: initalForm(),
				option: {
					type: 'min',
					week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
					month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					format: 'YYYY-MM-DD HH:mm',
					placeholder: 'Mikor?'
				},
				uploading: false,
				presentations: [],
				lecturers: [],
				locations: [],
				ckeditor: __webpack_require__(45).default.ckeditor
			};
		},
	
		watch: {
			"form.duration": function formDuration(newVal, oldVal) {
				if (newVal != oldVal) {
					var d = (0, _moment2.default)(this.form.fromDate.time);
					d.add(newVal, "minutes");
					this.form.toDate = { time: d.format('YYYY-MM-DD HH:mm') };
				}
			},
			"form.toDate": function formToDate(newVal, oldVal) {
				this.form.duration = Math.abs((0, _moment2.default)(this.form.fromDate.time).diff((0, _moment2.default)(newVal.time), "minutes"));
			},
			"form.fromDate": function formFromDate(newVal, oldVal) {
				this.form.duration = Math.abs((0, _moment2.default)(newVal.time).diff((0, _moment2.default)(this.form.toDate.time), "minutes"));
			}
		},
		methods: {
			save: function save() {
				var _this = this;
	
				if (this.type === "presentation") {
					var presentation = this.form;
					lastDate = _lodash2.default.clone(presentation.toDate.time);
					presentation.fromDate = (0, _moment2.default)(presentation.fromDate.time).utcOffset((0, _moment2.default)().utcOffset()).toDate().toISOString();
					presentation.toDate = (0, _moment2.default)(presentation.toDate.time).utcOffset((0, _moment2.default)().utcOffset()).toDate().toISOString();
					presentation.lecturers = _lodash2.default.map(presentation.lecturers, function (l) {
						return _lodash2.default.find(_this.lecturers, { value: l }).object;
					});
					_FirebaseDBService2.default.savePresentation(presentation);
					this.$router.replace({ name: 'admin-presentations' });
				} else {
					_FirebaseDBService2.default.saveLecturer(this.form);
					this.$router.replace({ name: 'admin-lecturers' });
				}
			},
			remove: function remove() {
				_FirebaseDBService2.default.deletePresentation(this.form);
				this.$router.replace({ name: 'admin-presentations' });
			},
			removeLecturer: function removeLecturer(index) {
				this.form.lecturers.splice(index, 1);
				this.$forceUpdate();
			},
			uploadImage: function uploadImage(event) {
				var _this2 = this;
	
				var file = event.target.files[0];
				console.log(file);
				this.uploading = true;
				console.log(this.uploading);
				_ConfliveHelperService2.default.uploadImage(file, function (err, response) {
					_this2.form.image = response.file;
					_this2.uploading = false;
				});
			}
		},
		mounted: function mounted() {
			var _this3 = this;
	
			this.type = this.$route.query.type;
			this.form = initalForm();
	
			var id = this.$route.query.id;
	
			if (this.type === "presentation") {
	
				if (id) {
					_FirebaseDBService2.default.getPresentationById(id, function (err, presentation) {
						presentation.lecturers = presentation.lecturers || [];
						presentation.attachments = presentation.attachments || [];
						presentation.location = presentation.location || { fireId: "l0" };
						presentation.section = presentation.section || " ";
						presentation.lecturers = _lodash2.default.map(presentation.lecturers, function (l) {
							return l.fireId;
						});
						presentation.fromDate = { time: (0, _moment2.default)(presentation.fromDate).format('YYYY-MM-DD HH:mm') };
						presentation.toDate = { time: (0, _moment2.default)(presentation.toDate).format('YYYY-MM-DD HH:mm') };
						presentation.isSection = _this3.$route.query.isSection;
						_this3.form = presentation;
					});
				} else {
					this.form.isSection = this.$route.query.isSection;
					if (this.form.isSection) {
						this.form.displayHours = false;
					}
					if (this.$route.query.parentSection) {
						console.log("Called");
						this.form.section = this.$route.query.parentSection;
					}
					console.log("this.form", this.form.section);
	
					if (lastSection) {
						this.form.section = lastSection;
					}
					if (lastDate) {
						this.form.fromDate = { time: (0, _moment2.default)(lastDate).format('YYYY-MM-DD HH:mm') };
						this.form.toDate = { time: (0, _moment2.default)(lastDate).format('YYYY-MM-DD HH:mm') };
					}
				}
	
				_FirebaseDBService2.default.getPresentations(function (err, presentations) {
					presentations = _lodash2.default.orderBy(presentations, "title");
	
					presentations.unshift({
						title: "Nincs megadva",
						fireId: " "
					});
					_this3.presentations = presentations;
				});
	
				_FirebaseDBService2.default.getLecturers(function (err, lecturers) {
					lecturers = _lodash2.default.filter(lecturers, { hidden: false });
					lecturers = _lodash2.default.sortBy(lecturers, "name");
					_this3.lecturers = _lodash2.default.map(lecturers, function (l) {
						var row = {
							label: l.name,
							value: l.fireId,
							object: l
						};
						return row;
					});
				});
	
				_FirebaseDBService2.default.getLocations(function (err, locations) {
					_this3.locations = locations;
				});
			}
	
			if (this.type === "lecturer") {
				if (id) {
					_FirebaseDBService2.default.getLecturerById(id, function (err, lecturer) {
						lecturer.attachments = lecturer.attachments || [];
						_this3.form = lecturer;
						_this3.form.lecturers = [];
					});
				}
			}
		}
	};

/***/ }),

/***/ 355:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _vueCkeditor = __webpack_require__(303);
	
	var _vueCkeditor2 = _interopRequireDefault(_vueCkeditor);
	
	var _geocoder = __webpack_require__(442);
	
	var _geocoder2 = _interopRequireDefault(_geocoder);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function newInformation() {
		return {
			title: "",
			origin: "",
			description: "",
			sponsors: [],
			locations: [],
			attachments: []
		};
	}
	
	exports.default = {
		components: {
			'attachment-block': __webpack_require__(305),
			Ckeditor: _vueCkeditor2.default
		},
		data: function data() {
			return {
				loading: true,
				form: newInformation(),
				locations: [],
	
				sponsorCategories: [{
					label: "Arany",
					value: "gold"
				}, {
					label: "Ezüst",
					value: "silver"
				}, {
					label: "Bronz",
					value: "bronze"
				}],
				ckeditor: __webpack_require__(45).default.ckeditor
			};
		},
	
		methods: {
			newSponsor: function newSponsor() {
				this.form.sponsors.push({
					name: "",
					website: "",
					image: "",
					category: this.sponsorCategories[0]
				});
				this.$forceUpdate();
			},
			newLocation: function newLocation() {
				this.locations.push({
					name: "Budapest",
					longitude: "000",
					latitude: "000"
				});
				this.$forceUpdate();
			},
			removeStuff: function removeStuff(from, what) {
				console.log('Removing');
				_lodash2.default.remove(this.form[from], what);
				this.$forceUpdate();
			},
			removeLocation: function removeLocation(location, index) {
				console.log('Removing');
				_lodash2.default.pullAt(this.locations, index);
				console.log('this.locations', this.locations);
				_FirebaseDBService2.default.deleteLocation(location);
				this.$forceUpdate();
			},
			loadCoords: function loadCoords(location) {
				_geocoder2.default.geocode(location.address + " Hungary", function (err, data) {
					console.log('err', err);
					console.log('data', data);
					if (data.results.length > 0 && data.results[0].geometry) {
						location.latitude = data.results[0].geometry.location.lat;
						location.longitude = data.results[0].geometry.location.lng;
					}
				}, { key: "AIzaSyC0eEisEIsBMH6YYQhboH8-V50olkvQAl8" });
			},
			save: function save() {
	
				_FirebaseDBService2.default.saveInformation(this.form);
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.locations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var location = _step.value;
	
						_FirebaseDBService2.default.saveLocation(location);
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			this.loading = true;
			_FirebaseDBService2.default.getInformation(function (err, informations) {
				if (informations.length > 0) {
					var information = informations[0];
					information.attachments = information.attachments || [];
					information.sponsors = information.sponsors || [];
					information.locations = information.locations || [];
					_this.form = information;
				} else {
					_this.form = newInformation();
				}
				_this.loading = false;
			});
	
			_FirebaseDBService2.default.getLocations(function (err, locations) {
				_this.locations = locations;
			});
		}
	};

/***/ }),

/***/ 356:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				lecturers: []
			};
		},
	
		methods: {
			showEditor: function showEditor() {
				this.$router.push({ name: 'admin-editor', query: { type: 'lecturer' } });
			},
	
			edit: function edit(lecturer) {
				this.$router.push({ name: 'admin-editor', query: { type: 'lecturer', id: lecturer.fireId } });
			},
			remove: function remove(lecturer) {
				_FirebaseDBService2.default.deleteLecturer(lecturer);
			}
		},
		mounted: function mounted() {
			var _this = this;
	
			_FirebaseDBService2.default.getLecturers(function (err, lecturers) {
				_this.lecturers = _lodash2.default.sortBy(lecturers, "name");
			});
		}
	};

/***/ }),

/***/ 357:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _FCMService = __webpack_require__(349);
	
	var _FCMService2 = _interopRequireDefault(_FCMService);
	
	var _generated = __webpack_require__(115);
	
	var _generated2 = _interopRequireDefault(_generated);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueDatepicker = __webpack_require__(304);
	
	var _vueDatepicker2 = _interopRequireDefault(_vueDatepicker);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		components: {
			'date-picker': _vueDatepicker2.default
		},
		data: function data() {
			return {
				notifications: [],
				option: {
					type: 'min',
					week: ['Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa', 'Su'],
					month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
					format: 'YYYY-MM-DD HH:mm',
					placeholder: 'Mikor?'
				},
				limit: []
			};
		},
	
		methods: {
			createNotification: function createNotification() {
				var notification = new _generated2.default.Question();
				notification.published = false;
				notification.type = "notification";
				notification.saved = false;
				notification.targetDate = {
					time: (0, _moment2.default)().format('YYYY-MM-DD HH:mm')
				};
				this.notifications.unshift(notification);
			},
			saveNotification: function saveNotification(notification) {
				if (!notification.createdAt) {
					notification.createdAt = new Date().toISOString();
				}
				notification.updatedAt = new Date().toISOString();
				notification.targetDate = (0, _moment2.default)(notification.targetDate.time).utcOffset((0, _moment2.default)().utcOffset()).toDate().toISOString();
				_FirebaseDBService2.default.saveNotification(notification);
				this.$set(notification, 'saved', true);
				this.reload();
			},
			pushNotification: function pushNotification(notification) {
				_FCMService2.default.sendGlobalNotification(notification, function (err) {
					console.log(err);
				});
			},
			addOption: function addOption(notification) {
				if (!notification.options) {
					this.$set(notification, 'options', []);
				}
				notification.options.push({});
			},
			deleteNotification: function deleteNotification(notification) {
				_FirebaseDBService2.default.deleteNotification(notification);
				this.notifications.splice(this.notifications.indexOf(notification), 1);
			},
			reload: function reload() {
				var _this = this;
	
				_FirebaseDBService2.default.getNotifications(function (err, notifications) {
					var _iteratorNormalCompletion = true;
					var _didIteratorError = false;
					var _iteratorError = undefined;
	
					try {
						for (var _iterator = (0, _getIterator3.default)(notifications), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
							var notification = _step.value;
	
							notification.targetDate = { time: (0, _moment2.default)(notification.targetDate).format('YYYY-MM-DD HH:mm') };
							console.log(notification.targetDate);
						}
					} catch (err) {
						_didIteratorError = true;
						_iteratorError = err;
					} finally {
						try {
							if (!_iteratorNormalCompletion && _iterator.return) {
								_iterator.return();
							}
						} finally {
							if (_didIteratorError) {
								throw _iteratorError;
							}
						}
					}
	
					_this.notifications = notifications.reverse();
				});
			}
		},
		created: function created() {
			this.reload();
		}
	};

/***/ }),

/***/ 358:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		name: "presentation-row",
		props: {
			presentation: Object,
			depth: 0,
			open: false
		},
		methods: {
			switchOpen: function switchOpen() {
				this.open = !this.open;
				var openSections = JSON.parse(_vue2.default.localStorage.get('openSections', '{}'));
				openSections[this.presentation.fireId] = !openSections[this.presentation.fireId];
				_vue2.default.localStorage.set('openSections', (0, _stringify2.default)(openSections));
			},
			formatedDate: function formatedDate(date) {
				return (0, _moment2.default)(date).format("YYYY MMMM DD.");
			},
			formatedTime: function formatedTime(date) {
				return (0, _moment2.default)(date).format("HH:mm");
			},
			edit: function edit(presentation) {
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', id: presentation.fireId, isSection: presentation.isSection } });
			},
			create: function create(parent, isSection) {
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', parentSection: parent, isSection: isSection } });
			},
	
			remove: function remove(presentation) {
				_FirebaseDBService2.default.deletePresentation(presentation);
			}
		},
		mounted: function mounted() {
			var openSections = JSON.parse(_vue2.default.localStorage.get('openSections', '{}'));
			if (openSections[this.presentation.fireId]) {
				this.open = true;
			}
		}
	};

/***/ }),

/***/ 359:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _stringify = __webpack_require__(61);
	
	var _stringify2 = _interopRequireDefault(_stringify);
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _FirebaseDBService = __webpack_require__(24);
	
	var _FirebaseDBService2 = _interopRequireDefault(_FirebaseDBService);
	
	var _moment = __webpack_require__(1);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _lodash = __webpack_require__(43);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var colors = ["#00a8ff", "#4cd137", "#487eb0", "#e84118", "#9c88ff", "#273c75", "#fbc531"];
	
	exports.default = {
		components: {
			'presentation-row': __webpack_require__(544)
		},
		data: function data() {
			return {
				presentations: [],
				rootPresentations: [],
				sectionCollapsed: [],
				sectionColor: {},
				ratings: {},
				comments: {},
				date: (0, _moment2.default)().format("MMMM Do YYYY")
			};
		},
	
		methods: {
			loadData: function loadData() {
				var _this = this;
	
				_FirebaseDBService2.default.rawGet("comments", function (err, comments) {
					_this.comments = comments;
	
					_FirebaseDBService2.default.rawGet("ratings", function (err, ratings) {
						_this.ratings = ratings;
	
						_FirebaseDBService2.default.getPresentations(function (err, presentations) {
							_this.presentations = _lodash2.default.orderBy(presentations, "fromDate");
	
							var sectionIds = _lodash2.default.chain(_this.presentations).map("section").filter(_lodash2.default.isString).uniq().value();
							_this.presentations = _lodash2.default.map(_this.presentations, function (p) {
								if (p.isSection === undefined) {
									p.isSection = _lodash2.default.includes(sectionIds, p.fireId);
								}
								return p;
							});
	
							console.log("ratings", ratings);
							console.log("comments", comments);
	
							var _iteratorNormalCompletion = true;
							var _didIteratorError = false;
							var _iteratorError = undefined;
	
							try {
								for (var _iterator = (0, _getIterator3.default)(_this.presentations), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
									var presentation = _step.value;
	
									presentation.ratingCount = 0;
									presentation.ratingAvg = 0;
									presentation.ratings = {};
									presentation.comments = {};
								}
							} catch (err) {
								_didIteratorError = true;
								_iteratorError = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion && _iterator.return) {
										_iterator.return();
									}
								} finally {
									if (_didIteratorError) {
										throw _iteratorError;
									}
								}
							}
	
							for (var userId in comments) {
								for (var presentationId in comments[userId]) {
									var presentation = _lodash2.default.find(_this.presentations, { "fireId": presentationId });
									if (presentation) {
										if (comments[userId][presentationId].length > 1) {
											presentation.comments[userId] = comments[userId][presentationId];
										}
									}
								}
							}
	
							for (var userId in ratings) {
								for (var presentationId in ratings[userId]) {
									var presentation = _lodash2.default.find(presentations, { "fireId": presentationId });
									if (presentation) {
										presentation.ratingCount += 1;
										presentation.ratingAvg += ratings[userId][presentationId];
										presentation.ratings[userId] = ratings[userId][presentationId];
									}
								}
							}
	
							console.log("this.presentations", (0, _stringify2.default)(_this.presentations));
	
							var _iteratorNormalCompletion2 = true;
							var _didIteratorError2 = false;
							var _iteratorError2 = undefined;
	
							try {
								for (var _iterator2 = (0, _getIterator3.default)(presentations), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
									var presentation = _step2.value;
	
									if (presentation.ratingCount > 0) {
										presentation.ratingAvg = (presentation.ratingAvg / presentation.ratingCount).toFixed(2);
									}
								}
							} catch (err) {
								_didIteratorError2 = true;
								_iteratorError2 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion2 && _iterator2.return) {
										_iterator2.return();
									}
								} finally {
									if (_didIteratorError2) {
										throw _iteratorError2;
									}
								}
							}
	
							var sectionIndex = 0;
							var _iteratorNormalCompletion3 = true;
							var _didIteratorError3 = false;
							var _iteratorError3 = undefined;
	
							try {
								for (var _iterator3 = (0, _getIterator3.default)(presentations), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
									var presentation = _step3.value;
	
									presentation.key = presentation.fireId;
									var section = _lodash2.default.findLast(presentations, { fireId: presentation.section });
									if (section) {
										if (!section.presentations) {
											_this.sectionCollapsed[section.fireId] = true;
											_this.sectionColor[section.fireId] = colors[sectionIndex % colors.length];
											section.presentations = [];
											sectionIndex++;
										}
										section.presentations.push(presentation);
									} else {
										_this.rootPresentations.push(presentation);
									}
								}
							} catch (err) {
								_didIteratorError3 = true;
								_iteratorError3 = err;
							} finally {
								try {
									if (!_iteratorNormalCompletion3 && _iterator3.return) {
										_iterator3.return();
									}
								} finally {
									if (_didIteratorError3) {
										throw _iteratorError3;
									}
								}
							}
						});
					});
				});
			},
			goToRoute: function goToRoute(name) {
				this.$router.replace({ name: name });
			},
			create: function create(isSection) {
				this.$router.push({ name: 'admin-editor', query: { type: 'presentation', isSection: isSection } });
			},
	
			countRatings: function countRatings(presentation) {
				var count = 0;
				for (var key in presentation.ratings) {
					count += presentation.ratings[key];
				}
				return count;
			},
			sumRatings: function sumRatings(presentation) {
				var sum = 0;
				for (var key in presentation.ratings) {
					sum += key * presentation.ratings[key];
				}
				return sum;
			}
		},
		mounted: function mounted() {
			this.loadData();
		}
	};

/***/ }),

/***/ 360:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _vue = __webpack_require__(15);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueStrap = __webpack_require__(306);
	
	var _firebase = __webpack_require__(42);
	
	var firebase = _interopRequireWildcard(_firebase);
	
	var _config = __webpack_require__(45);
	
	var _config2 = _interopRequireDefault(_config);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timer = undefined;
	
	exports.default = {
		components: {
			bsInput: _vueStrap.input
		},
		data: function data() {
			return {
				email: "",
				password: "",
				errorCode: "",
				errorMessage: "",
				project: _config2.default.default,
				firebaseConfig: _config2.default.firebaseConfig
			};
		},
	
		methods: {
			login: function login() {
				var _this = this;
	
				firebase.auth().signInWithEmailAndPassword(this.email, this.password).then(function (user) {
					_this.$router.push('/admin');
				}).catch(function (error) {
					console.log(error.code);
					_this.errorCode = error.code;
				});
			}
		},
		watch: {
			project: function project(val) {
				console.log(val);
				_vue2.default.localStorage.set('project', val);
				firebase.app().delete().then(function () {
					firebase.initializeApp(_config2.default.firebaseConfig[val]);
				});
			}
		},
		created: function created() {
			var _this2 = this;
	
			var user = firebase.auth().currentUser;
	
			if (user) {
				console.log("ok");
				this.$router.push('/admin');
			} else {
				console.log("notok");
			}
	
			firebase.auth().onAuthStateChanged(function (user) {
				if (user) {
					_this2.$router.push('/admin');
				} else {
					console.log("Probably logged out");
				}
			});
		}
	};

/***/ }),

/***/ 361:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	
	var _getIterator2 = __webpack_require__(35);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
		data: function data() {
			return {
				sponsors: [{
					"booths": [19, 20, 22],
					"company": "Raynet Kft.",
					"website": "http://raynet.hu"
				}, {
					"booths": [16],
					"company": "EL-CO Tech Kft.",
					"website": "http://elocotech.hu"
				}, {
					"booths": [5],
					"company": "Hauff-Technik Hungária Kft.",
					"website": "http://hauff-technik.hu"
				}, {
					"booths": [18],
					"company": "Megawatt Mérnökiroda Kft.",
					"website": "http://mwmi.hu"
				}, {
					"booths": [4],
					"company": "Maxicont Kft. / Megger Hungária Kft.",
					"website": "http://maxicont.hu"
				}, {
					"booths": [26],
					"company": "Weidmüller Kft.",
					"website": "http://weidmueller.com"
				}, {
					"booths": [28],
					"company": "TE Connectivity",
					"website": "http://te.com"
				}, {
					"booths": [6],
					"company": "Omexom Magyarország Kft.",
					"website": "http://omexom.hu"
				}, {
					"booths": [30],
					"company": "HOFEKA Kft.",
					"website": "http://hofeka.hu"
				}, {
					"booths": [13],
					"company": "Enersys Kft.",
					"website": "http://enersys.com"
				}, {
					"booths": [27],
					"company": "Prolan Innolab Kft.",
					"website": "http://prolaninnolab.hu"
				}, {
					"booths": [31],
					"company": "PHOENIX CONTACT Kft.",
					"website": "http://phoenixcontact.com"
				}, {
					"booths": [2, 3],
					"company": "Ganz Mérőgyár Kft.",
					"website": "http://itron.com"
				}, {
					"booths": [29],
					"company": "Ekofluid sro",
					"website": "http://ekofluid.com"
				}, {
					"booths": [12],
					"company": "FirePro Hungary Kft.",
					"website": "http://firepro.hu"
				}, {
					"booths": [24],
					"company": "Villbek Kft.",
					"website": "http://villbek.hu"
				}, {
					"booths": [7],
					"company": "C+D Automatika Kft.",
					"website": "http://meter.hu"
				}, {
					"booths": [25],
					"company": "WAGO Hungária Kft.",
					"website": "http://wago.com"
				}, {
					"booths": [32, 33, 34],
					"company": "Geometria Kft.",
					"website": "http://geometria.hu"
				}, {
					"booths": [1],
					"company": "Diagnostics Kft.",
					"website": "http://diagnostics.hu"
				}, {
					"booths": [8, 9, 10],
					"company": "Marchiol Kft.",
					"website": "http://marchiol.hu"
				}, {
					"booths": [35],
					"company": "Technikatörténeti Bizottság",
					"website": "http://www.mee.hu/ttb"
				}, {
					"booths": [23],
					"company": "Hensel Hungária Kft.",
					"website": "http://www.hensel.hu"
				}, {
					"booths": [36],
					"company": "Better és Better Bt",
					"website": "http://betterbt.hu/"
				}],
				selectedSponsor: undefined
			};
		},
	
		methods: {
			areaSelected: function areaSelected($event, index) {
				event.preventDefault();
				this.selectedSponsor = undefined;
				var _iteratorNormalCompletion = true;
				var _didIteratorError = false;
				var _iteratorError = undefined;
	
				try {
					for (var _iterator = (0, _getIterator3.default)(this.sponsors), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
						var sponsor = _step.value;
	
						if (sponsor.booths.includes(index)) {
							this.selectedSponsor = sponsor;
							break;
						}
					}
				} catch (err) {
					_didIteratorError = true;
					_iteratorError = err;
				} finally {
					try {
						if (!_iteratorNormalCompletion && _iterator.return) {
							_iterator.return();
						}
					} finally {
						if (_didIteratorError) {
							throw _iteratorError;
						}
					}
				}
	
				this.pickerIndex = index - 1;
				console.log(event.target.coords.split(','));
				var mapRect = document.getElementById("image-map").getBoundingClientRect();
				var coords = event.target.coords.split(',');
				var x1 = parseInt(coords[0]);
				var y1 = parseInt(coords[1]);
				var x2 = parseInt(coords[2]);
				var y2 = parseInt(coords[3]);
	
				console.log(mapRect);
				var tooltip = document.getElementById("tooltip");
	
				var middleX = (x1 + x2) / 2;
				var middleY = (y1 + y2) / 2;
	
				tooltip.style.left = middleX + 'px';
				tooltip.style.top = middleY + 'px';
				tooltip.style.opacity = 1;
	
				var rect = event.target.getBoundingClientRect();
				console.log(rect.left + window.scrollX);
				console.log(rect.top + window.scrollY);
			}
		},
		created: function created() {
			console.log("appId", this.$route.params.appId);
		},
		mounted: function mounted() {
			console.log("asd", imageMapResize());
		}
	};

/***/ }),

/***/ 418:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 419:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 420:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 421:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 422:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 423:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 424:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 425:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 427:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 428:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 429:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 430:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 431:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 432:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 433:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 434:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 435:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 443:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./geonames": 150,
		"./geonames.js": 150,
		"./google": 151,
		"./google.js": 151,
		"./yahoo": 152,
		"./yahoo.js": 152
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 443;


/***/ }),

/***/ 454:
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"https://raw.githubusercontent.com/epoberezkin/ajv/master/lib/refs/$data.json#","description":"Meta-schema for $data reference (JSON-schema extension proposal)","type":"object","required":["$data"],"properties":{"$data":{"type":"string","anyOf":[{"format":"relative-json-pointer"},{"format":"json-pointer"}]}},"additionalProperties":false}

/***/ }),

/***/ 455:
/***/ (function(module, exports) {

	module.exports = {"$schema":"http://json-schema.org/draft-06/schema#","$id":"http://json-schema.org/draft-06/schema#","title":"Core schema meta-schema","definitions":{"schemaArray":{"type":"array","minItems":1,"items":{"$ref":"#"}},"nonNegativeInteger":{"type":"integer","minimum":0},"nonNegativeIntegerDefault0":{"allOf":[{"$ref":"#/definitions/nonNegativeInteger"},{"default":0}]},"simpleTypes":{"enum":["array","boolean","integer","null","number","object","string"]},"stringArray":{"type":"array","items":{"type":"string"},"uniqueItems":true,"default":[]}},"type":["object","boolean"],"properties":{"$id":{"type":"string","format":"uri-reference"},"$schema":{"type":"string","format":"uri"},"$ref":{"type":"string","format":"uri-reference"},"title":{"type":"string"},"description":{"type":"string"},"default":{},"examples":{"type":"array","items":{}},"multipleOf":{"type":"number","exclusiveMinimum":0},"maximum":{"type":"number"},"exclusiveMaximum":{"type":"number"},"minimum":{"type":"number"},"exclusiveMinimum":{"type":"number"},"maxLength":{"$ref":"#/definitions/nonNegativeInteger"},"minLength":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"pattern":{"type":"string","format":"regex"},"additionalItems":{"$ref":"#"},"items":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/schemaArray"}],"default":{}},"maxItems":{"$ref":"#/definitions/nonNegativeInteger"},"minItems":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"uniqueItems":{"type":"boolean","default":false},"contains":{"$ref":"#"},"maxProperties":{"$ref":"#/definitions/nonNegativeInteger"},"minProperties":{"$ref":"#/definitions/nonNegativeIntegerDefault0"},"required":{"$ref":"#/definitions/stringArray"},"additionalProperties":{"$ref":"#"},"definitions":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"properties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"patternProperties":{"type":"object","additionalProperties":{"$ref":"#"},"default":{}},"dependencies":{"type":"object","additionalProperties":{"anyOf":[{"$ref":"#"},{"$ref":"#/definitions/stringArray"}]}},"propertyNames":{"$ref":"#"},"const":{},"enum":{"type":"array","minItems":1,"uniqueItems":true},"type":{"anyOf":[{"$ref":"#/definitions/simpleTypes"},{"type":"array","items":{"$ref":"#/definitions/simpleTypes"},"minItems":1,"uniqueItems":true}]},"format":{"type":"string"},"allOf":{"$ref":"#/definitions/schemaArray"},"anyOf":{"$ref":"#/definitions/schemaArray"},"oneOf":{"$ref":"#/definitions/schemaArray"},"not":{"$ref":"#"}},"default":{}}

/***/ }),

/***/ 456:
/***/ (function(module, exports) {

	module.exports = {"$id":"afterRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 457:
/***/ (function(module, exports) {

	module.exports = {"$id":"beforeRequest.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["lastAccess","eTag","hitCount"],"properties":{"expires":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"lastAccess":{"type":"string","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))?"},"eTag":{"type":"string"},"hitCount":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 458:
/***/ (function(module, exports) {

	module.exports = {"$id":"browser.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 459:
/***/ (function(module, exports) {

	module.exports = {"$id":"cache.json#","$schema":"http://json-schema.org/draft-06/schema#","properties":{"beforeRequest":{"oneOf":[{"type":"null"},{"$ref":"beforeRequest.json#"}]},"afterRequest":{"oneOf":[{"type":"null"},{"$ref":"afterRequest.json#"}]},"comment":{"type":"string"}}}

/***/ }),

/***/ 460:
/***/ (function(module, exports) {

	module.exports = {"$id":"content.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["size","mimeType"],"properties":{"size":{"type":"integer"},"compression":{"type":"integer"},"mimeType":{"type":"string"},"text":{"type":"string"},"encoding":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 461:
/***/ (function(module, exports) {

	module.exports = {"$id":"cookie.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"path":{"type":"string"},"domain":{"type":"string"},"expires":{"type":["string","null"],"format":"date-time"},"httpOnly":{"type":"boolean"},"secure":{"type":"boolean"},"comment":{"type":"string"}}}

/***/ }),

/***/ 462:
/***/ (function(module, exports) {

	module.exports = {"$id":"creator.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","version"],"properties":{"name":{"type":"string"},"version":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 463:
/***/ (function(module, exports) {

	module.exports = {"$id":"entry.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","time","request","response","cache","timings"],"properties":{"pageref":{"type":"string"},"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"time":{"type":"number","min":0},"request":{"$ref":"request.json#"},"response":{"$ref":"response.json#"},"cache":{"$ref":"cache.json#"},"timings":{"$ref":"timings.json#"},"serverIPAddress":{"type":"string","oneOf":[{"format":"ipv4"},{"format":"ipv6"}]},"connection":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 464:
/***/ (function(module, exports) {

	module.exports = {"$id":"har.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["log"],"properties":{"log":{"$ref":"log.json#"}}}

/***/ }),

/***/ 465:
/***/ (function(module, exports) {

	module.exports = {"$id":"header.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 466:
/***/ (function(module, exports) {

	module.exports = {"$id":"log.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["version","creator","entries"],"properties":{"version":{"type":"string"},"creator":{"$ref":"creator.json#"},"browser":{"$ref":"browser.json#"},"pages":{"type":"array","items":{"$ref":"page.json#"}},"entries":{"type":"array","items":{"$ref":"entry.json#"}},"comment":{"type":"string"}}}

/***/ }),

/***/ 467:
/***/ (function(module, exports) {

	module.exports = {"$id":"page.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["startedDateTime","id","title","pageTimings"],"properties":{"startedDateTime":{"type":"string","format":"date-time","pattern":"^(\\d{4})(-)?(\\d\\d)(-)?(\\d\\d)(T)?(\\d\\d)(:)?(\\d\\d)(:)?(\\d\\d)(\\.\\d+)?(Z|([+-])(\\d\\d)(:)?(\\d\\d))"},"id":{"type":"string","unique":true},"title":{"type":"string"},"pageTimings":{"$ref":"pageTimings.json#"},"comment":{"type":"string"}}}

/***/ }),

/***/ 468:
/***/ (function(module, exports) {

	module.exports = {"$id":"pageTimings.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","properties":{"onContentLoad":{"type":"number","min":-1},"onLoad":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),

/***/ 469:
/***/ (function(module, exports) {

	module.exports = {"$id":"postData.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","optional":true,"required":["mimeType"],"properties":{"mimeType":{"type":"string"},"text":{"type":"string"},"params":{"type":"array","required":["name"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"fileName":{"type":"string"},"contentType":{"type":"string"},"comment":{"type":"string"}}},"comment":{"type":"string"}}}

/***/ }),

/***/ 470:
/***/ (function(module, exports) {

	module.exports = {"$id":"query.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["name","value"],"properties":{"name":{"type":"string"},"value":{"type":"string"},"comment":{"type":"string"}}}

/***/ }),

/***/ 471:
/***/ (function(module, exports) {

	module.exports = {"$id":"request.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["method","url","httpVersion","cookies","headers","queryString","headersSize","bodySize"],"properties":{"method":{"type":"string"},"url":{"type":"string","format":"uri"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"queryString":{"type":"array","items":{"$ref":"query.json#"}},"postData":{"$ref":"postData.json#"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 472:
/***/ (function(module, exports) {

	module.exports = {"$id":"response.json#","$schema":"http://json-schema.org/draft-06/schema#","type":"object","required":["status","statusText","httpVersion","cookies","headers","content","redirectURL","headersSize","bodySize"],"properties":{"status":{"type":"integer"},"statusText":{"type":"string"},"httpVersion":{"type":"string"},"cookies":{"type":"array","items":{"$ref":"cookie.json#"}},"headers":{"type":"array","items":{"$ref":"header.json#"}},"content":{"$ref":"content.json#"},"redirectURL":{"type":"string"},"headersSize":{"type":"integer"},"bodySize":{"type":"integer"},"comment":{"type":"string"}}}

/***/ }),

/***/ 473:
/***/ (function(module, exports) {

	module.exports = {"$id":"timings.json#","$schema":"http://json-schema.org/draft-06/schema#","required":["send","wait","receive"],"properties":{"dns":{"type":"number","min":-1},"connect":{"type":"number","min":-1},"blocked":{"type":"number","min":-1},"send":{"type":"number","min":-1},"wait":{"type":"number","min":-1},"receive":{"type":"number","min":-1},"ssl":{"type":"number","min":-1},"comment":{"type":"string"}}}

/***/ }),

/***/ 474:
/***/ (function(module, exports) {

	module.exports = {"application/1d-interleaved-parityfec":{"source":"iana"},"application/3gpdash-qoe-report+xml":{"source":"iana"},"application/3gpp-ims+xml":{"source":"iana"},"application/a2l":{"source":"iana"},"application/activemessage":{"source":"iana"},"application/alto-costmap+json":{"source":"iana","compressible":true},"application/alto-costmapfilter+json":{"source":"iana","compressible":true},"application/alto-directory+json":{"source":"iana","compressible":true},"application/alto-endpointcost+json":{"source":"iana","compressible":true},"application/alto-endpointcostparams+json":{"source":"iana","compressible":true},"application/alto-endpointprop+json":{"source":"iana","compressible":true},"application/alto-endpointpropparams+json":{"source":"iana","compressible":true},"application/alto-error+json":{"source":"iana","compressible":true},"application/alto-networkmap+json":{"source":"iana","compressible":true},"application/alto-networkmapfilter+json":{"source":"iana","compressible":true},"application/aml":{"source":"iana"},"application/andrew-inset":{"source":"iana","extensions":["ez"]},"application/applefile":{"source":"iana"},"application/applixware":{"source":"apache","extensions":["aw"]},"application/atf":{"source":"iana"},"application/atfx":{"source":"iana"},"application/atom+xml":{"source":"iana","compressible":true,"extensions":["atom"]},"application/atomcat+xml":{"source":"iana","extensions":["atomcat"]},"application/atomdeleted+xml":{"source":"iana"},"application/atomicmail":{"source":"iana"},"application/atomsvc+xml":{"source":"iana","extensions":["atomsvc"]},"application/atxml":{"source":"iana"},"application/auth-policy+xml":{"source":"iana"},"application/bacnet-xdd+zip":{"source":"iana"},"application/batch-smtp":{"source":"iana"},"application/bdoc":{"compressible":false,"extensions":["bdoc"]},"application/beep+xml":{"source":"iana"},"application/calendar+json":{"source":"iana","compressible":true},"application/calendar+xml":{"source":"iana"},"application/call-completion":{"source":"iana"},"application/cals-1840":{"source":"iana"},"application/cbor":{"source":"iana"},"application/cccex":{"source":"iana"},"application/ccmp+xml":{"source":"iana"},"application/ccxml+xml":{"source":"iana","extensions":["ccxml"]},"application/cdfx+xml":{"source":"iana"},"application/cdmi-capability":{"source":"iana","extensions":["cdmia"]},"application/cdmi-container":{"source":"iana","extensions":["cdmic"]},"application/cdmi-domain":{"source":"iana","extensions":["cdmid"]},"application/cdmi-object":{"source":"iana","extensions":["cdmio"]},"application/cdmi-queue":{"source":"iana","extensions":["cdmiq"]},"application/cdni":{"source":"iana"},"application/cea":{"source":"iana"},"application/cea-2018+xml":{"source":"iana"},"application/cellml+xml":{"source":"iana"},"application/cfw":{"source":"iana"},"application/clue_info+xml":{"source":"iana"},"application/cms":{"source":"iana"},"application/cnrp+xml":{"source":"iana"},"application/coap-group+json":{"source":"iana","compressible":true},"application/coap-payload":{"source":"iana"},"application/commonground":{"source":"iana"},"application/conference-info+xml":{"source":"iana"},"application/cose":{"source":"iana"},"application/cose-key":{"source":"iana"},"application/cose-key-set":{"source":"iana"},"application/cpl+xml":{"source":"iana"},"application/csrattrs":{"source":"iana"},"application/csta+xml":{"source":"iana"},"application/cstadata+xml":{"source":"iana"},"application/csvm+json":{"source":"iana","compressible":true},"application/cu-seeme":{"source":"apache","extensions":["cu"]},"application/cybercash":{"source":"iana"},"application/dart":{"compressible":true},"application/dash+xml":{"source":"iana","extensions":["mpd"]},"application/dashdelta":{"source":"iana"},"application/davmount+xml":{"source":"iana","extensions":["davmount"]},"application/dca-rft":{"source":"iana"},"application/dcd":{"source":"iana"},"application/dec-dx":{"source":"iana"},"application/dialog-info+xml":{"source":"iana"},"application/dicom":{"source":"iana"},"application/dicom+json":{"source":"iana","compressible":true},"application/dicom+xml":{"source":"iana"},"application/dii":{"source":"iana"},"application/dit":{"source":"iana"},"application/dns":{"source":"iana"},"application/docbook+xml":{"source":"apache","extensions":["dbk"]},"application/dskpp+xml":{"source":"iana"},"application/dssc+der":{"source":"iana","extensions":["dssc"]},"application/dssc+xml":{"source":"iana","extensions":["xdssc"]},"application/dvcs":{"source":"iana"},"application/ecmascript":{"source":"iana","compressible":true,"extensions":["ecma"]},"application/edi-consent":{"source":"iana"},"application/edi-x12":{"source":"iana","compressible":false},"application/edifact":{"source":"iana","compressible":false},"application/efi":{"source":"iana"},"application/emergencycalldata.comment+xml":{"source":"iana"},"application/emergencycalldata.control+xml":{"source":"iana"},"application/emergencycalldata.deviceinfo+xml":{"source":"iana"},"application/emergencycalldata.ecall.msd":{"source":"iana"},"application/emergencycalldata.providerinfo+xml":{"source":"iana"},"application/emergencycalldata.serviceinfo+xml":{"source":"iana"},"application/emergencycalldata.subscriberinfo+xml":{"source":"iana"},"application/emergencycalldata.veds+xml":{"source":"iana"},"application/emma+xml":{"source":"iana","extensions":["emma"]},"application/emotionml+xml":{"source":"iana"},"application/encaprtp":{"source":"iana"},"application/epp+xml":{"source":"iana"},"application/epub+zip":{"source":"iana","extensions":["epub"]},"application/eshop":{"source":"iana"},"application/exi":{"source":"iana","extensions":["exi"]},"application/fastinfoset":{"source":"iana"},"application/fastsoap":{"source":"iana"},"application/fdt+xml":{"source":"iana"},"application/fhir+xml":{"source":"iana"},"application/fido.trusted-apps+json":{"compressible":true},"application/fits":{"source":"iana"},"application/font-sfnt":{"source":"iana"},"application/font-tdpfr":{"source":"iana","extensions":["pfr"]},"application/font-woff":{"source":"iana","compressible":false,"extensions":["woff"]},"application/framework-attributes+xml":{"source":"iana"},"application/geo+json":{"source":"iana","compressible":true,"extensions":["geojson"]},"application/geo+json-seq":{"source":"iana"},"application/geoxacml+xml":{"source":"iana"},"application/gml+xml":{"source":"iana","extensions":["gml"]},"application/gpx+xml":{"source":"apache","extensions":["gpx"]},"application/gxf":{"source":"apache","extensions":["gxf"]},"application/gzip":{"source":"iana","compressible":false,"extensions":["gz"]},"application/h224":{"source":"iana"},"application/held+xml":{"source":"iana"},"application/hjson":{"extensions":["hjson"]},"application/http":{"source":"iana"},"application/hyperstudio":{"source":"iana","extensions":["stk"]},"application/ibe-key-request+xml":{"source":"iana"},"application/ibe-pkg-reply+xml":{"source":"iana"},"application/ibe-pp-data":{"source":"iana"},"application/iges":{"source":"iana"},"application/im-iscomposing+xml":{"source":"iana"},"application/index":{"source":"iana"},"application/index.cmd":{"source":"iana"},"application/index.obj":{"source":"iana"},"application/index.response":{"source":"iana"},"application/index.vnd":{"source":"iana"},"application/inkml+xml":{"source":"iana","extensions":["ink","inkml"]},"application/iotp":{"source":"iana"},"application/ipfix":{"source":"iana","extensions":["ipfix"]},"application/ipp":{"source":"iana"},"application/isup":{"source":"iana"},"application/its+xml":{"source":"iana"},"application/java-archive":{"source":"apache","compressible":false,"extensions":["jar","war","ear"]},"application/java-serialized-object":{"source":"apache","compressible":false,"extensions":["ser"]},"application/java-vm":{"source":"apache","compressible":false,"extensions":["class"]},"application/javascript":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["js","mjs"]},"application/jf2feed+json":{"source":"iana","compressible":true},"application/jose":{"source":"iana"},"application/jose+json":{"source":"iana","compressible":true},"application/jrd+json":{"source":"iana","compressible":true},"application/json":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["json","map"]},"application/json-patch+json":{"source":"iana","compressible":true},"application/json-seq":{"source":"iana"},"application/json5":{"extensions":["json5"]},"application/jsonml+json":{"source":"apache","compressible":true,"extensions":["jsonml"]},"application/jwk+json":{"source":"iana","compressible":true},"application/jwk-set+json":{"source":"iana","compressible":true},"application/jwt":{"source":"iana"},"application/kpml-request+xml":{"source":"iana"},"application/kpml-response+xml":{"source":"iana"},"application/ld+json":{"source":"iana","compressible":true,"extensions":["jsonld"]},"application/lgr+xml":{"source":"iana"},"application/link-format":{"source":"iana"},"application/load-control+xml":{"source":"iana"},"application/lost+xml":{"source":"iana","extensions":["lostxml"]},"application/lostsync+xml":{"source":"iana"},"application/lxf":{"source":"iana"},"application/mac-binhex40":{"source":"iana","extensions":["hqx"]},"application/mac-compactpro":{"source":"apache","extensions":["cpt"]},"application/macwriteii":{"source":"iana"},"application/mads+xml":{"source":"iana","extensions":["mads"]},"application/manifest+json":{"charset":"UTF-8","compressible":true,"extensions":["webmanifest"]},"application/marc":{"source":"iana","extensions":["mrc"]},"application/marcxml+xml":{"source":"iana","extensions":["mrcx"]},"application/mathematica":{"source":"iana","extensions":["ma","nb","mb"]},"application/mathml+xml":{"source":"iana","extensions":["mathml"]},"application/mathml-content+xml":{"source":"iana"},"application/mathml-presentation+xml":{"source":"iana"},"application/mbms-associated-procedure-description+xml":{"source":"iana"},"application/mbms-deregister+xml":{"source":"iana"},"application/mbms-envelope+xml":{"source":"iana"},"application/mbms-msk+xml":{"source":"iana"},"application/mbms-msk-response+xml":{"source":"iana"},"application/mbms-protection-description+xml":{"source":"iana"},"application/mbms-reception-report+xml":{"source":"iana"},"application/mbms-register+xml":{"source":"iana"},"application/mbms-register-response+xml":{"source":"iana"},"application/mbms-schedule+xml":{"source":"iana"},"application/mbms-user-service-description+xml":{"source":"iana"},"application/mbox":{"source":"iana","extensions":["mbox"]},"application/media-policy-dataset+xml":{"source":"iana"},"application/media_control+xml":{"source":"iana"},"application/mediaservercontrol+xml":{"source":"iana","extensions":["mscml"]},"application/merge-patch+json":{"source":"iana","compressible":true},"application/metalink+xml":{"source":"apache","extensions":["metalink"]},"application/metalink4+xml":{"source":"iana","extensions":["meta4"]},"application/mets+xml":{"source":"iana","extensions":["mets"]},"application/mf4":{"source":"iana"},"application/mikey":{"source":"iana"},"application/mmt-usd+xml":{"source":"iana"},"application/mods+xml":{"source":"iana","extensions":["mods"]},"application/moss-keys":{"source":"iana"},"application/moss-signature":{"source":"iana"},"application/mosskey-data":{"source":"iana"},"application/mosskey-request":{"source":"iana"},"application/mp21":{"source":"iana","extensions":["m21","mp21"]},"application/mp4":{"source":"iana","extensions":["mp4s","m4p"]},"application/mpeg4-generic":{"source":"iana"},"application/mpeg4-iod":{"source":"iana"},"application/mpeg4-iod-xmt":{"source":"iana"},"application/mrb-consumer+xml":{"source":"iana"},"application/mrb-publish+xml":{"source":"iana"},"application/msc-ivr+xml":{"source":"iana"},"application/msc-mixer+xml":{"source":"iana"},"application/msword":{"source":"iana","compressible":false,"extensions":["doc","dot"]},"application/mud+json":{"source":"iana","compressible":true},"application/mxf":{"source":"iana","extensions":["mxf"]},"application/n-quads":{"source":"iana"},"application/n-triples":{"source":"iana"},"application/nasdata":{"source":"iana"},"application/news-checkgroups":{"source":"iana"},"application/news-groupinfo":{"source":"iana"},"application/news-transmission":{"source":"iana"},"application/nlsml+xml":{"source":"iana"},"application/node":{"source":"iana"},"application/nss":{"source":"iana"},"application/ocsp-request":{"source":"iana"},"application/ocsp-response":{"source":"iana"},"application/octet-stream":{"source":"iana","compressible":false,"extensions":["bin","dms","lrf","mar","so","dist","distz","pkg","bpk","dump","elc","deploy","exe","dll","deb","dmg","iso","img","msi","msp","msm","buffer"]},"application/oda":{"source":"iana","extensions":["oda"]},"application/odx":{"source":"iana"},"application/oebps-package+xml":{"source":"iana","extensions":["opf"]},"application/ogg":{"source":"iana","compressible":false,"extensions":["ogx"]},"application/omdoc+xml":{"source":"apache","extensions":["omdoc"]},"application/onenote":{"source":"apache","extensions":["onetoc","onetoc2","onetmp","onepkg"]},"application/oxps":{"source":"iana","extensions":["oxps"]},"application/p2p-overlay+xml":{"source":"iana"},"application/parityfec":{"source":"iana"},"application/passport":{"source":"iana"},"application/patch-ops-error+xml":{"source":"iana","extensions":["xer"]},"application/pdf":{"source":"iana","compressible":false,"extensions":["pdf"]},"application/pdx":{"source":"iana"},"application/pgp-encrypted":{"source":"iana","compressible":false,"extensions":["pgp"]},"application/pgp-keys":{"source":"iana"},"application/pgp-signature":{"source":"iana","extensions":["asc","sig"]},"application/pics-rules":{"source":"apache","extensions":["prf"]},"application/pidf+xml":{"source":"iana"},"application/pidf-diff+xml":{"source":"iana"},"application/pkcs10":{"source":"iana","extensions":["p10"]},"application/pkcs12":{"source":"iana"},"application/pkcs7-mime":{"source":"iana","extensions":["p7m","p7c"]},"application/pkcs7-signature":{"source":"iana","extensions":["p7s"]},"application/pkcs8":{"source":"iana","extensions":["p8"]},"application/pkcs8-encrypted":{"source":"iana"},"application/pkix-attr-cert":{"source":"iana","extensions":["ac"]},"application/pkix-cert":{"source":"iana","extensions":["cer"]},"application/pkix-crl":{"source":"iana","extensions":["crl"]},"application/pkix-pkipath":{"source":"iana","extensions":["pkipath"]},"application/pkixcmp":{"source":"iana","extensions":["pki"]},"application/pls+xml":{"source":"iana","extensions":["pls"]},"application/poc-settings+xml":{"source":"iana"},"application/postscript":{"source":"iana","compressible":true,"extensions":["ai","eps","ps"]},"application/ppsp-tracker+json":{"source":"iana","compressible":true},"application/problem+json":{"source":"iana","compressible":true},"application/problem+xml":{"source":"iana"},"application/provenance+xml":{"source":"iana"},"application/prs.alvestrand.titrax-sheet":{"source":"iana"},"application/prs.cww":{"source":"iana","extensions":["cww"]},"application/prs.hpub+zip":{"source":"iana"},"application/prs.nprend":{"source":"iana"},"application/prs.plucker":{"source":"iana"},"application/prs.rdf-xml-crypt":{"source":"iana"},"application/prs.xsf+xml":{"source":"iana"},"application/pskc+xml":{"source":"iana","extensions":["pskcxml"]},"application/qsig":{"source":"iana"},"application/raml+yaml":{"compressible":true,"extensions":["raml"]},"application/raptorfec":{"source":"iana"},"application/rdap+json":{"source":"iana","compressible":true},"application/rdf+xml":{"source":"iana","compressible":true,"extensions":["rdf"]},"application/reginfo+xml":{"source":"iana","extensions":["rif"]},"application/relax-ng-compact-syntax":{"source":"iana","extensions":["rnc"]},"application/remote-printing":{"source":"iana"},"application/reputon+json":{"source":"iana","compressible":true},"application/resource-lists+xml":{"source":"iana","extensions":["rl"]},"application/resource-lists-diff+xml":{"source":"iana","extensions":["rld"]},"application/rfc+xml":{"source":"iana"},"application/riscos":{"source":"iana"},"application/rlmi+xml":{"source":"iana"},"application/rls-services+xml":{"source":"iana","extensions":["rs"]},"application/route-apd+xml":{"source":"iana"},"application/route-s-tsid+xml":{"source":"iana"},"application/route-usd+xml":{"source":"iana"},"application/rpki-ghostbusters":{"source":"iana","extensions":["gbr"]},"application/rpki-manifest":{"source":"iana","extensions":["mft"]},"application/rpki-publication":{"source":"iana"},"application/rpki-roa":{"source":"iana","extensions":["roa"]},"application/rpki-updown":{"source":"iana"},"application/rsd+xml":{"source":"apache","extensions":["rsd"]},"application/rss+xml":{"source":"apache","compressible":true,"extensions":["rss"]},"application/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"application/rtploopback":{"source":"iana"},"application/rtx":{"source":"iana"},"application/samlassertion+xml":{"source":"iana"},"application/samlmetadata+xml":{"source":"iana"},"application/sbml+xml":{"source":"iana","extensions":["sbml"]},"application/scaip+xml":{"source":"iana"},"application/scim+json":{"source":"iana","compressible":true},"application/scvp-cv-request":{"source":"iana","extensions":["scq"]},"application/scvp-cv-response":{"source":"iana","extensions":["scs"]},"application/scvp-vp-request":{"source":"iana","extensions":["spq"]},"application/scvp-vp-response":{"source":"iana","extensions":["spp"]},"application/sdp":{"source":"iana","extensions":["sdp"]},"application/sep+xml":{"source":"iana"},"application/sep-exi":{"source":"iana"},"application/session-info":{"source":"iana"},"application/set-payment":{"source":"iana"},"application/set-payment-initiation":{"source":"iana","extensions":["setpay"]},"application/set-registration":{"source":"iana"},"application/set-registration-initiation":{"source":"iana","extensions":["setreg"]},"application/sgml":{"source":"iana"},"application/sgml-open-catalog":{"source":"iana"},"application/shf+xml":{"source":"iana","extensions":["shf"]},"application/sieve":{"source":"iana"},"application/simple-filter+xml":{"source":"iana"},"application/simple-message-summary":{"source":"iana"},"application/simplesymbolcontainer":{"source":"iana"},"application/slate":{"source":"iana"},"application/smil":{"source":"iana"},"application/smil+xml":{"source":"iana","extensions":["smi","smil"]},"application/smpte336m":{"source":"iana"},"application/soap+fastinfoset":{"source":"iana"},"application/soap+xml":{"source":"iana","compressible":true},"application/sparql-query":{"source":"iana","extensions":["rq"]},"application/sparql-results+xml":{"source":"iana","extensions":["srx"]},"application/spirits-event+xml":{"source":"iana"},"application/sql":{"source":"iana"},"application/srgs":{"source":"iana","extensions":["gram"]},"application/srgs+xml":{"source":"iana","extensions":["grxml"]},"application/sru+xml":{"source":"iana","extensions":["sru"]},"application/ssdl+xml":{"source":"apache","extensions":["ssdl"]},"application/ssml+xml":{"source":"iana","extensions":["ssml"]},"application/tamp-apex-update":{"source":"iana"},"application/tamp-apex-update-confirm":{"source":"iana"},"application/tamp-community-update":{"source":"iana"},"application/tamp-community-update-confirm":{"source":"iana"},"application/tamp-error":{"source":"iana"},"application/tamp-sequence-adjust":{"source":"iana"},"application/tamp-sequence-adjust-confirm":{"source":"iana"},"application/tamp-status-query":{"source":"iana"},"application/tamp-status-response":{"source":"iana"},"application/tamp-update":{"source":"iana"},"application/tamp-update-confirm":{"source":"iana"},"application/tar":{"compressible":true},"application/tei+xml":{"source":"iana","extensions":["tei","teicorpus"]},"application/thraud+xml":{"source":"iana","extensions":["tfi"]},"application/timestamp-query":{"source":"iana"},"application/timestamp-reply":{"source":"iana"},"application/timestamped-data":{"source":"iana","extensions":["tsd"]},"application/tnauthlist":{"source":"iana"},"application/trig":{"source":"iana"},"application/ttml+xml":{"source":"iana"},"application/tve-trigger":{"source":"iana"},"application/ulpfec":{"source":"iana"},"application/urc-grpsheet+xml":{"source":"iana"},"application/urc-ressheet+xml":{"source":"iana"},"application/urc-targetdesc+xml":{"source":"iana"},"application/urc-uisocketdesc+xml":{"source":"iana"},"application/vcard+json":{"source":"iana","compressible":true},"application/vcard+xml":{"source":"iana"},"application/vemmi":{"source":"iana"},"application/vividence.scriptfile":{"source":"apache"},"application/vnd.1000minds.decision-model+xml":{"source":"iana"},"application/vnd.3gpp-prose+xml":{"source":"iana"},"application/vnd.3gpp-prose-pc3ch+xml":{"source":"iana"},"application/vnd.3gpp-v2x-local-service-information":{"source":"iana"},"application/vnd.3gpp.access-transfer-events+xml":{"source":"iana"},"application/vnd.3gpp.bsf+xml":{"source":"iana"},"application/vnd.3gpp.gmop+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-affiliation-command+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-floor-request+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-info+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-location-info+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-mbms-usage-info+xml":{"source":"iana"},"application/vnd.3gpp.mcptt-signed+xml":{"source":"iana"},"application/vnd.3gpp.mid-call+xml":{"source":"iana"},"application/vnd.3gpp.pic-bw-large":{"source":"iana","extensions":["plb"]},"application/vnd.3gpp.pic-bw-small":{"source":"iana","extensions":["psb"]},"application/vnd.3gpp.pic-bw-var":{"source":"iana","extensions":["pvb"]},"application/vnd.3gpp.sms":{"source":"iana"},"application/vnd.3gpp.sms+xml":{"source":"iana"},"application/vnd.3gpp.srvcc-ext+xml":{"source":"iana"},"application/vnd.3gpp.srvcc-info+xml":{"source":"iana"},"application/vnd.3gpp.state-and-event-info+xml":{"source":"iana"},"application/vnd.3gpp.ussd+xml":{"source":"iana"},"application/vnd.3gpp2.bcmcsinfo+xml":{"source":"iana"},"application/vnd.3gpp2.sms":{"source":"iana"},"application/vnd.3gpp2.tcap":{"source":"iana","extensions":["tcap"]},"application/vnd.3lightssoftware.imagescal":{"source":"iana"},"application/vnd.3m.post-it-notes":{"source":"iana","extensions":["pwn"]},"application/vnd.accpac.simply.aso":{"source":"iana","extensions":["aso"]},"application/vnd.accpac.simply.imp":{"source":"iana","extensions":["imp"]},"application/vnd.acucobol":{"source":"iana","extensions":["acu"]},"application/vnd.acucorp":{"source":"iana","extensions":["atc","acutc"]},"application/vnd.adobe.air-application-installer-package+zip":{"source":"apache","extensions":["air"]},"application/vnd.adobe.flash.movie":{"source":"iana"},"application/vnd.adobe.formscentral.fcdt":{"source":"iana","extensions":["fcdt"]},"application/vnd.adobe.fxp":{"source":"iana","extensions":["fxp","fxpl"]},"application/vnd.adobe.partial-upload":{"source":"iana"},"application/vnd.adobe.xdp+xml":{"source":"iana","extensions":["xdp"]},"application/vnd.adobe.xfdf":{"source":"iana","extensions":["xfdf"]},"application/vnd.aether.imp":{"source":"iana"},"application/vnd.ah-barcode":{"source":"iana"},"application/vnd.ahead.space":{"source":"iana","extensions":["ahead"]},"application/vnd.airzip.filesecure.azf":{"source":"iana","extensions":["azf"]},"application/vnd.airzip.filesecure.azs":{"source":"iana","extensions":["azs"]},"application/vnd.amadeus+json":{"source":"iana","compressible":true},"application/vnd.amazon.ebook":{"source":"apache","extensions":["azw"]},"application/vnd.amazon.mobi8-ebook":{"source":"iana"},"application/vnd.americandynamics.acc":{"source":"iana","extensions":["acc"]},"application/vnd.amiga.ami":{"source":"iana","extensions":["ami"]},"application/vnd.amundsen.maze+xml":{"source":"iana"},"application/vnd.android.package-archive":{"source":"apache","compressible":false,"extensions":["apk"]},"application/vnd.anki":{"source":"iana"},"application/vnd.anser-web-certificate-issue-initiation":{"source":"iana","extensions":["cii"]},"application/vnd.anser-web-funds-transfer-initiation":{"source":"apache","extensions":["fti"]},"application/vnd.antix.game-component":{"source":"iana","extensions":["atx"]},"application/vnd.apache.thrift.binary":{"source":"iana"},"application/vnd.apache.thrift.compact":{"source":"iana"},"application/vnd.apache.thrift.json":{"source":"iana"},"application/vnd.api+json":{"source":"iana","compressible":true},"application/vnd.apothekende.reservation+json":{"source":"iana","compressible":true},"application/vnd.apple.installer+xml":{"source":"iana","extensions":["mpkg"]},"application/vnd.apple.mpegurl":{"source":"iana","extensions":["m3u8"]},"application/vnd.apple.pkpass":{"compressible":false,"extensions":["pkpass"]},"application/vnd.arastra.swi":{"source":"iana"},"application/vnd.aristanetworks.swi":{"source":"iana","extensions":["swi"]},"application/vnd.artsquare":{"source":"iana"},"application/vnd.astraea-software.iota":{"source":"iana","extensions":["iota"]},"application/vnd.audiograph":{"source":"iana","extensions":["aep"]},"application/vnd.autopackage":{"source":"iana"},"application/vnd.avalon+json":{"source":"iana","compressible":true},"application/vnd.avistar+xml":{"source":"iana"},"application/vnd.balsamiq.bmml+xml":{"source":"iana"},"application/vnd.balsamiq.bmpr":{"source":"iana"},"application/vnd.bbf.usp.msg":{"source":"iana"},"application/vnd.bbf.usp.msg+json":{"source":"iana","compressible":true},"application/vnd.bekitzur-stech+json":{"source":"iana","compressible":true},"application/vnd.bint.med-content":{"source":"iana"},"application/vnd.biopax.rdf+xml":{"source":"iana"},"application/vnd.blink-idb-value-wrapper":{"source":"iana"},"application/vnd.blueice.multipass":{"source":"iana","extensions":["mpm"]},"application/vnd.bluetooth.ep.oob":{"source":"iana"},"application/vnd.bluetooth.le.oob":{"source":"iana"},"application/vnd.bmi":{"source":"iana","extensions":["bmi"]},"application/vnd.businessobjects":{"source":"iana","extensions":["rep"]},"application/vnd.cab-jscript":{"source":"iana"},"application/vnd.canon-cpdl":{"source":"iana"},"application/vnd.canon-lips":{"source":"iana"},"application/vnd.capasystems-pg+json":{"source":"iana","compressible":true},"application/vnd.cendio.thinlinc.clientconf":{"source":"iana"},"application/vnd.century-systems.tcp_stream":{"source":"iana"},"application/vnd.chemdraw+xml":{"source":"iana","extensions":["cdxml"]},"application/vnd.chess-pgn":{"source":"iana"},"application/vnd.chipnuts.karaoke-mmd":{"source":"iana","extensions":["mmd"]},"application/vnd.cinderella":{"source":"iana","extensions":["cdy"]},"application/vnd.cirpack.isdn-ext":{"source":"iana"},"application/vnd.citationstyles.style+xml":{"source":"iana"},"application/vnd.claymore":{"source":"iana","extensions":["cla"]},"application/vnd.cloanto.rp9":{"source":"iana","extensions":["rp9"]},"application/vnd.clonk.c4group":{"source":"iana","extensions":["c4g","c4d","c4f","c4p","c4u"]},"application/vnd.cluetrust.cartomobile-config":{"source":"iana","extensions":["c11amc"]},"application/vnd.cluetrust.cartomobile-config-pkg":{"source":"iana","extensions":["c11amz"]},"application/vnd.coffeescript":{"source":"iana"},"application/vnd.collabio.xodocuments.document":{"source":"iana"},"application/vnd.collabio.xodocuments.document-template":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation":{"source":"iana"},"application/vnd.collabio.xodocuments.presentation-template":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet":{"source":"iana"},"application/vnd.collabio.xodocuments.spreadsheet-template":{"source":"iana"},"application/vnd.collection+json":{"source":"iana","compressible":true},"application/vnd.collection.doc+json":{"source":"iana","compressible":true},"application/vnd.collection.next+json":{"source":"iana","compressible":true},"application/vnd.comicbook+zip":{"source":"iana"},"application/vnd.comicbook-rar":{"source":"iana"},"application/vnd.commerce-battelle":{"source":"iana"},"application/vnd.commonspace":{"source":"iana","extensions":["csp"]},"application/vnd.contact.cmsg":{"source":"iana","extensions":["cdbcmsg"]},"application/vnd.coreos.ignition+json":{"source":"iana","compressible":true},"application/vnd.cosmocaller":{"source":"iana","extensions":["cmc"]},"application/vnd.crick.clicker":{"source":"iana","extensions":["clkx"]},"application/vnd.crick.clicker.keyboard":{"source":"iana","extensions":["clkk"]},"application/vnd.crick.clicker.palette":{"source":"iana","extensions":["clkp"]},"application/vnd.crick.clicker.template":{"source":"iana","extensions":["clkt"]},"application/vnd.crick.clicker.wordbank":{"source":"iana","extensions":["clkw"]},"application/vnd.criticaltools.wbs+xml":{"source":"iana","extensions":["wbs"]},"application/vnd.ctc-posml":{"source":"iana","extensions":["pml"]},"application/vnd.ctct.ws+xml":{"source":"iana"},"application/vnd.cups-pdf":{"source":"iana"},"application/vnd.cups-postscript":{"source":"iana"},"application/vnd.cups-ppd":{"source":"iana","extensions":["ppd"]},"application/vnd.cups-raster":{"source":"iana"},"application/vnd.cups-raw":{"source":"iana"},"application/vnd.curl":{"source":"iana"},"application/vnd.curl.car":{"source":"apache","extensions":["car"]},"application/vnd.curl.pcurl":{"source":"apache","extensions":["pcurl"]},"application/vnd.cyan.dean.root+xml":{"source":"iana"},"application/vnd.cybank":{"source":"iana"},"application/vnd.d2l.coursepackage1p0+zip":{"source":"iana"},"application/vnd.dart":{"source":"iana","compressible":true,"extensions":["dart"]},"application/vnd.data-vision.rdz":{"source":"iana","extensions":["rdz"]},"application/vnd.datapackage+json":{"source":"iana","compressible":true},"application/vnd.dataresource+json":{"source":"iana","compressible":true},"application/vnd.debian.binary-package":{"source":"iana"},"application/vnd.dece.data":{"source":"iana","extensions":["uvf","uvvf","uvd","uvvd"]},"application/vnd.dece.ttml+xml":{"source":"iana","extensions":["uvt","uvvt"]},"application/vnd.dece.unspecified":{"source":"iana","extensions":["uvx","uvvx"]},"application/vnd.dece.zip":{"source":"iana","extensions":["uvz","uvvz"]},"application/vnd.denovo.fcselayout-link":{"source":"iana","extensions":["fe_launch"]},"application/vnd.desmume-movie":{"source":"iana"},"application/vnd.desmume.movie":{"source":"apache"},"application/vnd.dir-bi.plate-dl-nosuffix":{"source":"iana"},"application/vnd.dm.delegation+xml":{"source":"iana"},"application/vnd.dna":{"source":"iana","extensions":["dna"]},"application/vnd.document+json":{"source":"iana","compressible":true},"application/vnd.dolby.mlp":{"source":"apache","extensions":["mlp"]},"application/vnd.dolby.mobile.1":{"source":"iana"},"application/vnd.dolby.mobile.2":{"source":"iana"},"application/vnd.doremir.scorecloud-binary-document":{"source":"iana"},"application/vnd.dpgraph":{"source":"iana","extensions":["dpg"]},"application/vnd.dreamfactory":{"source":"iana","extensions":["dfac"]},"application/vnd.drive+json":{"source":"iana","compressible":true},"application/vnd.ds-keypoint":{"source":"apache","extensions":["kpxx"]},"application/vnd.dtg.local":{"source":"iana"},"application/vnd.dtg.local.flash":{"source":"iana"},"application/vnd.dtg.local.html":{"source":"iana"},"application/vnd.dvb.ait":{"source":"iana","extensions":["ait"]},"application/vnd.dvb.dvbj":{"source":"iana"},"application/vnd.dvb.esgcontainer":{"source":"iana"},"application/vnd.dvb.ipdcdftnotifaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess":{"source":"iana"},"application/vnd.dvb.ipdcesgaccess2":{"source":"iana"},"application/vnd.dvb.ipdcesgpdd":{"source":"iana"},"application/vnd.dvb.ipdcroaming":{"source":"iana"},"application/vnd.dvb.iptv.alfec-base":{"source":"iana"},"application/vnd.dvb.iptv.alfec-enhancement":{"source":"iana"},"application/vnd.dvb.notif-aggregate-root+xml":{"source":"iana"},"application/vnd.dvb.notif-container+xml":{"source":"iana"},"application/vnd.dvb.notif-generic+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-msglist+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-registration-request+xml":{"source":"iana"},"application/vnd.dvb.notif-ia-registration-response+xml":{"source":"iana"},"application/vnd.dvb.notif-init+xml":{"source":"iana"},"application/vnd.dvb.pfr":{"source":"iana"},"application/vnd.dvb.service":{"source":"iana","extensions":["svc"]},"application/vnd.dxr":{"source":"iana"},"application/vnd.dynageo":{"source":"iana","extensions":["geo"]},"application/vnd.dzr":{"source":"iana"},"application/vnd.easykaraoke.cdgdownload":{"source":"iana"},"application/vnd.ecdis-update":{"source":"iana"},"application/vnd.ecip.rlp":{"source":"iana"},"application/vnd.ecowin.chart":{"source":"iana","extensions":["mag"]},"application/vnd.ecowin.filerequest":{"source":"iana"},"application/vnd.ecowin.fileupdate":{"source":"iana"},"application/vnd.ecowin.series":{"source":"iana"},"application/vnd.ecowin.seriesrequest":{"source":"iana"},"application/vnd.ecowin.seriesupdate":{"source":"iana"},"application/vnd.efi.img":{"source":"iana"},"application/vnd.efi.iso":{"source":"iana"},"application/vnd.emclient.accessrequest+xml":{"source":"iana"},"application/vnd.enliven":{"source":"iana","extensions":["nml"]},"application/vnd.enphase.envoy":{"source":"iana"},"application/vnd.eprints.data+xml":{"source":"iana"},"application/vnd.epson.esf":{"source":"iana","extensions":["esf"]},"application/vnd.epson.msf":{"source":"iana","extensions":["msf"]},"application/vnd.epson.quickanime":{"source":"iana","extensions":["qam"]},"application/vnd.epson.salt":{"source":"iana","extensions":["slt"]},"application/vnd.epson.ssf":{"source":"iana","extensions":["ssf"]},"application/vnd.ericsson.quickcall":{"source":"iana"},"application/vnd.espass-espass+zip":{"source":"iana"},"application/vnd.eszigno3+xml":{"source":"iana","extensions":["es3","et3"]},"application/vnd.etsi.aoc+xml":{"source":"iana"},"application/vnd.etsi.asic-e+zip":{"source":"iana"},"application/vnd.etsi.asic-s+zip":{"source":"iana"},"application/vnd.etsi.cug+xml":{"source":"iana"},"application/vnd.etsi.iptvcommand+xml":{"source":"iana"},"application/vnd.etsi.iptvdiscovery+xml":{"source":"iana"},"application/vnd.etsi.iptvprofile+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-bc+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-cod+xml":{"source":"iana"},"application/vnd.etsi.iptvsad-npvr+xml":{"source":"iana"},"application/vnd.etsi.iptvservice+xml":{"source":"iana"},"application/vnd.etsi.iptvsync+xml":{"source":"iana"},"application/vnd.etsi.iptvueprofile+xml":{"source":"iana"},"application/vnd.etsi.mcid+xml":{"source":"iana"},"application/vnd.etsi.mheg5":{"source":"iana"},"application/vnd.etsi.overload-control-policy-dataset+xml":{"source":"iana"},"application/vnd.etsi.pstn+xml":{"source":"iana"},"application/vnd.etsi.sci+xml":{"source":"iana"},"application/vnd.etsi.simservs+xml":{"source":"iana"},"application/vnd.etsi.timestamp-token":{"source":"iana"},"application/vnd.etsi.tsl+xml":{"source":"iana"},"application/vnd.etsi.tsl.der":{"source":"iana"},"application/vnd.eudora.data":{"source":"iana"},"application/vnd.evolv.ecig.profile":{"source":"iana"},"application/vnd.evolv.ecig.settings":{"source":"iana"},"application/vnd.evolv.ecig.theme":{"source":"iana"},"application/vnd.ezpix-album":{"source":"iana","extensions":["ez2"]},"application/vnd.ezpix-package":{"source":"iana","extensions":["ez3"]},"application/vnd.f-secure.mobile":{"source":"iana"},"application/vnd.fastcopy-disk-image":{"source":"iana"},"application/vnd.fdf":{"source":"iana","extensions":["fdf"]},"application/vnd.fdsn.mseed":{"source":"iana","extensions":["mseed"]},"application/vnd.fdsn.seed":{"source":"iana","extensions":["seed","dataless"]},"application/vnd.ffsns":{"source":"iana"},"application/vnd.filmit.zfc":{"source":"iana"},"application/vnd.fints":{"source":"iana"},"application/vnd.firemonkeys.cloudcell":{"source":"iana"},"application/vnd.flographit":{"source":"iana","extensions":["gph"]},"application/vnd.fluxtime.clip":{"source":"iana","extensions":["ftc"]},"application/vnd.font-fontforge-sfd":{"source":"iana"},"application/vnd.framemaker":{"source":"iana","extensions":["fm","frame","maker","book"]},"application/vnd.frogans.fnc":{"source":"iana","extensions":["fnc"]},"application/vnd.frogans.ltf":{"source":"iana","extensions":["ltf"]},"application/vnd.fsc.weblaunch":{"source":"iana","extensions":["fsc"]},"application/vnd.fujitsu.oasys":{"source":"iana","extensions":["oas"]},"application/vnd.fujitsu.oasys2":{"source":"iana","extensions":["oa2"]},"application/vnd.fujitsu.oasys3":{"source":"iana","extensions":["oa3"]},"application/vnd.fujitsu.oasysgp":{"source":"iana","extensions":["fg5"]},"application/vnd.fujitsu.oasysprs":{"source":"iana","extensions":["bh2"]},"application/vnd.fujixerox.art-ex":{"source":"iana"},"application/vnd.fujixerox.art4":{"source":"iana"},"application/vnd.fujixerox.ddd":{"source":"iana","extensions":["ddd"]},"application/vnd.fujixerox.docuworks":{"source":"iana","extensions":["xdw"]},"application/vnd.fujixerox.docuworks.binder":{"source":"iana","extensions":["xbd"]},"application/vnd.fujixerox.docuworks.container":{"source":"iana"},"application/vnd.fujixerox.hbpl":{"source":"iana"},"application/vnd.fut-misnet":{"source":"iana"},"application/vnd.fuzzysheet":{"source":"iana","extensions":["fzs"]},"application/vnd.genomatix.tuxedo":{"source":"iana","extensions":["txd"]},"application/vnd.geo+json":{"source":"iana","compressible":true},"application/vnd.geocube+xml":{"source":"iana"},"application/vnd.geogebra.file":{"source":"iana","extensions":["ggb"]},"application/vnd.geogebra.tool":{"source":"iana","extensions":["ggt"]},"application/vnd.geometry-explorer":{"source":"iana","extensions":["gex","gre"]},"application/vnd.geonext":{"source":"iana","extensions":["gxt"]},"application/vnd.geoplan":{"source":"iana","extensions":["g2w"]},"application/vnd.geospace":{"source":"iana","extensions":["g3w"]},"application/vnd.gerber":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt":{"source":"iana"},"application/vnd.globalplatform.card-content-mgt-response":{"source":"iana"},"application/vnd.gmx":{"source":"iana","extensions":["gmx"]},"application/vnd.google-apps.document":{"compressible":false,"extensions":["gdoc"]},"application/vnd.google-apps.presentation":{"compressible":false,"extensions":["gslides"]},"application/vnd.google-apps.spreadsheet":{"compressible":false,"extensions":["gsheet"]},"application/vnd.google-earth.kml+xml":{"source":"iana","compressible":true,"extensions":["kml"]},"application/vnd.google-earth.kmz":{"source":"iana","compressible":false,"extensions":["kmz"]},"application/vnd.gov.sk.e-form+xml":{"source":"iana"},"application/vnd.gov.sk.e-form+zip":{"source":"iana"},"application/vnd.gov.sk.xmldatacontainer+xml":{"source":"iana"},"application/vnd.grafeq":{"source":"iana","extensions":["gqf","gqs"]},"application/vnd.gridmp":{"source":"iana"},"application/vnd.groove-account":{"source":"iana","extensions":["gac"]},"application/vnd.groove-help":{"source":"iana","extensions":["ghf"]},"application/vnd.groove-identity-message":{"source":"iana","extensions":["gim"]},"application/vnd.groove-injector":{"source":"iana","extensions":["grv"]},"application/vnd.groove-tool-message":{"source":"iana","extensions":["gtm"]},"application/vnd.groove-tool-template":{"source":"iana","extensions":["tpl"]},"application/vnd.groove-vcard":{"source":"iana","extensions":["vcg"]},"application/vnd.hal+json":{"source":"iana","compressible":true},"application/vnd.hal+xml":{"source":"iana","extensions":["hal"]},"application/vnd.handheld-entertainment+xml":{"source":"iana","extensions":["zmm"]},"application/vnd.hbci":{"source":"iana","extensions":["hbci"]},"application/vnd.hc+json":{"source":"iana","compressible":true},"application/vnd.hcl-bireports":{"source":"iana"},"application/vnd.hdt":{"source":"iana"},"application/vnd.heroku+json":{"source":"iana","compressible":true},"application/vnd.hhe.lesson-player":{"source":"iana","extensions":["les"]},"application/vnd.hp-hpgl":{"source":"iana","extensions":["hpgl"]},"application/vnd.hp-hpid":{"source":"iana","extensions":["hpid"]},"application/vnd.hp-hps":{"source":"iana","extensions":["hps"]},"application/vnd.hp-jlyt":{"source":"iana","extensions":["jlt"]},"application/vnd.hp-pcl":{"source":"iana","extensions":["pcl"]},"application/vnd.hp-pclxl":{"source":"iana","extensions":["pclxl"]},"application/vnd.httphone":{"source":"iana"},"application/vnd.hydrostatix.sof-data":{"source":"iana","extensions":["sfd-hdstx"]},"application/vnd.hyper-item+json":{"source":"iana","compressible":true},"application/vnd.hyperdrive+json":{"source":"iana","compressible":true},"application/vnd.hzn-3d-crossword":{"source":"iana"},"application/vnd.ibm.afplinedata":{"source":"iana"},"application/vnd.ibm.electronic-media":{"source":"iana"},"application/vnd.ibm.minipay":{"source":"iana","extensions":["mpy"]},"application/vnd.ibm.modcap":{"source":"iana","extensions":["afp","listafp","list3820"]},"application/vnd.ibm.rights-management":{"source":"iana","extensions":["irm"]},"application/vnd.ibm.secure-container":{"source":"iana","extensions":["sc"]},"application/vnd.iccprofile":{"source":"iana","extensions":["icc","icm"]},"application/vnd.ieee.1905":{"source":"iana"},"application/vnd.igloader":{"source":"iana","extensions":["igl"]},"application/vnd.imagemeter.folder+zip":{"source":"iana"},"application/vnd.imagemeter.image+zip":{"source":"iana"},"application/vnd.immervision-ivp":{"source":"iana","extensions":["ivp"]},"application/vnd.immervision-ivu":{"source":"iana","extensions":["ivu"]},"application/vnd.ims.imsccv1p1":{"source":"iana"},"application/vnd.ims.imsccv1p2":{"source":"iana"},"application/vnd.ims.imsccv1p3":{"source":"iana"},"application/vnd.ims.lis.v2.result+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolconsumerprofile+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolproxy.id+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings+json":{"source":"iana","compressible":true},"application/vnd.ims.lti.v2.toolsettings.simple+json":{"source":"iana","compressible":true},"application/vnd.informedcontrol.rms+xml":{"source":"iana"},"application/vnd.informix-visionary":{"source":"iana"},"application/vnd.infotech.project":{"source":"iana"},"application/vnd.infotech.project+xml":{"source":"iana"},"application/vnd.innopath.wamp.notification":{"source":"iana"},"application/vnd.insors.igm":{"source":"iana","extensions":["igm"]},"application/vnd.intercon.formnet":{"source":"iana","extensions":["xpw","xpx"]},"application/vnd.intergeo":{"source":"iana","extensions":["i2g"]},"application/vnd.intertrust.digibox":{"source":"iana"},"application/vnd.intertrust.nncp":{"source":"iana"},"application/vnd.intu.qbo":{"source":"iana","extensions":["qbo"]},"application/vnd.intu.qfx":{"source":"iana","extensions":["qfx"]},"application/vnd.iptc.g2.catalogitem+xml":{"source":"iana"},"application/vnd.iptc.g2.conceptitem+xml":{"source":"iana"},"application/vnd.iptc.g2.knowledgeitem+xml":{"source":"iana"},"application/vnd.iptc.g2.newsitem+xml":{"source":"iana"},"application/vnd.iptc.g2.newsmessage+xml":{"source":"iana"},"application/vnd.iptc.g2.packageitem+xml":{"source":"iana"},"application/vnd.iptc.g2.planningitem+xml":{"source":"iana"},"application/vnd.ipunplugged.rcprofile":{"source":"iana","extensions":["rcprofile"]},"application/vnd.irepository.package+xml":{"source":"iana","extensions":["irp"]},"application/vnd.is-xpr":{"source":"iana","extensions":["xpr"]},"application/vnd.isac.fcs":{"source":"iana","extensions":["fcs"]},"application/vnd.jam":{"source":"iana","extensions":["jam"]},"application/vnd.japannet-directory-service":{"source":"iana"},"application/vnd.japannet-jpnstore-wakeup":{"source":"iana"},"application/vnd.japannet-payment-wakeup":{"source":"iana"},"application/vnd.japannet-registration":{"source":"iana"},"application/vnd.japannet-registration-wakeup":{"source":"iana"},"application/vnd.japannet-setstore-wakeup":{"source":"iana"},"application/vnd.japannet-verification":{"source":"iana"},"application/vnd.japannet-verification-wakeup":{"source":"iana"},"application/vnd.jcp.javame.midlet-rms":{"source":"iana","extensions":["rms"]},"application/vnd.jisp":{"source":"iana","extensions":["jisp"]},"application/vnd.joost.joda-archive":{"source":"iana","extensions":["joda"]},"application/vnd.jsk.isdn-ngn":{"source":"iana"},"application/vnd.kahootz":{"source":"iana","extensions":["ktz","ktr"]},"application/vnd.kde.karbon":{"source":"iana","extensions":["karbon"]},"application/vnd.kde.kchart":{"source":"iana","extensions":["chrt"]},"application/vnd.kde.kformula":{"source":"iana","extensions":["kfo"]},"application/vnd.kde.kivio":{"source":"iana","extensions":["flw"]},"application/vnd.kde.kontour":{"source":"iana","extensions":["kon"]},"application/vnd.kde.kpresenter":{"source":"iana","extensions":["kpr","kpt"]},"application/vnd.kde.kspread":{"source":"iana","extensions":["ksp"]},"application/vnd.kde.kword":{"source":"iana","extensions":["kwd","kwt"]},"application/vnd.kenameaapp":{"source":"iana","extensions":["htke"]},"application/vnd.kidspiration":{"source":"iana","extensions":["kia"]},"application/vnd.kinar":{"source":"iana","extensions":["kne","knp"]},"application/vnd.koan":{"source":"iana","extensions":["skp","skd","skt","skm"]},"application/vnd.kodak-descriptor":{"source":"iana","extensions":["sse"]},"application/vnd.las.las+json":{"source":"iana","compressible":true},"application/vnd.las.las+xml":{"source":"iana","extensions":["lasxml"]},"application/vnd.liberty-request+xml":{"source":"iana"},"application/vnd.llamagraphics.life-balance.desktop":{"source":"iana","extensions":["lbd"]},"application/vnd.llamagraphics.life-balance.exchange+xml":{"source":"iana","extensions":["lbe"]},"application/vnd.lotus-1-2-3":{"source":"iana","extensions":["123"]},"application/vnd.lotus-approach":{"source":"iana","extensions":["apr"]},"application/vnd.lotus-freelance":{"source":"iana","extensions":["pre"]},"application/vnd.lotus-notes":{"source":"iana","extensions":["nsf"]},"application/vnd.lotus-organizer":{"source":"iana","extensions":["org"]},"application/vnd.lotus-screencam":{"source":"iana","extensions":["scm"]},"application/vnd.lotus-wordpro":{"source":"iana","extensions":["lwp"]},"application/vnd.macports.portpkg":{"source":"iana","extensions":["portpkg"]},"application/vnd.mapbox-vector-tile":{"source":"iana"},"application/vnd.marlin.drm.actiontoken+xml":{"source":"iana"},"application/vnd.marlin.drm.conftoken+xml":{"source":"iana"},"application/vnd.marlin.drm.license+xml":{"source":"iana"},"application/vnd.marlin.drm.mdcf":{"source":"iana"},"application/vnd.mason+json":{"source":"iana","compressible":true},"application/vnd.maxmind.maxmind-db":{"source":"iana"},"application/vnd.mcd":{"source":"iana","extensions":["mcd"]},"application/vnd.medcalcdata":{"source":"iana","extensions":["mc1"]},"application/vnd.mediastation.cdkey":{"source":"iana","extensions":["cdkey"]},"application/vnd.meridian-slingshot":{"source":"iana"},"application/vnd.mfer":{"source":"iana","extensions":["mwf"]},"application/vnd.mfmp":{"source":"iana","extensions":["mfm"]},"application/vnd.micro+json":{"source":"iana","compressible":true},"application/vnd.micrografx.flo":{"source":"iana","extensions":["flo"]},"application/vnd.micrografx.igx":{"source":"iana","extensions":["igx"]},"application/vnd.microsoft.portable-executable":{"source":"iana"},"application/vnd.microsoft.windows.thumbnail-cache":{"source":"iana"},"application/vnd.miele+json":{"source":"iana","compressible":true},"application/vnd.mif":{"source":"iana","extensions":["mif"]},"application/vnd.minisoft-hp3000-save":{"source":"iana"},"application/vnd.mitsubishi.misty-guard.trustweb":{"source":"iana"},"application/vnd.mobius.daf":{"source":"iana","extensions":["daf"]},"application/vnd.mobius.dis":{"source":"iana","extensions":["dis"]},"application/vnd.mobius.mbk":{"source":"iana","extensions":["mbk"]},"application/vnd.mobius.mqy":{"source":"iana","extensions":["mqy"]},"application/vnd.mobius.msl":{"source":"iana","extensions":["msl"]},"application/vnd.mobius.plc":{"source":"iana","extensions":["plc"]},"application/vnd.mobius.txf":{"source":"iana","extensions":["txf"]},"application/vnd.mophun.application":{"source":"iana","extensions":["mpn"]},"application/vnd.mophun.certificate":{"source":"iana","extensions":["mpc"]},"application/vnd.motorola.flexsuite":{"source":"iana"},"application/vnd.motorola.flexsuite.adsi":{"source":"iana"},"application/vnd.motorola.flexsuite.fis":{"source":"iana"},"application/vnd.motorola.flexsuite.gotap":{"source":"iana"},"application/vnd.motorola.flexsuite.kmr":{"source":"iana"},"application/vnd.motorola.flexsuite.ttc":{"source":"iana"},"application/vnd.motorola.flexsuite.wem":{"source":"iana"},"application/vnd.motorola.iprm":{"source":"iana"},"application/vnd.mozilla.xul+xml":{"source":"iana","compressible":true,"extensions":["xul"]},"application/vnd.ms-3mfdocument":{"source":"iana"},"application/vnd.ms-artgalry":{"source":"iana","extensions":["cil"]},"application/vnd.ms-asf":{"source":"iana"},"application/vnd.ms-cab-compressed":{"source":"iana","extensions":["cab"]},"application/vnd.ms-color.iccprofile":{"source":"apache"},"application/vnd.ms-excel":{"source":"iana","compressible":false,"extensions":["xls","xlm","xla","xlc","xlt","xlw"]},"application/vnd.ms-excel.addin.macroenabled.12":{"source":"iana","extensions":["xlam"]},"application/vnd.ms-excel.sheet.binary.macroenabled.12":{"source":"iana","extensions":["xlsb"]},"application/vnd.ms-excel.sheet.macroenabled.12":{"source":"iana","extensions":["xlsm"]},"application/vnd.ms-excel.template.macroenabled.12":{"source":"iana","extensions":["xltm"]},"application/vnd.ms-fontobject":{"source":"iana","compressible":true,"extensions":["eot"]},"application/vnd.ms-htmlhelp":{"source":"iana","extensions":["chm"]},"application/vnd.ms-ims":{"source":"iana","extensions":["ims"]},"application/vnd.ms-lrm":{"source":"iana","extensions":["lrm"]},"application/vnd.ms-office.activex+xml":{"source":"iana"},"application/vnd.ms-officetheme":{"source":"iana","extensions":["thmx"]},"application/vnd.ms-opentype":{"source":"apache","compressible":true},"application/vnd.ms-outlook":{"compressible":false,"extensions":["msg"]},"application/vnd.ms-package.obfuscated-opentype":{"source":"apache"},"application/vnd.ms-pki.seccat":{"source":"apache","extensions":["cat"]},"application/vnd.ms-pki.stl":{"source":"apache","extensions":["stl"]},"application/vnd.ms-playready.initiator+xml":{"source":"iana"},"application/vnd.ms-powerpoint":{"source":"iana","compressible":false,"extensions":["ppt","pps","pot"]},"application/vnd.ms-powerpoint.addin.macroenabled.12":{"source":"iana","extensions":["ppam"]},"application/vnd.ms-powerpoint.presentation.macroenabled.12":{"source":"iana","extensions":["pptm"]},"application/vnd.ms-powerpoint.slide.macroenabled.12":{"source":"iana","extensions":["sldm"]},"application/vnd.ms-powerpoint.slideshow.macroenabled.12":{"source":"iana","extensions":["ppsm"]},"application/vnd.ms-powerpoint.template.macroenabled.12":{"source":"iana","extensions":["potm"]},"application/vnd.ms-printdevicecapabilities+xml":{"source":"iana"},"application/vnd.ms-printing.printticket+xml":{"source":"apache"},"application/vnd.ms-printschematicket+xml":{"source":"iana"},"application/vnd.ms-project":{"source":"iana","extensions":["mpp","mpt"]},"application/vnd.ms-tnef":{"source":"iana"},"application/vnd.ms-windows.devicepairing":{"source":"iana"},"application/vnd.ms-windows.nwprinting.oob":{"source":"iana"},"application/vnd.ms-windows.printerpairing":{"source":"iana"},"application/vnd.ms-windows.wsd.oob":{"source":"iana"},"application/vnd.ms-wmdrm.lic-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.lic-resp":{"source":"iana"},"application/vnd.ms-wmdrm.meter-chlg-req":{"source":"iana"},"application/vnd.ms-wmdrm.meter-resp":{"source":"iana"},"application/vnd.ms-word.document.macroenabled.12":{"source":"iana","extensions":["docm"]},"application/vnd.ms-word.template.macroenabled.12":{"source":"iana","extensions":["dotm"]},"application/vnd.ms-works":{"source":"iana","extensions":["wps","wks","wcm","wdb"]},"application/vnd.ms-wpl":{"source":"iana","extensions":["wpl"]},"application/vnd.ms-xpsdocument":{"source":"iana","compressible":false,"extensions":["xps"]},"application/vnd.msa-disk-image":{"source":"iana"},"application/vnd.mseq":{"source":"iana","extensions":["mseq"]},"application/vnd.msign":{"source":"iana"},"application/vnd.multiad.creator":{"source":"iana"},"application/vnd.multiad.creator.cif":{"source":"iana"},"application/vnd.music-niff":{"source":"iana"},"application/vnd.musician":{"source":"iana","extensions":["mus"]},"application/vnd.muvee.style":{"source":"iana","extensions":["msty"]},"application/vnd.mynfc":{"source":"iana","extensions":["taglet"]},"application/vnd.ncd.control":{"source":"iana"},"application/vnd.ncd.reference":{"source":"iana"},"application/vnd.nearst.inv+json":{"source":"iana","compressible":true},"application/vnd.nervana":{"source":"iana"},"application/vnd.netfpx":{"source":"iana"},"application/vnd.neurolanguage.nlu":{"source":"iana","extensions":["nlu"]},"application/vnd.nintendo.nitro.rom":{"source":"iana"},"application/vnd.nintendo.snes.rom":{"source":"iana"},"application/vnd.nitf":{"source":"iana","extensions":["ntf","nitf"]},"application/vnd.noblenet-directory":{"source":"iana","extensions":["nnd"]},"application/vnd.noblenet-sealer":{"source":"iana","extensions":["nns"]},"application/vnd.noblenet-web":{"source":"iana","extensions":["nnw"]},"application/vnd.nokia.catalogs":{"source":"iana"},"application/vnd.nokia.conml+wbxml":{"source":"iana"},"application/vnd.nokia.conml+xml":{"source":"iana"},"application/vnd.nokia.iptv.config+xml":{"source":"iana"},"application/vnd.nokia.isds-radio-presets":{"source":"iana"},"application/vnd.nokia.landmark+wbxml":{"source":"iana"},"application/vnd.nokia.landmark+xml":{"source":"iana"},"application/vnd.nokia.landmarkcollection+xml":{"source":"iana"},"application/vnd.nokia.n-gage.ac+xml":{"source":"iana"},"application/vnd.nokia.n-gage.data":{"source":"iana","extensions":["ngdat"]},"application/vnd.nokia.n-gage.symbian.install":{"source":"iana","extensions":["n-gage"]},"application/vnd.nokia.ncd":{"source":"iana"},"application/vnd.nokia.pcd+wbxml":{"source":"iana"},"application/vnd.nokia.pcd+xml":{"source":"iana"},"application/vnd.nokia.radio-preset":{"source":"iana","extensions":["rpst"]},"application/vnd.nokia.radio-presets":{"source":"iana","extensions":["rpss"]},"application/vnd.novadigm.edm":{"source":"iana","extensions":["edm"]},"application/vnd.novadigm.edx":{"source":"iana","extensions":["edx"]},"application/vnd.novadigm.ext":{"source":"iana","extensions":["ext"]},"application/vnd.ntt-local.content-share":{"source":"iana"},"application/vnd.ntt-local.file-transfer":{"source":"iana"},"application/vnd.ntt-local.ogw_remote-access":{"source":"iana"},"application/vnd.ntt-local.sip-ta_remote":{"source":"iana"},"application/vnd.ntt-local.sip-ta_tcp_stream":{"source":"iana"},"application/vnd.oasis.opendocument.chart":{"source":"iana","extensions":["odc"]},"application/vnd.oasis.opendocument.chart-template":{"source":"iana","extensions":["otc"]},"application/vnd.oasis.opendocument.database":{"source":"iana","extensions":["odb"]},"application/vnd.oasis.opendocument.formula":{"source":"iana","extensions":["odf"]},"application/vnd.oasis.opendocument.formula-template":{"source":"iana","extensions":["odft"]},"application/vnd.oasis.opendocument.graphics":{"source":"iana","compressible":false,"extensions":["odg"]},"application/vnd.oasis.opendocument.graphics-template":{"source":"iana","extensions":["otg"]},"application/vnd.oasis.opendocument.image":{"source":"iana","extensions":["odi"]},"application/vnd.oasis.opendocument.image-template":{"source":"iana","extensions":["oti"]},"application/vnd.oasis.opendocument.presentation":{"source":"iana","compressible":false,"extensions":["odp"]},"application/vnd.oasis.opendocument.presentation-template":{"source":"iana","extensions":["otp"]},"application/vnd.oasis.opendocument.spreadsheet":{"source":"iana","compressible":false,"extensions":["ods"]},"application/vnd.oasis.opendocument.spreadsheet-template":{"source":"iana","extensions":["ots"]},"application/vnd.oasis.opendocument.text":{"source":"iana","compressible":false,"extensions":["odt"]},"application/vnd.oasis.opendocument.text-master":{"source":"iana","extensions":["odm"]},"application/vnd.oasis.opendocument.text-template":{"source":"iana","extensions":["ott"]},"application/vnd.oasis.opendocument.text-web":{"source":"iana","extensions":["oth"]},"application/vnd.obn":{"source":"iana"},"application/vnd.ocf+cbor":{"source":"iana"},"application/vnd.oftn.l10n+json":{"source":"iana","compressible":true},"application/vnd.oipf.contentaccessdownload+xml":{"source":"iana"},"application/vnd.oipf.contentaccessstreaming+xml":{"source":"iana"},"application/vnd.oipf.cspg-hexbinary":{"source":"iana"},"application/vnd.oipf.dae.svg+xml":{"source":"iana"},"application/vnd.oipf.dae.xhtml+xml":{"source":"iana"},"application/vnd.oipf.mippvcontrolmessage+xml":{"source":"iana"},"application/vnd.oipf.pae.gem":{"source":"iana"},"application/vnd.oipf.spdiscovery+xml":{"source":"iana"},"application/vnd.oipf.spdlist+xml":{"source":"iana"},"application/vnd.oipf.ueprofile+xml":{"source":"iana"},"application/vnd.oipf.userprofile+xml":{"source":"iana"},"application/vnd.olpc-sugar":{"source":"iana","extensions":["xo"]},"application/vnd.oma-scws-config":{"source":"iana"},"application/vnd.oma-scws-http-request":{"source":"iana"},"application/vnd.oma-scws-http-response":{"source":"iana"},"application/vnd.oma.bcast.associated-procedure-parameter+xml":{"source":"iana"},"application/vnd.oma.bcast.drm-trigger+xml":{"source":"iana"},"application/vnd.oma.bcast.imd+xml":{"source":"iana"},"application/vnd.oma.bcast.ltkm":{"source":"iana"},"application/vnd.oma.bcast.notification+xml":{"source":"iana"},"application/vnd.oma.bcast.provisioningtrigger":{"source":"iana"},"application/vnd.oma.bcast.sgboot":{"source":"iana"},"application/vnd.oma.bcast.sgdd+xml":{"source":"iana"},"application/vnd.oma.bcast.sgdu":{"source":"iana"},"application/vnd.oma.bcast.simple-symbol-container":{"source":"iana"},"application/vnd.oma.bcast.smartcard-trigger+xml":{"source":"iana"},"application/vnd.oma.bcast.sprov+xml":{"source":"iana"},"application/vnd.oma.bcast.stkm":{"source":"iana"},"application/vnd.oma.cab-address-book+xml":{"source":"iana"},"application/vnd.oma.cab-feature-handler+xml":{"source":"iana"},"application/vnd.oma.cab-pcc+xml":{"source":"iana"},"application/vnd.oma.cab-subs-invite+xml":{"source":"iana"},"application/vnd.oma.cab-user-prefs+xml":{"source":"iana"},"application/vnd.oma.dcd":{"source":"iana"},"application/vnd.oma.dcdc":{"source":"iana"},"application/vnd.oma.dd2+xml":{"source":"iana","extensions":["dd2"]},"application/vnd.oma.drm.risd+xml":{"source":"iana"},"application/vnd.oma.group-usage-list+xml":{"source":"iana"},"application/vnd.oma.lwm2m+json":{"source":"iana","compressible":true},"application/vnd.oma.lwm2m+tlv":{"source":"iana"},"application/vnd.oma.pal+xml":{"source":"iana"},"application/vnd.oma.poc.detailed-progress-report+xml":{"source":"iana"},"application/vnd.oma.poc.final-report+xml":{"source":"iana"},"application/vnd.oma.poc.groups+xml":{"source":"iana"},"application/vnd.oma.poc.invocation-descriptor+xml":{"source":"iana"},"application/vnd.oma.poc.optimized-progress-report+xml":{"source":"iana"},"application/vnd.oma.push":{"source":"iana"},"application/vnd.oma.scidm.messages+xml":{"source":"iana"},"application/vnd.oma.xcap-directory+xml":{"source":"iana"},"application/vnd.omads-email+xml":{"source":"iana"},"application/vnd.omads-file+xml":{"source":"iana"},"application/vnd.omads-folder+xml":{"source":"iana"},"application/vnd.omaloc-supl-init":{"source":"iana"},"application/vnd.onepager":{"source":"iana"},"application/vnd.onepagertamp":{"source":"iana"},"application/vnd.onepagertamx":{"source":"iana"},"application/vnd.onepagertat":{"source":"iana"},"application/vnd.onepagertatp":{"source":"iana"},"application/vnd.onepagertatx":{"source":"iana"},"application/vnd.openblox.game+xml":{"source":"iana"},"application/vnd.openblox.game-binary":{"source":"iana"},"application/vnd.openeye.oeb":{"source":"iana"},"application/vnd.openofficeorg.extension":{"source":"apache","extensions":["oxt"]},"application/vnd.openstreetmap.data+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.custom-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.customxmlproperties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawing+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.chart+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.chartshapes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramcolors+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramdata+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramlayout+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.drawingml.diagramstyle+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.extended-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.commentauthors+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.handoutmaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.notesmaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.notesslide+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.presentation":{"source":"iana","compressible":false,"extensions":["pptx"]},"application/vnd.openxmlformats-officedocument.presentationml.presentation.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.presprops+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slide":{"source":"iana","extensions":["sldx"]},"application/vnd.openxmlformats-officedocument.presentationml.slide+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slidelayout+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slidemaster+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slideshow":{"source":"iana","extensions":["ppsx"]},"application/vnd.openxmlformats-officedocument.presentationml.slideshow.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.slideupdateinfo+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.tablestyles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.tags+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.template":{"source":"iana","extensions":["potx"]},"application/vnd.openxmlformats-officedocument.presentationml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.presentationml.viewprops+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.calcchain+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.chartsheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.connections+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.dialogsheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.externallink+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcachedefinition+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivotcacherecords+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.pivottable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.querytable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionheaders+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.revisionlog+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sharedstrings+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":{"source":"iana","compressible":false,"extensions":["xlsx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.sheetmetadata+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.styles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.table+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.tablesinglecells+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.template":{"source":"iana","extensions":["xltx"]},"application/vnd.openxmlformats-officedocument.spreadsheetml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.usernames+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.volatiledependencies+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.spreadsheetml.worksheet+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.theme+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.themeoverride+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.vmldrawing":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.document":{"source":"iana","compressible":false,"extensions":["docx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.glossary+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.fonttable+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.template":{"source":"iana","extensions":["dotx"]},"application/vnd.openxmlformats-officedocument.wordprocessingml.template.main+xml":{"source":"iana"},"application/vnd.openxmlformats-officedocument.wordprocessingml.websettings+xml":{"source":"iana"},"application/vnd.openxmlformats-package.core-properties+xml":{"source":"iana"},"application/vnd.openxmlformats-package.digital-signature-xmlsignature+xml":{"source":"iana"},"application/vnd.openxmlformats-package.relationships+xml":{"source":"iana"},"application/vnd.oracle.resource+json":{"source":"iana","compressible":true},"application/vnd.orange.indata":{"source":"iana"},"application/vnd.osa.netdeploy":{"source":"iana"},"application/vnd.osgeo.mapguide.package":{"source":"iana","extensions":["mgp"]},"application/vnd.osgi.bundle":{"source":"iana"},"application/vnd.osgi.dp":{"source":"iana","extensions":["dp"]},"application/vnd.osgi.subsystem":{"source":"iana","extensions":["esa"]},"application/vnd.otps.ct-kip+xml":{"source":"iana"},"application/vnd.oxli.countgraph":{"source":"iana"},"application/vnd.pagerduty+json":{"source":"iana","compressible":true},"application/vnd.palm":{"source":"iana","extensions":["pdb","pqa","oprc"]},"application/vnd.panoply":{"source":"iana"},"application/vnd.paos+xml":{"source":"iana"},"application/vnd.paos.xml":{"source":"apache"},"application/vnd.patentdive":{"source":"iana"},"application/vnd.pawaafile":{"source":"iana","extensions":["paw"]},"application/vnd.pcos":{"source":"iana"},"application/vnd.pg.format":{"source":"iana","extensions":["str"]},"application/vnd.pg.osasli":{"source":"iana","extensions":["ei6"]},"application/vnd.piaccess.application-licence":{"source":"iana"},"application/vnd.picsel":{"source":"iana","extensions":["efif"]},"application/vnd.pmi.widget":{"source":"iana","extensions":["wg"]},"application/vnd.poc.group-advertisement+xml":{"source":"iana"},"application/vnd.pocketlearn":{"source":"iana","extensions":["plf"]},"application/vnd.powerbuilder6":{"source":"iana","extensions":["pbd"]},"application/vnd.powerbuilder6-s":{"source":"iana"},"application/vnd.powerbuilder7":{"source":"iana"},"application/vnd.powerbuilder7-s":{"source":"iana"},"application/vnd.powerbuilder75":{"source":"iana"},"application/vnd.powerbuilder75-s":{"source":"iana"},"application/vnd.preminet":{"source":"iana"},"application/vnd.previewsystems.box":{"source":"iana","extensions":["box"]},"application/vnd.proteus.magazine":{"source":"iana","extensions":["mgz"]},"application/vnd.publishare-delta-tree":{"source":"iana","extensions":["qps"]},"application/vnd.pvi.ptid1":{"source":"iana","extensions":["ptid"]},"application/vnd.pwg-multiplexed":{"source":"iana"},"application/vnd.pwg-xhtml-print+xml":{"source":"iana"},"application/vnd.qualcomm.brew-app-res":{"source":"iana"},"application/vnd.quarantainenet":{"source":"iana"},"application/vnd.quark.quarkxpress":{"source":"iana","extensions":["qxd","qxt","qwd","qwt","qxl","qxb"]},"application/vnd.quobject-quoxdocument":{"source":"iana"},"application/vnd.radisys.moml+xml":{"source":"iana"},"application/vnd.radisys.msml+xml":{"source":"iana"},"application/vnd.radisys.msml-audit+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-conf+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-conn+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-dialog+xml":{"source":"iana"},"application/vnd.radisys.msml-audit-stream+xml":{"source":"iana"},"application/vnd.radisys.msml-conf+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-base+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-fax-detect+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-fax-sendrecv+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-group+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-speech+xml":{"source":"iana"},"application/vnd.radisys.msml-dialog-transform+xml":{"source":"iana"},"application/vnd.rainstor.data":{"source":"iana"},"application/vnd.rapid":{"source":"iana"},"application/vnd.rar":{"source":"iana"},"application/vnd.realvnc.bed":{"source":"iana","extensions":["bed"]},"application/vnd.recordare.musicxml":{"source":"iana","extensions":["mxl"]},"application/vnd.recordare.musicxml+xml":{"source":"iana","extensions":["musicxml"]},"application/vnd.renlearn.rlprint":{"source":"iana"},"application/vnd.restful+json":{"source":"iana","compressible":true},"application/vnd.rig.cryptonote":{"source":"iana","extensions":["cryptonote"]},"application/vnd.rim.cod":{"source":"apache","extensions":["cod"]},"application/vnd.rn-realmedia":{"source":"apache","extensions":["rm"]},"application/vnd.rn-realmedia-vbr":{"source":"apache","extensions":["rmvb"]},"application/vnd.route66.link66+xml":{"source":"iana","extensions":["link66"]},"application/vnd.rs-274x":{"source":"iana"},"application/vnd.ruckus.download":{"source":"iana"},"application/vnd.s3sms":{"source":"iana"},"application/vnd.sailingtracker.track":{"source":"iana","extensions":["st"]},"application/vnd.sbm.cid":{"source":"iana"},"application/vnd.sbm.mid2":{"source":"iana"},"application/vnd.scribus":{"source":"iana"},"application/vnd.sealed.3df":{"source":"iana"},"application/vnd.sealed.csf":{"source":"iana"},"application/vnd.sealed.doc":{"source":"iana"},"application/vnd.sealed.eml":{"source":"iana"},"application/vnd.sealed.mht":{"source":"iana"},"application/vnd.sealed.net":{"source":"iana"},"application/vnd.sealed.ppt":{"source":"iana"},"application/vnd.sealed.tiff":{"source":"iana"},"application/vnd.sealed.xls":{"source":"iana"},"application/vnd.sealedmedia.softseal.html":{"source":"iana"},"application/vnd.sealedmedia.softseal.pdf":{"source":"iana"},"application/vnd.seemail":{"source":"iana","extensions":["see"]},"application/vnd.sema":{"source":"iana","extensions":["sema"]},"application/vnd.semd":{"source":"iana","extensions":["semd"]},"application/vnd.semf":{"source":"iana","extensions":["semf"]},"application/vnd.shana.informed.formdata":{"source":"iana","extensions":["ifm"]},"application/vnd.shana.informed.formtemplate":{"source":"iana","extensions":["itp"]},"application/vnd.shana.informed.interchange":{"source":"iana","extensions":["iif"]},"application/vnd.shana.informed.package":{"source":"iana","extensions":["ipk"]},"application/vnd.sigrok.session":{"source":"iana"},"application/vnd.simtech-mindmapper":{"source":"iana","extensions":["twd","twds"]},"application/vnd.siren+json":{"source":"iana","compressible":true},"application/vnd.smaf":{"source":"iana","extensions":["mmf"]},"application/vnd.smart.notebook":{"source":"iana"},"application/vnd.smart.teacher":{"source":"iana","extensions":["teacher"]},"application/vnd.software602.filler.form+xml":{"source":"iana"},"application/vnd.software602.filler.form-xml-zip":{"source":"iana"},"application/vnd.solent.sdkm+xml":{"source":"iana","extensions":["sdkm","sdkd"]},"application/vnd.spotfire.dxp":{"source":"iana","extensions":["dxp"]},"application/vnd.spotfire.sfs":{"source":"iana","extensions":["sfs"]},"application/vnd.sqlite3":{"source":"iana"},"application/vnd.sss-cod":{"source":"iana"},"application/vnd.sss-dtf":{"source":"iana"},"application/vnd.sss-ntf":{"source":"iana"},"application/vnd.stardivision.calc":{"source":"apache","extensions":["sdc"]},"application/vnd.stardivision.draw":{"source":"apache","extensions":["sda"]},"application/vnd.stardivision.impress":{"source":"apache","extensions":["sdd"]},"application/vnd.stardivision.math":{"source":"apache","extensions":["smf"]},"application/vnd.stardivision.writer":{"source":"apache","extensions":["sdw","vor"]},"application/vnd.stardivision.writer-global":{"source":"apache","extensions":["sgl"]},"application/vnd.stepmania.package":{"source":"iana","extensions":["smzip"]},"application/vnd.stepmania.stepchart":{"source":"iana","extensions":["sm"]},"application/vnd.street-stream":{"source":"iana"},"application/vnd.sun.wadl+xml":{"source":"iana","compressible":true,"extensions":["wadl"]},"application/vnd.sun.xml.calc":{"source":"apache","extensions":["sxc"]},"application/vnd.sun.xml.calc.template":{"source":"apache","extensions":["stc"]},"application/vnd.sun.xml.draw":{"source":"apache","extensions":["sxd"]},"application/vnd.sun.xml.draw.template":{"source":"apache","extensions":["std"]},"application/vnd.sun.xml.impress":{"source":"apache","extensions":["sxi"]},"application/vnd.sun.xml.impress.template":{"source":"apache","extensions":["sti"]},"application/vnd.sun.xml.math":{"source":"apache","extensions":["sxm"]},"application/vnd.sun.xml.writer":{"source":"apache","extensions":["sxw"]},"application/vnd.sun.xml.writer.global":{"source":"apache","extensions":["sxg"]},"application/vnd.sun.xml.writer.template":{"source":"apache","extensions":["stw"]},"application/vnd.sus-calendar":{"source":"iana","extensions":["sus","susp"]},"application/vnd.svd":{"source":"iana","extensions":["svd"]},"application/vnd.swiftview-ics":{"source":"iana"},"application/vnd.symbian.install":{"source":"apache","extensions":["sis","sisx"]},"application/vnd.syncml+xml":{"source":"iana","extensions":["xsm"]},"application/vnd.syncml.dm+wbxml":{"source":"iana","extensions":["bdm"]},"application/vnd.syncml.dm+xml":{"source":"iana","extensions":["xdm"]},"application/vnd.syncml.dm.notification":{"source":"iana"},"application/vnd.syncml.dmddf+wbxml":{"source":"iana"},"application/vnd.syncml.dmddf+xml":{"source":"iana"},"application/vnd.syncml.dmtnds+wbxml":{"source":"iana"},"application/vnd.syncml.dmtnds+xml":{"source":"iana"},"application/vnd.syncml.ds.notification":{"source":"iana"},"application/vnd.tableschema+json":{"source":"iana","compressible":true},"application/vnd.tao.intent-module-archive":{"source":"iana","extensions":["tao"]},"application/vnd.tcpdump.pcap":{"source":"iana","extensions":["pcap","cap","dmp"]},"application/vnd.tmd.mediaflex.api+xml":{"source":"iana"},"application/vnd.tml":{"source":"iana"},"application/vnd.tmobile-livetv":{"source":"iana","extensions":["tmo"]},"application/vnd.tri.onesource":{"source":"iana"},"application/vnd.trid.tpt":{"source":"iana","extensions":["tpt"]},"application/vnd.triscape.mxs":{"source":"iana","extensions":["mxs"]},"application/vnd.trueapp":{"source":"iana","extensions":["tra"]},"application/vnd.truedoc":{"source":"iana"},"application/vnd.ubisoft.webplayer":{"source":"iana"},"application/vnd.ufdl":{"source":"iana","extensions":["ufd","ufdl"]},"application/vnd.uiq.theme":{"source":"iana","extensions":["utz"]},"application/vnd.umajin":{"source":"iana","extensions":["umj"]},"application/vnd.unity":{"source":"iana","extensions":["unityweb"]},"application/vnd.uoml+xml":{"source":"iana","extensions":["uoml"]},"application/vnd.uplanet.alert":{"source":"iana"},"application/vnd.uplanet.alert-wbxml":{"source":"iana"},"application/vnd.uplanet.bearer-choice":{"source":"iana"},"application/vnd.uplanet.bearer-choice-wbxml":{"source":"iana"},"application/vnd.uplanet.cacheop":{"source":"iana"},"application/vnd.uplanet.cacheop-wbxml":{"source":"iana"},"application/vnd.uplanet.channel":{"source":"iana"},"application/vnd.uplanet.channel-wbxml":{"source":"iana"},"application/vnd.uplanet.list":{"source":"iana"},"application/vnd.uplanet.list-wbxml":{"source":"iana"},"application/vnd.uplanet.listcmd":{"source":"iana"},"application/vnd.uplanet.listcmd-wbxml":{"source":"iana"},"application/vnd.uplanet.signal":{"source":"iana"},"application/vnd.uri-map":{"source":"iana"},"application/vnd.valve.source.material":{"source":"iana"},"application/vnd.vcx":{"source":"iana","extensions":["vcx"]},"application/vnd.vd-study":{"source":"iana"},"application/vnd.vectorworks":{"source":"iana"},"application/vnd.vel+json":{"source":"iana","compressible":true},"application/vnd.verimatrix.vcas":{"source":"iana"},"application/vnd.vidsoft.vidconference":{"source":"iana"},"application/vnd.visio":{"source":"iana","extensions":["vsd","vst","vss","vsw"]},"application/vnd.visionary":{"source":"iana","extensions":["vis"]},"application/vnd.vividence.scriptfile":{"source":"iana"},"application/vnd.vsf":{"source":"iana","extensions":["vsf"]},"application/vnd.wap.sic":{"source":"iana"},"application/vnd.wap.slc":{"source":"iana"},"application/vnd.wap.wbxml":{"source":"iana","extensions":["wbxml"]},"application/vnd.wap.wmlc":{"source":"iana","extensions":["wmlc"]},"application/vnd.wap.wmlscriptc":{"source":"iana","extensions":["wmlsc"]},"application/vnd.webturbo":{"source":"iana","extensions":["wtb"]},"application/vnd.wfa.p2p":{"source":"iana"},"application/vnd.wfa.wsc":{"source":"iana"},"application/vnd.windows.devicepairing":{"source":"iana"},"application/vnd.wmc":{"source":"iana"},"application/vnd.wmf.bootstrap":{"source":"iana"},"application/vnd.wolfram.mathematica":{"source":"iana"},"application/vnd.wolfram.mathematica.package":{"source":"iana"},"application/vnd.wolfram.player":{"source":"iana","extensions":["nbp"]},"application/vnd.wordperfect":{"source":"iana","extensions":["wpd"]},"application/vnd.wqd":{"source":"iana","extensions":["wqd"]},"application/vnd.wrq-hp3000-labelled":{"source":"iana"},"application/vnd.wt.stf":{"source":"iana","extensions":["stf"]},"application/vnd.wv.csp+wbxml":{"source":"iana"},"application/vnd.wv.csp+xml":{"source":"iana"},"application/vnd.wv.ssp+xml":{"source":"iana"},"application/vnd.xacml+json":{"source":"iana","compressible":true},"application/vnd.xara":{"source":"iana","extensions":["xar"]},"application/vnd.xfdl":{"source":"iana","extensions":["xfdl"]},"application/vnd.xfdl.webform":{"source":"iana"},"application/vnd.xmi+xml":{"source":"iana"},"application/vnd.xmpie.cpkg":{"source":"iana"},"application/vnd.xmpie.dpkg":{"source":"iana"},"application/vnd.xmpie.plan":{"source":"iana"},"application/vnd.xmpie.ppkg":{"source":"iana"},"application/vnd.xmpie.xlim":{"source":"iana"},"application/vnd.yamaha.hv-dic":{"source":"iana","extensions":["hvd"]},"application/vnd.yamaha.hv-script":{"source":"iana","extensions":["hvs"]},"application/vnd.yamaha.hv-voice":{"source":"iana","extensions":["hvp"]},"application/vnd.yamaha.openscoreformat":{"source":"iana","extensions":["osf"]},"application/vnd.yamaha.openscoreformat.osfpvg+xml":{"source":"iana","extensions":["osfpvg"]},"application/vnd.yamaha.remote-setup":{"source":"iana"},"application/vnd.yamaha.smaf-audio":{"source":"iana","extensions":["saf"]},"application/vnd.yamaha.smaf-phrase":{"source":"iana","extensions":["spf"]},"application/vnd.yamaha.through-ngn":{"source":"iana"},"application/vnd.yamaha.tunnel-udpencap":{"source":"iana"},"application/vnd.yaoweme":{"source":"iana"},"application/vnd.yellowriver-custom-menu":{"source":"iana","extensions":["cmp"]},"application/vnd.youtube.yt":{"source":"iana"},"application/vnd.zul":{"source":"iana","extensions":["zir","zirz"]},"application/vnd.zzazz.deck+xml":{"source":"iana","extensions":["zaz"]},"application/voicexml+xml":{"source":"iana","extensions":["vxml"]},"application/voucher-cms+json":{"source":"iana","compressible":true},"application/vq-rtcpxr":{"source":"iana"},"application/wasm":{"compressible":true,"extensions":["wasm"]},"application/watcherinfo+xml":{"source":"iana"},"application/webpush-options+json":{"source":"iana","compressible":true},"application/whoispp-query":{"source":"iana"},"application/whoispp-response":{"source":"iana"},"application/widget":{"source":"iana","extensions":["wgt"]},"application/winhlp":{"source":"apache","extensions":["hlp"]},"application/wita":{"source":"iana"},"application/wordperfect5.1":{"source":"iana"},"application/wsdl+xml":{"source":"iana","extensions":["wsdl"]},"application/wspolicy+xml":{"source":"iana","extensions":["wspolicy"]},"application/x-7z-compressed":{"source":"apache","compressible":false,"extensions":["7z"]},"application/x-abiword":{"source":"apache","extensions":["abw"]},"application/x-ace-compressed":{"source":"apache","extensions":["ace"]},"application/x-amf":{"source":"apache"},"application/x-apple-diskimage":{"source":"apache","extensions":["dmg"]},"application/x-arj":{"compressible":false,"extensions":["arj"]},"application/x-authorware-bin":{"source":"apache","extensions":["aab","x32","u32","vox"]},"application/x-authorware-map":{"source":"apache","extensions":["aam"]},"application/x-authorware-seg":{"source":"apache","extensions":["aas"]},"application/x-bcpio":{"source":"apache","extensions":["bcpio"]},"application/x-bdoc":{"compressible":false,"extensions":["bdoc"]},"application/x-bittorrent":{"source":"apache","extensions":["torrent"]},"application/x-blorb":{"source":"apache","extensions":["blb","blorb"]},"application/x-bzip":{"source":"apache","compressible":false,"extensions":["bz"]},"application/x-bzip2":{"source":"apache","compressible":false,"extensions":["bz2","boz"]},"application/x-cbr":{"source":"apache","extensions":["cbr","cba","cbt","cbz","cb7"]},"application/x-cdlink":{"source":"apache","extensions":["vcd"]},"application/x-cfs-compressed":{"source":"apache","extensions":["cfs"]},"application/x-chat":{"source":"apache","extensions":["chat"]},"application/x-chess-pgn":{"source":"apache","extensions":["pgn"]},"application/x-chrome-extension":{"extensions":["crx"]},"application/x-cocoa":{"source":"nginx","extensions":["cco"]},"application/x-compress":{"source":"apache"},"application/x-conference":{"source":"apache","extensions":["nsc"]},"application/x-cpio":{"source":"apache","extensions":["cpio"]},"application/x-csh":{"source":"apache","extensions":["csh"]},"application/x-deb":{"compressible":false},"application/x-debian-package":{"source":"apache","extensions":["deb","udeb"]},"application/x-dgc-compressed":{"source":"apache","extensions":["dgc"]},"application/x-director":{"source":"apache","extensions":["dir","dcr","dxr","cst","cct","cxt","w3d","fgd","swa"]},"application/x-doom":{"source":"apache","extensions":["wad"]},"application/x-dtbncx+xml":{"source":"apache","extensions":["ncx"]},"application/x-dtbook+xml":{"source":"apache","extensions":["dtb"]},"application/x-dtbresource+xml":{"source":"apache","extensions":["res"]},"application/x-dvi":{"source":"apache","compressible":false,"extensions":["dvi"]},"application/x-envoy":{"source":"apache","extensions":["evy"]},"application/x-eva":{"source":"apache","extensions":["eva"]},"application/x-font-bdf":{"source":"apache","extensions":["bdf"]},"application/x-font-dos":{"source":"apache"},"application/x-font-framemaker":{"source":"apache"},"application/x-font-ghostscript":{"source":"apache","extensions":["gsf"]},"application/x-font-libgrx":{"source":"apache"},"application/x-font-linux-psf":{"source":"apache","extensions":["psf"]},"application/x-font-pcf":{"source":"apache","extensions":["pcf"]},"application/x-font-snf":{"source":"apache","extensions":["snf"]},"application/x-font-speedo":{"source":"apache"},"application/x-font-sunos-news":{"source":"apache"},"application/x-font-type1":{"source":"apache","extensions":["pfa","pfb","pfm","afm"]},"application/x-font-vfont":{"source":"apache"},"application/x-freearc":{"source":"apache","extensions":["arc"]},"application/x-futuresplash":{"source":"apache","extensions":["spl"]},"application/x-gca-compressed":{"source":"apache","extensions":["gca"]},"application/x-glulx":{"source":"apache","extensions":["ulx"]},"application/x-gnumeric":{"source":"apache","extensions":["gnumeric"]},"application/x-gramps-xml":{"source":"apache","extensions":["gramps"]},"application/x-gtar":{"source":"apache","extensions":["gtar"]},"application/x-gzip":{"source":"apache"},"application/x-hdf":{"source":"apache","extensions":["hdf"]},"application/x-httpd-php":{"compressible":true,"extensions":["php"]},"application/x-install-instructions":{"source":"apache","extensions":["install"]},"application/x-iso9660-image":{"source":"apache","extensions":["iso"]},"application/x-java-archive-diff":{"source":"nginx","extensions":["jardiff"]},"application/x-java-jnlp-file":{"source":"apache","compressible":false,"extensions":["jnlp"]},"application/x-javascript":{"compressible":true},"application/x-latex":{"source":"apache","compressible":false,"extensions":["latex"]},"application/x-lua-bytecode":{"extensions":["luac"]},"application/x-lzh-compressed":{"source":"apache","extensions":["lzh","lha"]},"application/x-makeself":{"source":"nginx","extensions":["run"]},"application/x-mie":{"source":"apache","extensions":["mie"]},"application/x-mobipocket-ebook":{"source":"apache","extensions":["prc","mobi"]},"application/x-mpegurl":{"compressible":false},"application/x-ms-application":{"source":"apache","extensions":["application"]},"application/x-ms-shortcut":{"source":"apache","extensions":["lnk"]},"application/x-ms-wmd":{"source":"apache","extensions":["wmd"]},"application/x-ms-wmz":{"source":"apache","extensions":["wmz"]},"application/x-ms-xbap":{"source":"apache","extensions":["xbap"]},"application/x-msaccess":{"source":"apache","extensions":["mdb"]},"application/x-msbinder":{"source":"apache","extensions":["obd"]},"application/x-mscardfile":{"source":"apache","extensions":["crd"]},"application/x-msclip":{"source":"apache","extensions":["clp"]},"application/x-msdos-program":{"extensions":["exe"]},"application/x-msdownload":{"source":"apache","extensions":["exe","dll","com","bat","msi"]},"application/x-msmediaview":{"source":"apache","extensions":["mvb","m13","m14"]},"application/x-msmetafile":{"source":"apache","extensions":["wmf","wmz","emf","emz"]},"application/x-msmoney":{"source":"apache","extensions":["mny"]},"application/x-mspublisher":{"source":"apache","extensions":["pub"]},"application/x-msschedule":{"source":"apache","extensions":["scd"]},"application/x-msterminal":{"source":"apache","extensions":["trm"]},"application/x-mswrite":{"source":"apache","extensions":["wri"]},"application/x-netcdf":{"source":"apache","extensions":["nc","cdf"]},"application/x-ns-proxy-autoconfig":{"compressible":true,"extensions":["pac"]},"application/x-nzb":{"source":"apache","extensions":["nzb"]},"application/x-perl":{"source":"nginx","extensions":["pl","pm"]},"application/x-pilot":{"source":"nginx","extensions":["prc","pdb"]},"application/x-pkcs12":{"source":"apache","compressible":false,"extensions":["p12","pfx"]},"application/x-pkcs7-certificates":{"source":"apache","extensions":["p7b","spc"]},"application/x-pkcs7-certreqresp":{"source":"apache","extensions":["p7r"]},"application/x-rar-compressed":{"source":"apache","compressible":false,"extensions":["rar"]},"application/x-redhat-package-manager":{"source":"nginx","extensions":["rpm"]},"application/x-research-info-systems":{"source":"apache","extensions":["ris"]},"application/x-sea":{"source":"nginx","extensions":["sea"]},"application/x-sh":{"source":"apache","compressible":true,"extensions":["sh"]},"application/x-shar":{"source":"apache","extensions":["shar"]},"application/x-shockwave-flash":{"source":"apache","compressible":false,"extensions":["swf"]},"application/x-silverlight-app":{"source":"apache","extensions":["xap"]},"application/x-sql":{"source":"apache","extensions":["sql"]},"application/x-stuffit":{"source":"apache","compressible":false,"extensions":["sit"]},"application/x-stuffitx":{"source":"apache","extensions":["sitx"]},"application/x-subrip":{"source":"apache","extensions":["srt"]},"application/x-sv4cpio":{"source":"apache","extensions":["sv4cpio"]},"application/x-sv4crc":{"source":"apache","extensions":["sv4crc"]},"application/x-t3vm-image":{"source":"apache","extensions":["t3"]},"application/x-tads":{"source":"apache","extensions":["gam"]},"application/x-tar":{"source":"apache","compressible":true,"extensions":["tar"]},"application/x-tcl":{"source":"apache","extensions":["tcl","tk"]},"application/x-tex":{"source":"apache","extensions":["tex"]},"application/x-tex-tfm":{"source":"apache","extensions":["tfm"]},"application/x-texinfo":{"source":"apache","extensions":["texinfo","texi"]},"application/x-tgif":{"source":"apache","extensions":["obj"]},"application/x-ustar":{"source":"apache","extensions":["ustar"]},"application/x-virtualbox-hdd":{"compressible":true,"extensions":["hdd"]},"application/x-virtualbox-ova":{"compressible":true,"extensions":["ova"]},"application/x-virtualbox-ovf":{"compressible":true,"extensions":["ovf"]},"application/x-virtualbox-vbox":{"compressible":true,"extensions":["vbox"]},"application/x-virtualbox-vbox-extpack":{"compressible":false,"extensions":["vbox-extpack"]},"application/x-virtualbox-vdi":{"compressible":true,"extensions":["vdi"]},"application/x-virtualbox-vhd":{"compressible":true,"extensions":["vhd"]},"application/x-virtualbox-vmdk":{"compressible":true,"extensions":["vmdk"]},"application/x-wais-source":{"source":"apache","extensions":["src"]},"application/x-web-app-manifest+json":{"compressible":true,"extensions":["webapp"]},"application/x-www-form-urlencoded":{"source":"iana","compressible":true},"application/x-x509-ca-cert":{"source":"apache","extensions":["der","crt","pem"]},"application/x-xfig":{"source":"apache","extensions":["fig"]},"application/x-xliff+xml":{"source":"apache","extensions":["xlf"]},"application/x-xpinstall":{"source":"apache","compressible":false,"extensions":["xpi"]},"application/x-xz":{"source":"apache","extensions":["xz"]},"application/x-zmachine":{"source":"apache","extensions":["z1","z2","z3","z4","z5","z6","z7","z8"]},"application/x400-bp":{"source":"iana"},"application/xacml+xml":{"source":"iana"},"application/xaml+xml":{"source":"apache","extensions":["xaml"]},"application/xcap-att+xml":{"source":"iana"},"application/xcap-caps+xml":{"source":"iana"},"application/xcap-diff+xml":{"source":"iana","extensions":["xdf"]},"application/xcap-el+xml":{"source":"iana"},"application/xcap-error+xml":{"source":"iana"},"application/xcap-ns+xml":{"source":"iana"},"application/xcon-conference-info+xml":{"source":"iana"},"application/xcon-conference-info-diff+xml":{"source":"iana"},"application/xenc+xml":{"source":"iana","extensions":["xenc"]},"application/xhtml+xml":{"source":"iana","compressible":true,"extensions":["xhtml","xht"]},"application/xhtml-voice+xml":{"source":"apache"},"application/xml":{"source":"iana","compressible":true,"extensions":["xml","xsl","xsd","rng"]},"application/xml-dtd":{"source":"iana","compressible":true,"extensions":["dtd"]},"application/xml-external-parsed-entity":{"source":"iana"},"application/xml-patch+xml":{"source":"iana"},"application/xmpp+xml":{"source":"iana"},"application/xop+xml":{"source":"iana","compressible":true,"extensions":["xop"]},"application/xproc+xml":{"source":"apache","extensions":["xpl"]},"application/xslt+xml":{"source":"iana","extensions":["xslt"]},"application/xspf+xml":{"source":"apache","extensions":["xspf"]},"application/xv+xml":{"source":"iana","extensions":["mxml","xhvml","xvml","xvm"]},"application/yang":{"source":"iana","extensions":["yang"]},"application/yang-data+json":{"source":"iana","compressible":true},"application/yang-data+xml":{"source":"iana"},"application/yang-patch+json":{"source":"iana","compressible":true},"application/yang-patch+xml":{"source":"iana"},"application/yin+xml":{"source":"iana","extensions":["yin"]},"application/zip":{"source":"iana","compressible":false,"extensions":["zip"]},"application/zlib":{"source":"iana"},"audio/1d-interleaved-parityfec":{"source":"iana"},"audio/32kadpcm":{"source":"iana"},"audio/3gpp":{"source":"iana","compressible":false,"extensions":["3gpp"]},"audio/3gpp2":{"source":"iana"},"audio/ac3":{"source":"iana"},"audio/adpcm":{"source":"apache","extensions":["adp"]},"audio/amr":{"source":"iana"},"audio/amr-wb":{"source":"iana"},"audio/amr-wb+":{"source":"iana"},"audio/aptx":{"source":"iana"},"audio/asc":{"source":"iana"},"audio/atrac-advanced-lossless":{"source":"iana"},"audio/atrac-x":{"source":"iana"},"audio/atrac3":{"source":"iana"},"audio/basic":{"source":"iana","compressible":false,"extensions":["au","snd"]},"audio/bv16":{"source":"iana"},"audio/bv32":{"source":"iana"},"audio/clearmode":{"source":"iana"},"audio/cn":{"source":"iana"},"audio/dat12":{"source":"iana"},"audio/dls":{"source":"iana"},"audio/dsr-es201108":{"source":"iana"},"audio/dsr-es202050":{"source":"iana"},"audio/dsr-es202211":{"source":"iana"},"audio/dsr-es202212":{"source":"iana"},"audio/dv":{"source":"iana"},"audio/dvi4":{"source":"iana"},"audio/eac3":{"source":"iana"},"audio/encaprtp":{"source":"iana"},"audio/evrc":{"source":"iana"},"audio/evrc-qcp":{"source":"iana"},"audio/evrc0":{"source":"iana"},"audio/evrc1":{"source":"iana"},"audio/evrcb":{"source":"iana"},"audio/evrcb0":{"source":"iana"},"audio/evrcb1":{"source":"iana"},"audio/evrcnw":{"source":"iana"},"audio/evrcnw0":{"source":"iana"},"audio/evrcnw1":{"source":"iana"},"audio/evrcwb":{"source":"iana"},"audio/evrcwb0":{"source":"iana"},"audio/evrcwb1":{"source":"iana"},"audio/evs":{"source":"iana"},"audio/fwdred":{"source":"iana"},"audio/g711-0":{"source":"iana"},"audio/g719":{"source":"iana"},"audio/g722":{"source":"iana"},"audio/g7221":{"source":"iana"},"audio/g723":{"source":"iana"},"audio/g726-16":{"source":"iana"},"audio/g726-24":{"source":"iana"},"audio/g726-32":{"source":"iana"},"audio/g726-40":{"source":"iana"},"audio/g728":{"source":"iana"},"audio/g729":{"source":"iana"},"audio/g7291":{"source":"iana"},"audio/g729d":{"source":"iana"},"audio/g729e":{"source":"iana"},"audio/gsm":{"source":"iana"},"audio/gsm-efr":{"source":"iana"},"audio/gsm-hr-08":{"source":"iana"},"audio/ilbc":{"source":"iana"},"audio/ip-mr_v2.5":{"source":"iana"},"audio/isac":{"source":"apache"},"audio/l16":{"source":"iana"},"audio/l20":{"source":"iana"},"audio/l24":{"source":"iana","compressible":false},"audio/l8":{"source":"iana"},"audio/lpc":{"source":"iana"},"audio/melp":{"source":"iana"},"audio/melp1200":{"source":"iana"},"audio/melp2400":{"source":"iana"},"audio/melp600":{"source":"iana"},"audio/midi":{"source":"apache","extensions":["mid","midi","kar","rmi"]},"audio/mobile-xmf":{"source":"iana"},"audio/mp3":{"compressible":false,"extensions":["mp3"]},"audio/mp4":{"source":"iana","compressible":false,"extensions":["m4a","mp4a"]},"audio/mp4a-latm":{"source":"iana"},"audio/mpa":{"source":"iana"},"audio/mpa-robust":{"source":"iana"},"audio/mpeg":{"source":"iana","compressible":false,"extensions":["mpga","mp2","mp2a","mp3","m2a","m3a"]},"audio/mpeg4-generic":{"source":"iana"},"audio/musepack":{"source":"apache"},"audio/ogg":{"source":"iana","compressible":false,"extensions":["oga","ogg","spx"]},"audio/opus":{"source":"iana"},"audio/parityfec":{"source":"iana"},"audio/pcma":{"source":"iana"},"audio/pcma-wb":{"source":"iana"},"audio/pcmu":{"source":"iana"},"audio/pcmu-wb":{"source":"iana"},"audio/prs.sid":{"source":"iana"},"audio/qcelp":{"source":"iana"},"audio/raptorfec":{"source":"iana"},"audio/red":{"source":"iana"},"audio/rtp-enc-aescm128":{"source":"iana"},"audio/rtp-midi":{"source":"iana"},"audio/rtploopback":{"source":"iana"},"audio/rtx":{"source":"iana"},"audio/s3m":{"source":"apache","extensions":["s3m"]},"audio/silk":{"source":"apache","extensions":["sil"]},"audio/smv":{"source":"iana"},"audio/smv-qcp":{"source":"iana"},"audio/smv0":{"source":"iana"},"audio/sp-midi":{"source":"iana"},"audio/speex":{"source":"iana"},"audio/t140c":{"source":"iana"},"audio/t38":{"source":"iana"},"audio/telephone-event":{"source":"iana"},"audio/tone":{"source":"iana"},"audio/uemclip":{"source":"iana"},"audio/ulpfec":{"source":"iana"},"audio/vdvi":{"source":"iana"},"audio/vmr-wb":{"source":"iana"},"audio/vnd.3gpp.iufp":{"source":"iana"},"audio/vnd.4sb":{"source":"iana"},"audio/vnd.audiokoz":{"source":"iana"},"audio/vnd.celp":{"source":"iana"},"audio/vnd.cisco.nse":{"source":"iana"},"audio/vnd.cmles.radio-events":{"source":"iana"},"audio/vnd.cns.anp1":{"source":"iana"},"audio/vnd.cns.inf1":{"source":"iana"},"audio/vnd.dece.audio":{"source":"iana","extensions":["uva","uvva"]},"audio/vnd.digital-winds":{"source":"iana","extensions":["eol"]},"audio/vnd.dlna.adts":{"source":"iana"},"audio/vnd.dolby.heaac.1":{"source":"iana"},"audio/vnd.dolby.heaac.2":{"source":"iana"},"audio/vnd.dolby.mlp":{"source":"iana"},"audio/vnd.dolby.mps":{"source":"iana"},"audio/vnd.dolby.pl2":{"source":"iana"},"audio/vnd.dolby.pl2x":{"source":"iana"},"audio/vnd.dolby.pl2z":{"source":"iana"},"audio/vnd.dolby.pulse.1":{"source":"iana"},"audio/vnd.dra":{"source":"iana","extensions":["dra"]},"audio/vnd.dts":{"source":"iana","extensions":["dts"]},"audio/vnd.dts.hd":{"source":"iana","extensions":["dtshd"]},"audio/vnd.dvb.file":{"source":"iana"},"audio/vnd.everad.plj":{"source":"iana"},"audio/vnd.hns.audio":{"source":"iana"},"audio/vnd.lucent.voice":{"source":"iana","extensions":["lvp"]},"audio/vnd.ms-playready.media.pya":{"source":"iana","extensions":["pya"]},"audio/vnd.nokia.mobile-xmf":{"source":"iana"},"audio/vnd.nortel.vbk":{"source":"iana"},"audio/vnd.nuera.ecelp4800":{"source":"iana","extensions":["ecelp4800"]},"audio/vnd.nuera.ecelp7470":{"source":"iana","extensions":["ecelp7470"]},"audio/vnd.nuera.ecelp9600":{"source":"iana","extensions":["ecelp9600"]},"audio/vnd.octel.sbc":{"source":"iana"},"audio/vnd.presonus.multitrack":{"source":"iana"},"audio/vnd.qcelp":{"source":"iana"},"audio/vnd.rhetorex.32kadpcm":{"source":"iana"},"audio/vnd.rip":{"source":"iana","extensions":["rip"]},"audio/vnd.rn-realaudio":{"compressible":false},"audio/vnd.sealedmedia.softseal.mpeg":{"source":"iana"},"audio/vnd.vmx.cvsd":{"source":"iana"},"audio/vnd.wave":{"compressible":false},"audio/vorbis":{"source":"iana","compressible":false},"audio/vorbis-config":{"source":"iana"},"audio/wav":{"compressible":false,"extensions":["wav"]},"audio/wave":{"compressible":false,"extensions":["wav"]},"audio/webm":{"source":"apache","compressible":false,"extensions":["weba"]},"audio/x-aac":{"source":"apache","compressible":false,"extensions":["aac"]},"audio/x-aiff":{"source":"apache","extensions":["aif","aiff","aifc"]},"audio/x-caf":{"source":"apache","compressible":false,"extensions":["caf"]},"audio/x-flac":{"source":"apache","extensions":["flac"]},"audio/x-m4a":{"source":"nginx","extensions":["m4a"]},"audio/x-matroska":{"source":"apache","extensions":["mka"]},"audio/x-mpegurl":{"source":"apache","extensions":["m3u"]},"audio/x-ms-wax":{"source":"apache","extensions":["wax"]},"audio/x-ms-wma":{"source":"apache","extensions":["wma"]},"audio/x-pn-realaudio":{"source":"apache","extensions":["ram","ra"]},"audio/x-pn-realaudio-plugin":{"source":"apache","extensions":["rmp"]},"audio/x-realaudio":{"source":"nginx","extensions":["ra"]},"audio/x-tta":{"source":"apache"},"audio/x-wav":{"source":"apache","extensions":["wav"]},"audio/xm":{"source":"apache","extensions":["xm"]},"chemical/x-cdx":{"source":"apache","extensions":["cdx"]},"chemical/x-cif":{"source":"apache","extensions":["cif"]},"chemical/x-cmdf":{"source":"apache","extensions":["cmdf"]},"chemical/x-cml":{"source":"apache","extensions":["cml"]},"chemical/x-csml":{"source":"apache","extensions":["csml"]},"chemical/x-pdb":{"source":"apache"},"chemical/x-xyz":{"source":"apache","extensions":["xyz"]},"font/collection":{"source":"iana","extensions":["ttc"]},"font/otf":{"source":"iana","compressible":true,"extensions":["otf"]},"font/sfnt":{"source":"iana"},"font/ttf":{"source":"iana","extensions":["ttf"]},"font/woff":{"source":"iana","extensions":["woff"]},"font/woff2":{"source":"iana","extensions":["woff2"]},"image/aces":{"source":"iana"},"image/apng":{"compressible":false,"extensions":["apng"]},"image/bmp":{"source":"iana","compressible":true,"extensions":["bmp"]},"image/cgm":{"source":"iana","extensions":["cgm"]},"image/dicom-rle":{"source":"iana"},"image/emf":{"source":"iana"},"image/fits":{"source":"iana"},"image/g3fax":{"source":"iana","extensions":["g3"]},"image/gif":{"source":"iana","compressible":false,"extensions":["gif"]},"image/ief":{"source":"iana","extensions":["ief"]},"image/jls":{"source":"iana"},"image/jp2":{"source":"iana","compressible":false,"extensions":["jp2","jpg2"]},"image/jpeg":{"source":"iana","compressible":false,"extensions":["jpeg","jpg","jpe"]},"image/jpm":{"source":"iana","compressible":false,"extensions":["jpm"]},"image/jpx":{"source":"iana","compressible":false,"extensions":["jpx","jpf"]},"image/ktx":{"source":"iana","extensions":["ktx"]},"image/naplps":{"source":"iana"},"image/pjpeg":{"compressible":false},"image/png":{"source":"iana","compressible":false,"extensions":["png"]},"image/prs.btif":{"source":"iana","extensions":["btif"]},"image/prs.pti":{"source":"iana"},"image/pwg-raster":{"source":"iana"},"image/sgi":{"source":"apache","extensions":["sgi"]},"image/svg+xml":{"source":"iana","compressible":true,"extensions":["svg","svgz"]},"image/t38":{"source":"iana"},"image/tiff":{"source":"iana","compressible":false,"extensions":["tiff","tif"]},"image/tiff-fx":{"source":"iana"},"image/vnd.adobe.photoshop":{"source":"iana","compressible":true,"extensions":["psd"]},"image/vnd.airzip.accelerator.azv":{"source":"iana"},"image/vnd.cns.inf2":{"source":"iana"},"image/vnd.dece.graphic":{"source":"iana","extensions":["uvi","uvvi","uvg","uvvg"]},"image/vnd.djvu":{"source":"iana","extensions":["djvu","djv"]},"image/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"image/vnd.dwg":{"source":"iana","extensions":["dwg"]},"image/vnd.dxf":{"source":"iana","extensions":["dxf"]},"image/vnd.fastbidsheet":{"source":"iana","extensions":["fbs"]},"image/vnd.fpx":{"source":"iana","extensions":["fpx"]},"image/vnd.fst":{"source":"iana","extensions":["fst"]},"image/vnd.fujixerox.edmics-mmr":{"source":"iana","extensions":["mmr"]},"image/vnd.fujixerox.edmics-rlc":{"source":"iana","extensions":["rlc"]},"image/vnd.globalgraphics.pgb":{"source":"iana"},"image/vnd.microsoft.icon":{"source":"iana"},"image/vnd.mix":{"source":"iana"},"image/vnd.mozilla.apng":{"source":"iana"},"image/vnd.ms-modi":{"source":"iana","extensions":["mdi"]},"image/vnd.ms-photo":{"source":"apache","extensions":["wdp"]},"image/vnd.net-fpx":{"source":"iana","extensions":["npx"]},"image/vnd.radiance":{"source":"iana"},"image/vnd.sealed.png":{"source":"iana"},"image/vnd.sealedmedia.softseal.gif":{"source":"iana"},"image/vnd.sealedmedia.softseal.jpg":{"source":"iana"},"image/vnd.svf":{"source":"iana"},"image/vnd.tencent.tap":{"source":"iana"},"image/vnd.valve.source.texture":{"source":"iana"},"image/vnd.wap.wbmp":{"source":"iana","extensions":["wbmp"]},"image/vnd.xiff":{"source":"iana","extensions":["xif"]},"image/vnd.zbrush.pcx":{"source":"iana"},"image/webp":{"source":"apache","extensions":["webp"]},"image/wmf":{"source":"iana"},"image/x-3ds":{"source":"apache","extensions":["3ds"]},"image/x-cmu-raster":{"source":"apache","extensions":["ras"]},"image/x-cmx":{"source":"apache","extensions":["cmx"]},"image/x-freehand":{"source":"apache","extensions":["fh","fhc","fh4","fh5","fh7"]},"image/x-icon":{"source":"apache","compressible":true,"extensions":["ico"]},"image/x-jng":{"source":"nginx","extensions":["jng"]},"image/x-mrsid-image":{"source":"apache","extensions":["sid"]},"image/x-ms-bmp":{"source":"nginx","compressible":true,"extensions":["bmp"]},"image/x-pcx":{"source":"apache","extensions":["pcx"]},"image/x-pict":{"source":"apache","extensions":["pic","pct"]},"image/x-portable-anymap":{"source":"apache","extensions":["pnm"]},"image/x-portable-bitmap":{"source":"apache","extensions":["pbm"]},"image/x-portable-graymap":{"source":"apache","extensions":["pgm"]},"image/x-portable-pixmap":{"source":"apache","extensions":["ppm"]},"image/x-rgb":{"source":"apache","extensions":["rgb"]},"image/x-tga":{"source":"apache","extensions":["tga"]},"image/x-xbitmap":{"source":"apache","extensions":["xbm"]},"image/x-xcf":{"compressible":false},"image/x-xpixmap":{"source":"apache","extensions":["xpm"]},"image/x-xwindowdump":{"source":"apache","extensions":["xwd"]},"message/cpim":{"source":"iana"},"message/delivery-status":{"source":"iana"},"message/disposition-notification":{"source":"iana","extensions":["disposition-notification"]},"message/external-body":{"source":"iana"},"message/feedback-report":{"source":"iana"},"message/global":{"source":"iana","extensions":["u8msg"]},"message/global-delivery-status":{"source":"iana","extensions":["u8dsn"]},"message/global-disposition-notification":{"source":"iana","extensions":["u8mdn"]},"message/global-headers":{"source":"iana","extensions":["u8hdr"]},"message/http":{"source":"iana","compressible":false},"message/imdn+xml":{"source":"iana","compressible":true},"message/news":{"source":"iana"},"message/partial":{"source":"iana","compressible":false},"message/rfc822":{"source":"iana","compressible":true,"extensions":["eml","mime"]},"message/s-http":{"source":"iana"},"message/sip":{"source":"iana"},"message/sipfrag":{"source":"iana"},"message/tracking-status":{"source":"iana"},"message/vnd.si.simp":{"source":"iana"},"message/vnd.wfa.wsc":{"source":"iana","extensions":["wsc"]},"model/3mf":{"source":"iana"},"model/gltf+json":{"source":"iana","compressible":true,"extensions":["gltf"]},"model/gltf-binary":{"source":"iana","compressible":true,"extensions":["glb"]},"model/iges":{"source":"iana","compressible":false,"extensions":["igs","iges"]},"model/mesh":{"source":"iana","compressible":false,"extensions":["msh","mesh","silo"]},"model/vnd.collada+xml":{"source":"iana","extensions":["dae"]},"model/vnd.dwf":{"source":"iana","extensions":["dwf"]},"model/vnd.flatland.3dml":{"source":"iana"},"model/vnd.gdl":{"source":"iana","extensions":["gdl"]},"model/vnd.gs-gdl":{"source":"apache"},"model/vnd.gs.gdl":{"source":"iana"},"model/vnd.gtw":{"source":"iana","extensions":["gtw"]},"model/vnd.moml+xml":{"source":"iana"},"model/vnd.mts":{"source":"iana","extensions":["mts"]},"model/vnd.opengex":{"source":"iana"},"model/vnd.parasolid.transmit.binary":{"source":"iana"},"model/vnd.parasolid.transmit.text":{"source":"iana"},"model/vnd.rosette.annotated-data-model":{"source":"iana"},"model/vnd.valve.source.compiled-map":{"source":"iana"},"model/vnd.vtu":{"source":"iana","extensions":["vtu"]},"model/vrml":{"source":"iana","compressible":false,"extensions":["wrl","vrml"]},"model/x3d+binary":{"source":"apache","compressible":false,"extensions":["x3db","x3dbz"]},"model/x3d+fastinfoset":{"source":"iana"},"model/x3d+vrml":{"source":"apache","compressible":false,"extensions":["x3dv","x3dvz"]},"model/x3d+xml":{"source":"iana","compressible":true,"extensions":["x3d","x3dz"]},"model/x3d-vrml":{"source":"iana"},"multipart/alternative":{"source":"iana","compressible":false},"multipart/appledouble":{"source":"iana"},"multipart/byteranges":{"source":"iana"},"multipart/digest":{"source":"iana"},"multipart/encrypted":{"source":"iana","compressible":false},"multipart/form-data":{"source":"iana","compressible":false},"multipart/header-set":{"source":"iana"},"multipart/mixed":{"source":"iana","compressible":false},"multipart/multilingual":{"source":"iana"},"multipart/parallel":{"source":"iana"},"multipart/related":{"source":"iana","compressible":false},"multipart/report":{"source":"iana"},"multipart/signed":{"source":"iana","compressible":false},"multipart/vnd.bint.med-plus":{"source":"iana"},"multipart/voice-message":{"source":"iana"},"multipart/x-mixed-replace":{"source":"iana"},"text/1d-interleaved-parityfec":{"source":"iana"},"text/cache-manifest":{"source":"iana","compressible":true,"extensions":["appcache","manifest"]},"text/calendar":{"source":"iana","extensions":["ics","ifb"]},"text/calender":{"compressible":true},"text/cmd":{"compressible":true},"text/coffeescript":{"extensions":["coffee","litcoffee"]},"text/css":{"source":"iana","charset":"UTF-8","compressible":true,"extensions":["css"]},"text/csv":{"source":"iana","compressible":true,"extensions":["csv"]},"text/csv-schema":{"source":"iana"},"text/directory":{"source":"iana"},"text/dns":{"source":"iana"},"text/ecmascript":{"source":"iana"},"text/encaprtp":{"source":"iana"},"text/enriched":{"source":"iana"},"text/fwdred":{"source":"iana"},"text/grammar-ref-list":{"source":"iana"},"text/html":{"source":"iana","compressible":true,"extensions":["html","htm","shtml"]},"text/jade":{"extensions":["jade"]},"text/javascript":{"source":"iana","compressible":true},"text/jcr-cnd":{"source":"iana"},"text/jsx":{"compressible":true,"extensions":["jsx"]},"text/less":{"extensions":["less"]},"text/markdown":{"source":"iana","compressible":true,"extensions":["markdown","md"]},"text/mathml":{"source":"nginx","extensions":["mml"]},"text/mizar":{"source":"iana"},"text/n3":{"source":"iana","compressible":true,"extensions":["n3"]},"text/parameters":{"source":"iana"},"text/parityfec":{"source":"iana"},"text/plain":{"source":"iana","compressible":true,"extensions":["txt","text","conf","def","list","log","in","ini"]},"text/provenance-notation":{"source":"iana"},"text/prs.fallenstein.rst":{"source":"iana"},"text/prs.lines.tag":{"source":"iana","extensions":["dsc"]},"text/prs.prop.logic":{"source":"iana"},"text/raptorfec":{"source":"iana"},"text/red":{"source":"iana"},"text/rfc822-headers":{"source":"iana"},"text/richtext":{"source":"iana","compressible":true,"extensions":["rtx"]},"text/rtf":{"source":"iana","compressible":true,"extensions":["rtf"]},"text/rtp-enc-aescm128":{"source":"iana"},"text/rtploopback":{"source":"iana"},"text/rtx":{"source":"iana"},"text/sgml":{"source":"iana","extensions":["sgml","sgm"]},"text/shex":{"extensions":["shex"]},"text/slim":{"extensions":["slim","slm"]},"text/strings":{"source":"iana"},"text/stylus":{"extensions":["stylus","styl"]},"text/t140":{"source":"iana"},"text/tab-separated-values":{"source":"iana","compressible":true,"extensions":["tsv"]},"text/troff":{"source":"iana","extensions":["t","tr","roff","man","me","ms"]},"text/turtle":{"source":"iana","extensions":["ttl"]},"text/ulpfec":{"source":"iana"},"text/uri-list":{"source":"iana","compressible":true,"extensions":["uri","uris","urls"]},"text/vcard":{"source":"iana","compressible":true,"extensions":["vcard"]},"text/vnd.a":{"source":"iana"},"text/vnd.abc":{"source":"iana"},"text/vnd.ascii-art":{"source":"iana"},"text/vnd.curl":{"source":"iana","extensions":["curl"]},"text/vnd.curl.dcurl":{"source":"apache","extensions":["dcurl"]},"text/vnd.curl.mcurl":{"source":"apache","extensions":["mcurl"]},"text/vnd.curl.scurl":{"source":"apache","extensions":["scurl"]},"text/vnd.debian.copyright":{"source":"iana"},"text/vnd.dmclientscript":{"source":"iana"},"text/vnd.dvb.subtitle":{"source":"iana","extensions":["sub"]},"text/vnd.esmertec.theme-descriptor":{"source":"iana"},"text/vnd.fly":{"source":"iana","extensions":["fly"]},"text/vnd.fmi.flexstor":{"source":"iana","extensions":["flx"]},"text/vnd.graphviz":{"source":"iana","extensions":["gv"]},"text/vnd.in3d.3dml":{"source":"iana","extensions":["3dml"]},"text/vnd.in3d.spot":{"source":"iana","extensions":["spot"]},"text/vnd.iptc.newsml":{"source":"iana"},"text/vnd.iptc.nitf":{"source":"iana"},"text/vnd.latex-z":{"source":"iana"},"text/vnd.motorola.reflex":{"source":"iana"},"text/vnd.ms-mediapackage":{"source":"iana"},"text/vnd.net2phone.commcenter.command":{"source":"iana"},"text/vnd.radisys.msml-basic-layout":{"source":"iana"},"text/vnd.si.uricatalogue":{"source":"iana"},"text/vnd.sun.j2me.app-descriptor":{"source":"iana","extensions":["jad"]},"text/vnd.trolltech.linguist":{"source":"iana"},"text/vnd.wap.si":{"source":"iana"},"text/vnd.wap.sl":{"source":"iana"},"text/vnd.wap.wml":{"source":"iana","extensions":["wml"]},"text/vnd.wap.wmlscript":{"source":"iana","extensions":["wmls"]},"text/vtt":{"charset":"UTF-8","compressible":true,"extensions":["vtt"]},"text/x-asm":{"source":"apache","extensions":["s","asm"]},"text/x-c":{"source":"apache","extensions":["c","cc","cxx","cpp","h","hh","dic"]},"text/x-component":{"source":"nginx","extensions":["htc"]},"text/x-fortran":{"source":"apache","extensions":["f","for","f77","f90"]},"text/x-gwt-rpc":{"compressible":true},"text/x-handlebars-template":{"extensions":["hbs"]},"text/x-java-source":{"source":"apache","extensions":["java"]},"text/x-jquery-tmpl":{"compressible":true},"text/x-lua":{"extensions":["lua"]},"text/x-markdown":{"compressible":true,"extensions":["mkd"]},"text/x-nfo":{"source":"apache","extensions":["nfo"]},"text/x-opml":{"source":"apache","extensions":["opml"]},"text/x-org":{"compressible":true,"extensions":["org"]},"text/x-pascal":{"source":"apache","extensions":["p","pas"]},"text/x-processing":{"compressible":true,"extensions":["pde"]},"text/x-sass":{"extensions":["sass"]},"text/x-scss":{"extensions":["scss"]},"text/x-setext":{"source":"apache","extensions":["etx"]},"text/x-sfv":{"source":"apache","extensions":["sfv"]},"text/x-suse-ymp":{"compressible":true,"extensions":["ymp"]},"text/x-uuencode":{"source":"apache","extensions":["uu"]},"text/x-vcalendar":{"source":"apache","extensions":["vcs"]},"text/x-vcard":{"source":"apache","extensions":["vcf"]},"text/xml":{"source":"iana","compressible":true,"extensions":["xml"]},"text/xml-external-parsed-entity":{"source":"iana"},"text/yaml":{"extensions":["yaml","yml"]},"video/1d-interleaved-parityfec":{"source":"iana"},"video/3gpp":{"source":"iana","extensions":["3gp","3gpp"]},"video/3gpp-tt":{"source":"iana"},"video/3gpp2":{"source":"iana","extensions":["3g2"]},"video/bmpeg":{"source":"iana"},"video/bt656":{"source":"iana"},"video/celb":{"source":"iana"},"video/dv":{"source":"iana"},"video/encaprtp":{"source":"iana"},"video/h261":{"source":"iana","extensions":["h261"]},"video/h263":{"source":"iana","extensions":["h263"]},"video/h263-1998":{"source":"iana"},"video/h263-2000":{"source":"iana"},"video/h264":{"source":"iana","extensions":["h264"]},"video/h264-rcdo":{"source":"iana"},"video/h264-svc":{"source":"iana"},"video/h265":{"source":"iana"},"video/iso.segment":{"source":"iana"},"video/jpeg":{"source":"iana","extensions":["jpgv"]},"video/jpeg2000":{"source":"iana"},"video/jpm":{"source":"apache","extensions":["jpm","jpgm"]},"video/mj2":{"source":"iana","extensions":["mj2","mjp2"]},"video/mp1s":{"source":"iana"},"video/mp2p":{"source":"iana"},"video/mp2t":{"source":"iana","extensions":["ts"]},"video/mp4":{"source":"iana","compressible":false,"extensions":["mp4","mp4v","mpg4"]},"video/mp4v-es":{"source":"iana"},"video/mpeg":{"source":"iana","compressible":false,"extensions":["mpeg","mpg","mpe","m1v","m2v"]},"video/mpeg4-generic":{"source":"iana"},"video/mpv":{"source":"iana"},"video/nv":{"source":"iana"},"video/ogg":{"source":"iana","compressible":false,"extensions":["ogv"]},"video/parityfec":{"source":"iana"},"video/pointer":{"source":"iana"},"video/quicktime":{"source":"iana","compressible":false,"extensions":["qt","mov"]},"video/raptorfec":{"source":"iana"},"video/raw":{"source":"iana"},"video/rtp-enc-aescm128":{"source":"iana"},"video/rtploopback":{"source":"iana"},"video/rtx":{"source":"iana"},"video/smpte291":{"source":"iana"},"video/smpte292m":{"source":"iana"},"video/ulpfec":{"source":"iana"},"video/vc1":{"source":"iana"},"video/vnd.cctv":{"source":"iana"},"video/vnd.dece.hd":{"source":"iana","extensions":["uvh","uvvh"]},"video/vnd.dece.mobile":{"source":"iana","extensions":["uvm","uvvm"]},"video/vnd.dece.mp4":{"source":"iana"},"video/vnd.dece.pd":{"source":"iana","extensions":["uvp","uvvp"]},"video/vnd.dece.sd":{"source":"iana","extensions":["uvs","uvvs"]},"video/vnd.dece.video":{"source":"iana","extensions":["uvv","uvvv"]},"video/vnd.directv.mpeg":{"source":"iana"},"video/vnd.directv.mpeg-tts":{"source":"iana"},"video/vnd.dlna.mpeg-tts":{"source":"iana"},"video/vnd.dvb.file":{"source":"iana","extensions":["dvb"]},"video/vnd.fvt":{"source":"iana","extensions":["fvt"]},"video/vnd.hns.video":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.1dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-1010":{"source":"iana"},"video/vnd.iptvforum.2dparityfec-2005":{"source":"iana"},"video/vnd.iptvforum.ttsavc":{"source":"iana"},"video/vnd.iptvforum.ttsmpeg2":{"source":"iana"},"video/vnd.motorola.video":{"source":"iana"},"video/vnd.motorola.videop":{"source":"iana"},"video/vnd.mpegurl":{"source":"iana","extensions":["mxu","m4u"]},"video/vnd.ms-playready.media.pyv":{"source":"iana","extensions":["pyv"]},"video/vnd.nokia.interleaved-multimedia":{"source":"iana"},"video/vnd.nokia.mp4vr":{"source":"iana"},"video/vnd.nokia.videovoip":{"source":"iana"},"video/vnd.objectvideo":{"source":"iana"},"video/vnd.radgamettools.bink":{"source":"iana"},"video/vnd.radgamettools.smacker":{"source":"iana"},"video/vnd.sealed.mpeg1":{"source":"iana"},"video/vnd.sealed.mpeg4":{"source":"iana"},"video/vnd.sealed.swf":{"source":"iana"},"video/vnd.sealedmedia.softseal.mov":{"source":"iana"},"video/vnd.uvvu.mp4":{"source":"iana","extensions":["uvu","uvvu"]},"video/vnd.vivo":{"source":"iana","extensions":["viv"]},"video/vp8":{"source":"iana"},"video/webm":{"source":"apache","compressible":false,"extensions":["webm"]},"video/x-f4v":{"source":"apache","extensions":["f4v"]},"video/x-fli":{"source":"apache","extensions":["fli"]},"video/x-flv":{"source":"apache","compressible":false,"extensions":["flv"]},"video/x-m4v":{"source":"apache","extensions":["m4v"]},"video/x-matroska":{"source":"apache","compressible":false,"extensions":["mkv","mk3d","mks"]},"video/x-mng":{"source":"apache","extensions":["mng"]},"video/x-ms-asf":{"source":"apache","extensions":["asf","asx"]},"video/x-ms-vob":{"source":"apache","extensions":["vob"]},"video/x-ms-wm":{"source":"apache","extensions":["wm"]},"video/x-ms-wmv":{"source":"apache","compressible":false,"extensions":["wmv"]},"video/x-ms-wmx":{"source":"apache","extensions":["wmx"]},"video/x-ms-wvx":{"source":"apache","extensions":["wvx"]},"video/x-msvideo":{"source":"apache","extensions":["avi"]},"video/x-sgi-movie":{"source":"apache","extensions":["movie"]},"video/x-smv":{"source":"apache","extensions":["smv"]},"x-conference/x-cooltalk":{"source":"apache","extensions":["ice"]},"x-shader/x-fragment":{"compressible":true},"x-shader/x-vertex":{"compressible":true}}

/***/ }),

/***/ 475:
/***/ (function(module, exports) {

	module.exports = {"_args":[["tough-cookie@2.3.4","/Users/danieleke/Documents/Development/Conflive/Web/conference-frontend"]],"_from":"tough-cookie@2.3.4","_id":"tough-cookie@2.3.4","_inBundle":false,"_integrity":"sha512-TZ6TTfI5NtZnuyy/Kecv+CnoROnyXn2DN97LontgQpCwsX2XyLYCC0ENhYkehSOwAp8rTQKc/NUIF7BkQ5rKLA==","_location":"/tough-cookie","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"tough-cookie@2.3.4","name":"tough-cookie","escapedName":"tough-cookie","rawSpec":"2.3.4","saveSpec":null,"fetchSpec":"2.3.4"},"_requiredBy":["/request"],"_resolved":"https://registry.npmjs.org/tough-cookie/-/tough-cookie-2.3.4.tgz","_spec":"2.3.4","_where":"/Users/danieleke/Documents/Development/Conflive/Web/conference-frontend","author":{"name":"Jeremy Stashewsky","email":"jstashewsky@salesforce.com"},"bugs":{"url":"https://github.com/salesforce/tough-cookie/issues"},"contributors":[{"name":"Alexander Savin"},{"name":"Ian Livingstone"},{"name":"Ivan Nikulin"},{"name":"Lalit Kapoor"},{"name":"Sam Thompson"},{"name":"Sebastian Mayr"}],"dependencies":{"punycode":"^1.4.1"},"description":"RFC6265 Cookies and Cookie Jar for node.js","devDependencies":{"async":"^1.4.2","string.prototype.repeat":"^0.2.0","vows":"^0.8.1"},"engines":{"node":">=0.8"},"files":["lib"],"homepage":"https://github.com/salesforce/tough-cookie","keywords":["HTTP","cookie","cookies","set-cookie","cookiejar","jar","RFC6265","RFC2965"],"license":"BSD-3-Clause","main":"./lib/cookie","name":"tough-cookie","repository":{"type":"git","url":"git://github.com/salesforce/tough-cookie.git"},"scripts":{"suffixup":"curl -o public_suffix_list.dat https://publicsuffix.org/list/public_suffix_list.dat && ./generate-pubsuffix.js","test":"vows test/*_test.js"},"version":"2.3.4"}

/***/ }),

/***/ 482:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 155,
		"./af.js": 155,
		"./ar": 162,
		"./ar-dz": 156,
		"./ar-dz.js": 156,
		"./ar-kw": 157,
		"./ar-kw.js": 157,
		"./ar-ly": 158,
		"./ar-ly.js": 158,
		"./ar-ma": 159,
		"./ar-ma.js": 159,
		"./ar-sa": 160,
		"./ar-sa.js": 160,
		"./ar-tn": 161,
		"./ar-tn.js": 161,
		"./ar.js": 162,
		"./az": 163,
		"./az.js": 163,
		"./be": 164,
		"./be.js": 164,
		"./bg": 165,
		"./bg.js": 165,
		"./bm": 166,
		"./bm.js": 166,
		"./bn": 167,
		"./bn.js": 167,
		"./bo": 168,
		"./bo.js": 168,
		"./br": 169,
		"./br.js": 169,
		"./bs": 170,
		"./bs.js": 170,
		"./ca": 171,
		"./ca.js": 171,
		"./cs": 172,
		"./cs.js": 172,
		"./cv": 173,
		"./cv.js": 173,
		"./cy": 174,
		"./cy.js": 174,
		"./da": 175,
		"./da.js": 175,
		"./de": 178,
		"./de-at": 176,
		"./de-at.js": 176,
		"./de-ch": 177,
		"./de-ch.js": 177,
		"./de.js": 178,
		"./dv": 179,
		"./dv.js": 179,
		"./el": 180,
		"./el.js": 180,
		"./en-au": 181,
		"./en-au.js": 181,
		"./en-ca": 182,
		"./en-ca.js": 182,
		"./en-gb": 183,
		"./en-gb.js": 183,
		"./en-ie": 184,
		"./en-ie.js": 184,
		"./en-il": 185,
		"./en-il.js": 185,
		"./en-nz": 186,
		"./en-nz.js": 186,
		"./eo": 187,
		"./eo.js": 187,
		"./es": 190,
		"./es-do": 188,
		"./es-do.js": 188,
		"./es-us": 189,
		"./es-us.js": 189,
		"./es.js": 190,
		"./et": 191,
		"./et.js": 191,
		"./eu": 192,
		"./eu.js": 192,
		"./fa": 193,
		"./fa.js": 193,
		"./fi": 194,
		"./fi.js": 194,
		"./fo": 195,
		"./fo.js": 195,
		"./fr": 198,
		"./fr-ca": 196,
		"./fr-ca.js": 196,
		"./fr-ch": 197,
		"./fr-ch.js": 197,
		"./fr.js": 198,
		"./fy": 199,
		"./fy.js": 199,
		"./gd": 200,
		"./gd.js": 200,
		"./gl": 201,
		"./gl.js": 201,
		"./gom-latn": 202,
		"./gom-latn.js": 202,
		"./gu": 203,
		"./gu.js": 203,
		"./he": 204,
		"./he.js": 204,
		"./hi": 205,
		"./hi.js": 205,
		"./hr": 206,
		"./hr.js": 206,
		"./hu": 207,
		"./hu.js": 207,
		"./hy-am": 208,
		"./hy-am.js": 208,
		"./id": 209,
		"./id.js": 209,
		"./is": 210,
		"./is.js": 210,
		"./it": 211,
		"./it.js": 211,
		"./ja": 212,
		"./ja.js": 212,
		"./jv": 213,
		"./jv.js": 213,
		"./ka": 214,
		"./ka.js": 214,
		"./kk": 215,
		"./kk.js": 215,
		"./km": 216,
		"./km.js": 216,
		"./kn": 217,
		"./kn.js": 217,
		"./ko": 218,
		"./ko.js": 218,
		"./ky": 219,
		"./ky.js": 219,
		"./lb": 220,
		"./lb.js": 220,
		"./lo": 221,
		"./lo.js": 221,
		"./lt": 222,
		"./lt.js": 222,
		"./lv": 223,
		"./lv.js": 223,
		"./me": 224,
		"./me.js": 224,
		"./mi": 225,
		"./mi.js": 225,
		"./mk": 226,
		"./mk.js": 226,
		"./ml": 227,
		"./ml.js": 227,
		"./mn": 228,
		"./mn.js": 228,
		"./mr": 229,
		"./mr.js": 229,
		"./ms": 231,
		"./ms-my": 230,
		"./ms-my.js": 230,
		"./ms.js": 231,
		"./mt": 232,
		"./mt.js": 232,
		"./my": 233,
		"./my.js": 233,
		"./nb": 234,
		"./nb.js": 234,
		"./ne": 235,
		"./ne.js": 235,
		"./nl": 237,
		"./nl-be": 236,
		"./nl-be.js": 236,
		"./nl.js": 237,
		"./nn": 238,
		"./nn.js": 238,
		"./pa-in": 239,
		"./pa-in.js": 239,
		"./pl": 240,
		"./pl.js": 240,
		"./pt": 242,
		"./pt-br": 241,
		"./pt-br.js": 241,
		"./pt.js": 242,
		"./ro": 243,
		"./ro.js": 243,
		"./ru": 244,
		"./ru.js": 244,
		"./sd": 245,
		"./sd.js": 245,
		"./se": 246,
		"./se.js": 246,
		"./si": 247,
		"./si.js": 247,
		"./sk": 248,
		"./sk.js": 248,
		"./sl": 249,
		"./sl.js": 249,
		"./sq": 250,
		"./sq.js": 250,
		"./sr": 252,
		"./sr-cyrl": 251,
		"./sr-cyrl.js": 251,
		"./sr.js": 252,
		"./ss": 253,
		"./ss.js": 253,
		"./sv": 254,
		"./sv.js": 254,
		"./sw": 255,
		"./sw.js": 255,
		"./ta": 256,
		"./ta.js": 256,
		"./te": 257,
		"./te.js": 257,
		"./tet": 258,
		"./tet.js": 258,
		"./tg": 259,
		"./tg.js": 259,
		"./th": 260,
		"./th.js": 260,
		"./tl-ph": 261,
		"./tl-ph.js": 261,
		"./tlh": 262,
		"./tlh.js": 262,
		"./tr": 263,
		"./tr.js": 263,
		"./tzl": 264,
		"./tzl.js": 264,
		"./tzm": 266,
		"./tzm-latn": 265,
		"./tzm-latn.js": 265,
		"./tzm.js": 266,
		"./ug-cn": 267,
		"./ug-cn.js": 267,
		"./uk": 268,
		"./uk.js": 268,
		"./ur": 269,
		"./ur.js": 269,
		"./uz": 271,
		"./uz-latn": 270,
		"./uz-latn.js": 270,
		"./uz.js": 271,
		"./vi": 272,
		"./vi.js": 272,
		"./x-pseudo": 273,
		"./x-pseudo.js": 273,
		"./yo": 274,
		"./yo.js": 274,
		"./zh-cn": 275,
		"./zh-cn.js": 275,
		"./zh-hk": 276,
		"./zh-hk.js": 276,
		"./zh-tw": 277,
		"./zh-tw.js": 277
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 482;


/***/ }),

/***/ 528:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/alaprajzok2.a6c749a.jpg";

/***/ }),

/***/ 537:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(424)
	
	/* template */
	var __vue_template__ = __webpack_require__(554)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ }),

/***/ 538:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(428)
	__webpack_require__(427)
	
	/* script */
	__vue_exports__ = __webpack_require__(351)
	
	/* template */
	var __vue_template__ = __webpack_require__(557)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-8df93e2c"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(423)
	
	/* script */
	__vue_exports__ = __webpack_require__(352)
	
	/* template */
	var __vue_template__ = __webpack_require__(553)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-417525cb"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 540:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(425)
	
	/* script */
	__vue_exports__ = __webpack_require__(354)
	
	/* template */
	var __vue_template__ = __webpack_require__(555)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-64c1ed4c"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(426)
	
	/* script */
	__vue_exports__ = __webpack_require__(355)
	
	/* template */
	var __vue_template__ = __webpack_require__(556)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-6f36df47"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(420)
	
	/* script */
	__vue_exports__ = __webpack_require__(356)
	
	/* template */
	var __vue_template__ = __webpack_require__(550)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-1d31da4c"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(430)
	
	/* script */
	__vue_exports__ = __webpack_require__(357)
	
	/* template */
	var __vue_template__ = __webpack_require__(559)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cb35ab84"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 544:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(419)
	
	/* script */
	__vue_exports__ = __webpack_require__(358)
	
	/* template */
	var __vue_template__ = __webpack_require__(549)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-17e51636"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 545:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(421)
	
	/* script */
	__vue_exports__ = __webpack_require__(359)
	
	/* template */
	var __vue_template__ = __webpack_require__(551)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-23feba34"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(429)
	
	/* script */
	__vue_exports__ = __webpack_require__(360)
	
	/* template */
	var __vue_template__ = __webpack_require__(558)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-bddfbf38"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 547:
/***/ (function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(431)
	
	/* script */
	__vue_exports__ = __webpack_require__(361)
	
	/* template */
	var __vue_template__ = __webpack_require__(560)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	__vue_options__._scopeId = "data-v-cd0e46ea"
	
	module.exports = __vue_exports__


/***/ }),

/***/ 548:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "attachments"
	  }, [_vm._l((_vm.attachments), function(attachment, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md-6"
	    }, [_c('label', [_vm._v("Kategória")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.attachments[index].type),
	        callback: function($$v) {
	          _vm.$set(_vm.attachments[index], "type", $$v)
	        },
	        expression: "attachments[index].type"
	      }
	    }, _vm._l((_vm.attachmentTypes), function(attachmentType) {
	      return _c('md-option', {
	        attrs: {
	          "value": attachmentType.value
	        }
	      }, [_vm._v(_vm._s(attachmentType.label))])
	    }))], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (attachment.name),
	        callback: function($$v) {
	          _vm.$set(attachment, "name", $$v)
	        },
	        expression: "attachment.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Érték")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (attachment.value),
	        callback: function($$v) {
	          _vm.$set(attachment, "value", $$v)
	        },
	        expression: "attachment.value"
	      }
	    })], 1)], 1)
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        _vm.newAttachment()
	      }
	    }
	  }, [_vm._v("Kapcsolati adat hozzáadása")])], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 549:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "presentation-row"
	  }, [_c('div', {
	    staticClass: "presentation-row card between-md middle-md",
	    class: {
	      isSection: _vm.presentation.isSection
	    }
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4"
	  }, [_c('h3', [_vm._v(_vm._s(_vm.presentation.title))]), _c('br'), _vm._v(" "), (_vm.presentation.isSection) ? _c('span', [_vm._v("Szekció")]) : _c('span', [_vm._v("Előadás")]), _c('br'), _vm._v("\n\t\t\t\t" + _vm._s(_vm.formatedDate(_vm.presentation.fromDate)) + " - " + _vm._s(_vm.formatedDate(_vm.presentation.toDate))), _c('br'), _vm._v(" "), (!_vm.presentation.isSection) ? _c('span', [_vm._v(_vm._s(_vm.formatedTime(_vm.presentation.fromDate)) + " - " + _vm._s(_vm.formatedTime(_vm.presentation.toDate)))]) : _vm._e()]), _vm._v(" "), (_vm.presentation.isSection) ? _c('div', {
	    staticClass: "col-md-8 end-md"
	  }, [(_vm.presentation.isSection) ? _c('md-button', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.create(_vm.presentation.fireId, false)
	      }
	    }
	  }, [_vm._v("Előadás hozzadása")]) : _vm._e(), _vm._v(" "), (_vm.presentation.isSection) ? _c('md-button', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.create(_vm.presentation.fireId, true)
	      }
	    }
	  }, [_vm._v("Alszekció hozzadása")]) : _vm._e(), _vm._v(" "), (_vm.presentation.isSection) ? _c('md-button', {
	    nativeOn: {
	      "click": function($event) {
	        _vm.switchOpen()
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.open ? "Bezárás" : "Megnyitás"))]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "col-md-8"
	  }, [(_vm.presentation.ratingCount > 0) ? _c('div', {
	    staticClass: "ratings col-md-12"
	  }, [_vm._v("\n\t\t\t\t\tÖsszes értékelés: "), _c('b', [_vm._v(_vm._s(_vm.presentation.ratingCount))]), _vm._v(" - \n\t\t\t\t\tÁtlagos értékelés: "), _c('b', [_vm._v(_vm._s(_vm.presentation.ratingAvg) + " / 6")])]) : _vm._e(), _vm._v(" "), (Object.keys(_vm.presentation.comments).length > 0) ? _c('div', {
	    staticClass: "comment col-md-12"
	  }, [_vm._v("\n\t\t\t\t\tHozzászólások:\n\t\t\t\t\t"), _vm._l((_vm.presentation.comments), function(comment, userId) {
	    return _c('p', [_vm._v("\n\t\t\t\t\t\t" + _vm._s(comment) + "\n\t\t\t\t\t")])
	  })], 2) : _vm._e()])]), _vm._v(" "), _c('div', {
	    staticClass: "row end-md"
	  }, [_c('md-button', {
	    staticClass: "md-warn",
	    nativeOn: {
	      "click": function($event) {
	        _vm.remove(_vm.presentation)
	      }
	    }
	  }, [_vm._v("Törlés")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        _vm.edit(_vm.presentation)
	      }
	    }
	  }, [_vm._v("Szerkesztés")])], 1)]), _vm._v(" "), (_vm.open) ? _c('div', {
	    staticClass: "subsections card"
	  }, _vm._l((_vm.presentation.presentations), function(presentation) {
	    return _c('div', [_c('presentation-row', {
	      attrs: {
	        "presentation": presentation,
	        "depth": (_vm.depth + 1)
	      }
	    })], 1)
	  })) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 550:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "lecturers"
	  }, [_c('div', {
	    staticClass: "head"
	  }, [_c('md-button', {
	    staticClass: "md-raised",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.showEditor($event)
	      }
	    }
	  }, [_vm._v("Előadó hozzáadása")])], 1), _vm._v(" "), _vm._l((_vm.lecturers), function(lecturer) {
	    return _c('div', {
	      staticClass: "lecturer-row card row between-md middle-md"
	    }, [_c('span', {
	      staticClass: "col-md-10"
	    }, [_vm._v(_vm._s(lecturer.name))]), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.edit(lecturer)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("create")]), _c('br')], 1), _vm._v(" "), _c('a', {
	      on: {
	        "click": function($event) {
	          _vm.remove(lecturer)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)])])
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "presentations"
	  }, [_c('div', {
	    staticClass: "head"
	  }, [_c('md-button', {
	    staticClass: "md-raised",
	    nativeOn: {
	      "click": function($event) {
	        _vm.create(true)
	      }
	    }
	  }, [_vm._v("Új szekció")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised",
	    nativeOn: {
	      "click": function($event) {
	        _vm.create(false)
	      }
	    }
	  }, [_vm._v("Új előadás")])], 1), _vm._v(" "), (_vm.rootPresentations.length == 0) ? _c('div', {
	    staticClass: "card"
	  }, [_vm._v("\n\t\t... Betöltés ...\n\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.rootPresentations), function(presentation) {
	    return _c('div', [_c('presentation-row', {
	      attrs: {
	        "presentation": presentation,
	        "depth": 0
	      }
	    })], 1)
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 552:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "cov-vue-date"
	  }, [_c('div', {
	    staticClass: "datepickbox"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.date.time),
	      expression: "date.time"
	    }],
	    staticClass: "cov-datepicker",
	    style: (_vm.option.inputStyle ? _vm.option.inputStyle : {}),
	    attrs: {
	      "type": "text",
	      "title": "input date",
	      "readonly": "readonly",
	      "placeholder": _vm.option.placeholder,
	      "required": _vm.required
	    },
	    domProps: {
	      "value": (_vm.date.time)
	    },
	    on: {
	      "click": _vm.showCheck,
	      "foucus": _vm.showCheck,
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.$set(_vm.date, "time", $event.target.value)
	      }
	    }
	  })]), _vm._v(" "), (_vm.showInfo.check) ? _c('div', {
	    staticClass: "datepicker-overlay",
	    style: ({
	      'background': _vm.option.overlayOpacity ? 'rgba(0,0,0,' + _vm.option.overlayOpacity + ')' : 'rgba(0,0,0,0.5)'
	    }),
	    on: {
	      "click": function($event) {
	        _vm.dismiss($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "cov-date-body",
	    style: ({
	      'background-color': _vm.option.color ? _vm.option.color.header : '#3f51b5'
	    })
	  }, [_c('div', {
	    staticClass: "cov-date-monthly"
	  }, [_c('div', {
	    staticClass: "cov-date-previous",
	    on: {
	      "click": function($event) {
	        _vm.nextMonth('pre')
	      }
	    }
	  }, [_vm._v("«")]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-caption",
	    style: ({
	      'color': _vm.option.color ? _vm.option.color.headerText : '#fff'
	    })
	  }, [_c('span', {
	    on: {
	      "click": _vm.showYear
	    }
	  }, [_c('small', [_vm._v(_vm._s(_vm.checked.year))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.showMonth
	    }
	  }, [_vm._v(_vm._s(_vm.displayInfo.month))])]), _vm._v(" "), _c('div', {
	    staticClass: "cov-date-next",
	    on: {
	      "click": function($event) {
	        _vm.nextMonth('next')
	      }
	    }
	  }, [_vm._v("»")])]), _vm._v(" "), (_vm.showInfo.day) ? _c('div', {
	    staticClass: "cov-date-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box"
	  }, [_c('div', {
	    staticClass: "week"
	  }, [_c('ul', _vm._l((_vm.library.week), function(weekie) {
	    return _c('li', [_vm._v(_vm._s(weekie))])
	  }))]), _vm._v(" "), _vm._l((_vm.dayList), function(day) {
	    return _c('div', {
	      staticClass: "day",
	      class: {
	        'checked': day.checked, 'unavailable': day.unavailable, 'passive-day': !(day.inMonth)
	      },
	      style: (day.checked ? (_vm.option.color && _vm.option.color.checkedDay ? {
	        background: _vm.option.color.checkedDay
	      } : {
	        background: '#F50057'
	      }) : {}),
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          _vm.checkDay(day)
	        }
	      }
	    }, [_vm._v(_vm._s(day.value))])
	  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.showInfo.year) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list",
	    attrs: {
	      "id": "yearList"
	    }
	  }, _vm._l((_vm.library.year), function(yearItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setYear(yearItem)
	        }
	      }
	    }, [_vm._v(_vm._s(yearItem))])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.month) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, _vm._l((_vm.library.month), function(monthItem) {
	    return _c('div', {
	      staticClass: "date-item",
	      attrs: {
	        "track-by": "$index"
	      },
	      on: {
	        "click": function($event) {
	          _vm.setMonth(monthItem)
	        }
	      }
	    }, [_vm._v(_vm._s(monthItem))])
	  }))]) : _vm._e(), _vm._v(" "), (_vm.showInfo.hour) ? _c('div', {
	    staticClass: "cov-date-box list-box"
	  }, [_c('div', {
	    staticClass: "cov-picker-box date-list"
	  }, [_c('div', {
	    staticClass: "watch-box"
	  }, [_c('div', {
	    staticClass: "hour-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _c('ul', _vm._l((_vm.hours), function(hitem) {
	    return _c('li', {
	      staticClass: "hour-item",
	      class: {
	        'active': hitem.checked
	      },
	      on: {
	        "click": function($event) {
	          _vm.setTime('hour', hitem, _vm.hours)
	        }
	      }
	    }, [_vm._v(_vm._s(hitem.value))])
	  }))]), _vm._v(" "), _c('div', {
	    staticClass: "min-box"
	  }, [_c('div', {
	    staticClass: "mui-pciker-rule mui-pciker-rule-ft"
	  }), _vm._v(" "), _vm._l((_vm.mins), function(mitem) {
	    return _c('div', {
	      staticClass: "min-item",
	      class: {
	        'active': mitem.checked
	      },
	      on: {
	        "click": function($event) {
	          _vm.setTime('min', mitem, _vm.mins)
	        }
	      }
	    }, [_vm._v(_vm._s(mitem.value))])
	  })], 2)])])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "button-box"
	  }, [_c('span', {
	    on: {
	      "click": function($event) {
	        _vm.showInfo.check = false
	      }
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.cancel : 'Cancel'))]), _vm._v(" "), _c('span', {
	    on: {
	      "click": _vm.picked
	    }
	  }, [_vm._v(_vm._s(_vm.option.buttons ? _vm.option.buttons.ok : 'Ok'))])])])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 553:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "global-answers"
	  }, [_c('div', {
	    staticClass: "head"
	  }, [_c('md-button', {
	    staticClass: "md-raised",
	    class: {
	      active: _vm.showVoteNumbers
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.showVoteNumbers = !_vm.showVoteNumbers
	      }
	    }
	  }, [_vm._v("Válaszadók számának mutatása")])], 1), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
	    return _c('div', {
	      staticClass: "card question"
	    }, [_vm._v("\n\t\tKérdés: " + _vm._s(notification.title)), _c('br'), _vm._v(" "), _c('p', {
	      staticClass: "subtitle"
	    }, [_vm._v(_vm._s(notification.body))]), _vm._v(" "), _c('div', {
	      staticClass: "card"
	    }, _vm._l((notification.options), function(option) {
	      return _c('div', {
	        staticClass: "option"
	      }, [_c('p', [_vm._v(_vm._s(option.title)), (_vm.showVoteNumbers) ? _c('span', [_vm._v(" - " + _vm._s(option.answerCount))]) : _vm._e(), _vm._v(" - " + _vm._s(_vm.notificationPercentage(option, notification)) + "%")]), _vm._v(" "), _c('div', {
	        staticClass: "progress"
	      }, [_c('progressbar', {
	        attrs: {
	          "now": _vm.notificationPercentage(option, notification),
	          "label": "",
	          "type": "primary",
	          "striped": "",
	          "animated": ""
	        }
	      })], 1)])
	    }))])
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 554:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 555:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "editor"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "card"
	  }, [(_vm.type == 'presentation') ? _c('div', [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-8"
	  }, [_c('md-input-container', [_c('label', [_vm._v("Cím")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.title),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "title", $$v)
	      },
	      expression: "form.title"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-md-4"
	  }, [_c('md-checkbox', {
	    model: {
	      value: (_vm.form.isSection),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "isSection", $$v)
	      },
	      expression: "form.isSection"
	    }
	  }, [_vm._v("Szekció")]), _vm._v(" "), (_vm.form.isSection) ? _c('md-checkbox', {
	    model: {
	      value: (_vm.form.displayHours),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "displayHours", $$v)
	      },
	      expression: "form.displayHours"
	    }
	  }, [_vm._v("Óra és perc kijelzése")]) : _vm._e()], 1)]), _vm._v(" "), _c('img', {
	    staticClass: "formImage",
	    attrs: {
	      "src": _vm.form.image
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-xs-12 col-md-8"
	  }, [_c('md-input-container', [_c('label', [_vm._v("Kép (link)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.image),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "image", $$v)
	      },
	      expression: "form.image"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "col-xs-12 col-md-4"
	  }, [_c('input', {
	    attrs: {
	      "type": "file",
	      "accept": "image/*"
	    },
	    on: {
	      "change": _vm.uploadImage
	    }
	  })])]), _vm._v(" "), (_vm.uploading) ? _c('md-progress', {
	    attrs: {
	      "md-indeterminate": true
	    }
	  }) : _vm._e(), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Előadók")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.lecturerNames),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "lecturerNames", $$v)
	      },
	      expression: "form.lecturerNames"
	    }
	  })], 1), _vm._v(" "), _c('p', [_vm._v("\n\t\t\t\t\tAz előadókat vesszővel elválasztva kell felsorolni.\n\t\t\t\t")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Leírás")]), _vm._v(" "), _c('ckeditor', {
	    attrs: {
	      "config": _vm.ckeditor
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'lecturer') ? _c('div', [_c('md-input-container', [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.name),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "name", $$v)
	      },
	      expression: "form.name"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Titulus")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.title),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "title", $$v)
	      },
	      expression: "form.title"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Cég")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.origin),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "origin", $$v)
	      },
	      expression: "form.origin"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Kép (link)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.image),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "image", $$v)
	      },
	      expression: "form.image"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Bemutatkozás")]), _vm._v(" "), _c('ckeditor', {
	    attrs: {
	      "config": _vm.ckeditor
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
	    staticClass: "block dates"
	  }, [_c('h4', [_vm._v("Időpontok")]), _vm._v(" "), _c('date-picker', {
	    staticClass: "date-picker",
	    attrs: {
	      "date": _vm.form.fromDate,
	      "option": _vm.option
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("-tól")]), _vm._v(" "), _c('date-picker', {
	    staticClass: "date-picker",
	    attrs: {
	      "date": _vm.form.toDate,
	      "option": _vm.option
	    }
	  }), _vm._v(" "), _c('span', [_vm._v("-ig")]), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Időtartam (perc)")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.duration),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "duration", $$v)
	      },
	      expression: "form.duration"
	    }
	  })], 1), _vm._v("\n\t\t\t\tA következő új előadás szerkesztésénél az előző előadás időpontjának vége az alapértelmezett kezdő időpont.\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "block attachments"
	  }, [_c('h4', [_vm._v("Csatolmányok, kapcsolati adatok")]), _vm._v(" "), _c('attachment-block', {
	    attrs: {
	      "attachments": _vm.form.attachments
	    }
	  })], 1), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
	    staticClass: "block lecturers"
	  }, [_c('h4', [_vm._v("Szülő szekció")]), _vm._v(" "), _c('md-select', {
	    staticClass: "col-md-12",
	    model: {
	      value: (_vm.form.section),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "section", $$v)
	      },
	      expression: "form.section"
	    }
	  }, _vm._l((_vm.presentations), function(pres) {
	    return _c('md-option', {
	      attrs: {
	        "value": pres.fireId
	      }
	    }, [_vm._v(_vm._s(pres.title))])
	  })), _vm._v("\n\t\t\t\tBármelyik előadás választható egy előadás szekciójaként. A következő új előadás szerkesztésénél az előző előadás szekciója kerül használatra.\n\t\t\t")], 1) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
	    staticClass: "block lecturers"
	  }, [_c('h4', [_vm._v("Előadók")]), _vm._v(" "), _vm._l((_vm.form.lecturers), function(lecturer, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-select', {
	      staticClass: "col-md-10",
	      model: {
	        value: (_vm.form.lecturers[index]),
	        callback: function($$v) {
	          _vm.$set(_vm.form.lecturers, index, $$v)
	        },
	        expression: "form.lecturers[index]"
	      }
	    }, _vm._l((_vm.lecturers), function(lect) {
	      return _c('md-option', {
	        attrs: {
	          "value": lect.value
	        }
	      }, [_vm._v(_vm._s(lect.label))])
	    })), _vm._v(" "), _c('p', {
	      staticClass: "col-md-2"
	    }, [_c('a', {
	      on: {
	        "click": function($event) {
	          _vm.removeLecturer(index)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)])], 1)
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        _vm.form.lecturers.push({})
	      }
	    }
	  }, [_vm._v("Előadó hozzáadása")])], 2) : _vm._e(), _vm._v(" "), (_vm.type == 'presentation') ? _c('div', {
	    staticClass: "block location"
	  }, [_c('h4', [_vm._v("Helyszín")]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', _vm._l((_vm.locations), function(loc) {
	    return _c('md-radio', {
	      attrs: {
	        "md-value": loc.fireId
	      },
	      model: {
	        value: (_vm.form.location.fireId),
	        callback: function($$v) {
	          _vm.$set(_vm.form.location, "fireId", $$v)
	        },
	        expression: "form.location.fireId"
	      }
	    }, [_vm._v(_vm._s(loc.name))])
	  }))])]) : _vm._e(), _vm._v(" "), _c('div', {
	    staticClass: "actions"
	  }, [_c('md-checkbox', {
	    model: {
	      value: (_vm.form.closed),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "closed", $$v)
	      },
	      expression: "form.closed"
	    }
	  }, [_vm._v("Csak cím mutatása")]), _vm._v(" "), _c('md-checkbox', {
	    model: {
	      value: (_vm.form.hidden),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "hidden", $$v)
	      },
	      expression: "form.hidden"
	    }
	  }, [_vm._v("Teljes elrejtés")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-warn",
	    nativeOn: {
	      "click": function($event) {
	        _vm.remove()
	      }
	    }
	  }, [_vm._v("Törlés")]), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised md-accent",
	    nativeOn: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._v("Mentés")])], 1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "head"
	  }, [_c('h3', [_vm._v("Szerkesztő")])])
	}]}

/***/ }),

/***/ 556:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "infromation"
	  }, [_vm._m(0), _vm._v(" "), (!_vm.loading) ? _c('div', {
	    staticClass: "card"
	  }, [_c('div', [_c('md-input-container', [_c('label', [_vm._v("Rendezvény neve")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.form.title),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "title", $$v)
	      },
	      expression: "form.title"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Leírás")]), _vm._v(" "), _c('ckeditor', {
	    attrs: {
	      "config": _vm.ckeditor
	    },
	    model: {
	      value: (_vm.form.description),
	      callback: function($$v) {
	        _vm.$set(_vm.form, "description", $$v)
	      },
	      expression: "form.description"
	    }
	  })], 1)], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('h4', [_vm._v("Kapcsolati adatok")]), _vm._v(" "), _c('attachment-block', {
	    attrs: {
	      "attachments": _vm.form.attachments
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('h4', [_vm._v("Szponzorok")]), _vm._v(" "), _vm._l((_vm.form.sponsors), function(sponsor, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (sponsor.name),
	        callback: function($$v) {
	          _vm.$set(sponsor, "name", $$v)
	        },
	        expression: "sponsor.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Weboldal")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (sponsor.website),
	        callback: function($$v) {
	          _vm.$set(sponsor, "website", $$v)
	        },
	        expression: "sponsor.website"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Kép")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (sponsor.image),
	        callback: function($$v) {
	          _vm.$set(sponsor, "image", $$v)
	        },
	        expression: "sponsor.image"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Kategória")]), _vm._v(" "), _c('md-select', {
	      model: {
	        value: (_vm.form.sponsors[index].category),
	        callback: function($$v) {
	          _vm.$set(_vm.form.sponsors[index], "category", $$v)
	        },
	        expression: "form.sponsors[index].category"
	      }
	    }, _vm._l((_vm.sponsorCategories), function(sponsorCategory) {
	      return _c('md-option', {
	        attrs: {
	          "value": sponsorCategory.value
	        }
	      }, [_vm._v(_vm._s(sponsorCategory.label))])
	    }))], 1), _vm._v(" "), _c('a', {
	      staticClass: "col-md-1",
	      on: {
	        "click": function($event) {
	          _vm.removeStuff('sponsors', sponsor)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1)], 1)
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.newSponsor($event)
	      }
	    }
	  }, [_vm._v("Szponzor hozzáadása")])], 2), _vm._v(" "), _c('div', {
	    staticClass: "block"
	  }, [_c('h4', [_vm._v("Helyszínek")]), _vm._v(" "), _vm._l((_vm.locations), function(location, index) {
	    return _c('div', {
	      staticClass: "row"
	    }, [_c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Név")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (location.name),
	        callback: function($$v) {
	          _vm.$set(location, "name", $$v)
	        },
	        expression: "location.name"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-2"
	    }, [_c('label', [_vm._v("Hosszúság")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (location.latitude),
	        callback: function($$v) {
	          _vm.$set(location, "latitude", $$v)
	        },
	        expression: "location.latitude"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-2"
	    }, [_c('label', [_vm._v("Szélesség")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (location.longitude),
	        callback: function($$v) {
	          _vm.$set(location, "longitude", $$v)
	        },
	        expression: "location.longitude"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', {
	      staticClass: "col-md-3"
	    }, [_c('label', [_vm._v("Cím")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (location.address),
	        callback: function($$v) {
	          _vm.$set(location, "address", $$v)
	        },
	        expression: "location.address"
	      }
	    })], 1), _vm._v(" "), _c('a', {
	      staticClass: "col-md-1",
	      on: {
	        "click": function($event) {
	          _vm.removeLocation(location, index)
	        }
	      }
	    }, [_c('md-icon', [_vm._v("remove_circle_outline")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-12 row"
	    }, [_c('a', {
	      staticClass: "col-md-2",
	      on: {
	        "click": function($event) {
	          _vm.loadCoords(location)
	        }
	      }
	    }, [_vm._v("Koordináták kitöltése")]), _vm._v(" "), _c('a', {
	      staticClass: "col-md-2",
	      attrs: {
	        "href": 'https://www.google.com/maps/?q=' + location.latitude + ',' + location.longitude,
	        "target": "_blank"
	      }
	    }, [_vm._v("Megtekintés térképen")])])], 1)
	  }), _vm._v(" "), _c('md-button', {
	    staticClass: "md-primary",
	    nativeOn: {
	      "click": function($event) {
	        return _vm.newLocation($event)
	      }
	    }
	  }, [_vm._v("Helyszín hozzáadása")])], 2), _vm._v(" "), _c('md-button', {
	    staticClass: "md-accent",
	    nativeOn: {
	      "click": function($event) {
	        _vm.save()
	      }
	    }
	  }, [_vm._v("Mentés")])], 1) : _vm._e()])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "head"
	  }, [_c('h3', [_vm._v("Szerkesztő")])])
	}]}

/***/ }),

/***/ 557:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "admin"
	  }, [_c('h1', [_vm._v(_vm._s(_vm.getAppName()))]), _vm._v(" "), _c('md-bottom-bar', [_c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "announcement",
	      "md-active": _vm.ifRoute('admin-notifications')
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.goToRoute('admin-notifications')
	      }
	    }
	  }, [_vm._v("Értesítések")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "speaker_notes",
	      "md-active": _vm.ifRoute('admin-answers')
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.goToRoute('admin-answers')
	      }
	    }
	  }, [_vm._v("Válaszok")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "event",
	      "md-active": _vm.ifRoute('admin-presentations')
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.goToRoute('admin-presentations')
	      }
	    }
	  }, [_vm._v("Napirend")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "face",
	      "md-active": _vm.ifRoute('admin-lecturers')
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.goToRoute('admin-lecturers')
	      }
	    }
	  }, [_vm._v("Előadók")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "info_outline",
	      "md-active": _vm.ifRoute('admin-information')
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.goToRoute('admin-information')
	      }
	    }
	  }, [_vm._v("Információk")]), _vm._v(" "), _c('md-bottom-bar-item', {
	    attrs: {
	      "md-icon": "cancel"
	    },
	    nativeOn: {
	      "click": function($event) {
	        _vm.logout()
	      }
	    }
	  }, [_vm._v("Kijelentkezés")])], 1), _vm._v(" "), _c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 558:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "login"
	  }, [_c('h1', [_vm._v("Bejelentkezés")]), _vm._v(" "), _c('h3', [_vm._v("\n\t\tAdminisztrációs felület\n\t")]), _vm._v(" "), _c('form', {
	    staticClass: "card login-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        _vm.login()
	      }
	    }
	  }, [_c('md-input-container', [_c('label', [_vm._v("Projekt")]), _vm._v(" "), _c('md-select', {
	    model: {
	      value: (_vm.project),
	      callback: function($$v) {
	        _vm.project = $$v
	      },
	      expression: "project"
	    }
	  }, _vm._l((_vm.firebaseConfig), function(item, key) {
	    return _c('md-option', {
	      attrs: {
	        "value": key
	      }
	    }, [_vm._v(_vm._s(key))])
	  }))], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("E-mail cím")]), _vm._v(" "), _c('md-input', {
	    model: {
	      value: (_vm.email),
	      callback: function($$v) {
	        _vm.email = $$v
	      },
	      expression: "email"
	    }
	  })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Jelszó")]), _vm._v(" "), _c('md-input', {
	    attrs: {
	      "type": "password"
	    },
	    model: {
	      value: (_vm.password),
	      callback: function($$v) {
	        _vm.password = $$v
	      },
	      expression: "password"
	    }
	  })], 1), _vm._v(" "), _c('md-button', {
	    staticClass: "md-raised",
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Bejelentkezés")]), _vm._v(" "), (_vm.errorCode === 'auth/invalid-email') ? _c('div', [_c('b', [_vm._v("Hibás e-mail cím")])]) : _vm._e(), _vm._v(" "), (_vm.errorCode === 'auth/user-not-found') ? _c('div', [_c('b', [_vm._v("Felhasználó nem található")])]) : _vm._e(), _vm._v(" "), (_vm.errorCode === 'auth/wrong-password') ? _c('div', [_c('b', [_vm._v("Hibás jelszó")])]) : _vm._e()], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 559:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "notifications"
	  }, [_c('div', {
	    staticClass: "head"
	  }, [_c('md-button', {
	    staticClass: "md-raised",
	    nativeOn: {
	      "click": function($event) {
	        _vm.createNotification()
	      }
	    }
	  }, [_vm._v("Új értesítés létrehozása")])], 1), _vm._v(" "), (_vm.notifications.length <= 0) ? _c('div', {
	    staticStyle: {
	      "text-align": "center",
	      "color": "white",
	      "font-size": "20px"
	    }
	  }, [_vm._v("\n\t\t\t..Betöltés..\n\t\t")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.notifications), function(notification) {
	    return _c('div', {
	      staticClass: "card"
	    }, [_c('md-input-container', [_c('label', [_vm._v("Értesítés címe")]), _vm._v(" "), _c('md-input', {
	      model: {
	        value: (notification.title),
	        callback: function($$v) {
	          _vm.$set(notification, "title", $$v)
	        },
	        expression: "notification.title"
	      }
	    })], 1), _vm._v(" "), _c('md-input-container', [_c('label', [_vm._v("Értesítés szövege")]), _vm._v(" "), _c('md-textarea', {
	      model: {
	        value: (notification.body),
	        callback: function($$v) {
	          _vm.$set(notification, "body", $$v)
	        },
	        expression: "notification.body"
	      }
	    })], 1), _vm._v(" "), (notification.options) ? _c('section', {
	      staticClass: "card options"
	    }, [_c('span', {
	      staticClass: "subtitle"
	    }, [_vm._v("Válaszlehetőségek")]), _vm._v(" "), _vm._l((notification.options), function(option) {
	      return _c('div', [_c('md-input-container', [_c('label', [_vm._v("Válasz")]), _vm._v(" "), _c('md-input', {
	        model: {
	          value: (option.title),
	          callback: function($$v) {
	            _vm.$set(option, "title", $$v)
	          },
	          expression: "option.title"
	        }
	      })], 1)], 1)
	    })], 2) : _vm._e(), _vm._v(" "), _c('div', {
	      staticClass: "block actions row"
	    }, [_c('div', {
	      staticClass: "col-md-12 end-md"
	    }, [_vm._v("\n\t\t\t\tÉrvényes: "), _c('date-picker', {
	      staticClass: "date-picker",
	      attrs: {
	        "date": notification.targetDate,
	        "option": _vm.option,
	        "limit": _vm.limit
	      }
	    }), _vm._v(" "), _c('md-checkbox', {
	      model: {
	        value: (notification.published),
	        callback: function($$v) {
	          _vm.$set(notification, "published", $$v)
	        },
	        expression: "notification.published"
	      }
	    }, [_vm._v("Publikálva")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-2 start-md"
	    }, [_c('md-button', {
	      staticClass: "md-warn",
	      nativeOn: {
	        "click": function($event) {
	          _vm.deleteNotification(notification)
	        }
	      }
	    }, [_vm._v("Törlés")])], 1), _vm._v(" "), _c('div', {
	      staticClass: "col-md-10 end-md"
	    }, [_c('md-button', {
	      staticClass: "md-accent",
	      nativeOn: {
	        "click": function($event) {
	          _vm.pushNotification(notification)
	        }
	      }
	    }, [_vm._v("Push értesítés küldése")]), _vm._v(" "), _c('md-button', {
	      staticClass: "md-accent",
	      nativeOn: {
	        "click": function($event) {
	          _vm.addOption(notification)
	        }
	      }
	    }, [_vm._v("Válaszlehetőség hozzáadása")]), _vm._v(" "), _c('md-button', {
	      staticClass: "md-primary",
	      nativeOn: {
	        "click": function($event) {
	          _vm.saveNotification(notification)
	        }
	      }
	    }, [_vm._v("Mentés")])], 1)])], 1)
	  })], 2)
	},staticRenderFns: []}

/***/ }),

/***/ 560:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "floorplan"
	  }, [_c('div', {
	    staticClass: "bg"
	  }), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": __webpack_require__(528),
	      "usemap": "#image-map"
	    }
	  }), _vm._v(" "), _c('map', {
	    attrs: {
	      "name": "image-map",
	      "id": "image-map"
	    }
	  }, [_c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "96,501,207,573",
	      "shape": "rect"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 1)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "260,480,348,551",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 2)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "353,481,440,547",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 3)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "416,208,485,357",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 4)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "492,184,556,246",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 5)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "556,317,490,258",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 6)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "492,330,556,394",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 7)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "629,179,703,242",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 8)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "622,258,701,319",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 9)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "622,328,701,391",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 10)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "704,486,735,552",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 12)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "994,430,1023,491",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 13)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1111,308,1165,349",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 16)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1327,200,1440,333",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 18)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1240,375,1325,459",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 19)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1457,308,1523,351",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 20)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1623,423,1683,454",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 22)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1361,399,1428,441",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 23)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1034,741,1166,816",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 24)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1173,741,1247,818",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 25)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1255,742,1330,815",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 26)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1346,737,1433,820",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 27)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1082,855,1166,916",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 28)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1176,850,1232,919",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 29)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1276,852,1332,924",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 30)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1345,850,1396,921",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 31)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1503,908,1586,989",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 32)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1588,910,1668,987",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 33)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "1673,908,1733,985",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 34)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "279,1127,348,1175",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 35)
	      }
	    }
	  }), _vm._v(" "), _c('area', {
	    attrs: {
	      "target": "",
	      "alt": "",
	      "title": "",
	      "href": "#",
	      "coords": "421,1029,489,1077",
	      "shape": "0"
	    },
	    on: {
	      "click": function($event) {
	        _vm.areaSelected($event, 36)
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "tooltip",
	    attrs: {
	      "id": "tooltip"
	    }
	  }, [(_vm.selectedSponsor) ? _c('div', [_vm._v("\n\t\t\t" + _vm._s(_vm.selectedSponsor.company) + "\n\t\t\t"), _c('a', {
	    attrs: {
	      "href": _vm.selectedSponsor.website
	    }
	  }, [_c('span', {
	    staticClass: "picker-button"
	  }, [_vm._v("Weboldal megnyitása")])])]) : _c('div', [_vm._v("\n\t\t\tNincs kiállító\n\t\t")]), _vm._v(" "), _c('i', {
	    staticClass: "arrow down"
	  })])])
	},staticRenderFns: []}

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 569:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 570:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 571:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ }),

/***/ 572:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.ae34e2e19594786d10fb.js